import '../../app-configuration/app-configuration.js';
import { KatapultPageElement, html } from '../../mixins/katapult-page-element.js';
import { mixinBehaviors } from '@polymer/polymer/lib/legacy/class.js';
import { DefaultComputedBindings } from '../../modules/DefaultComputedBindings.js';

import { html as litHtml } from 'lit';
import { showToast } from '../../modules/ShowShoelaceToast.js';

import { Debouncer } from '@polymer/polymer/lib/utils/debounce.js';
import { timeOut } from '@polymer/polymer/lib/utils/async.js';

import '@polymer/polymer/lib/mixins/gesture-event-listeners.js';
import '@polymer/iron-icons/iron-icons.js';
import '@polymer/iron-icons/device-icons.js';
import '@polymer/iron-icons/maps-icons.js';
import '@polymer/iron-icons/image-icons.js';
import '@polymer/iron-icons/av-icons.js';
import '@polymer/iron-icons/communication-icons.js';
import '@polymer/iron-icons/notification-icons.js';
import '@polymer/iron-icons/social-icons.js';
import '@polymer/iron-meta/iron-meta.js';
import '@polymer/iron-selector/iron-selector.js';
import '@polymer/iron-collapse/iron-collapse.js';
import '@polymer/paper-item/paper-item.js';
import '@polymer/paper-spinner/paper-spinner.js';
import '@polymer/paper-input/paper-input.js';
import '@polymer/paper-input/paper-textarea.js';
import '@polymer/paper-styles/paper-styles-classes.js';
import '@polymer/paper-toast/paper-toast.js';
import '@polymer/paper-toggle-button/paper-toggle-button.js';
import '@polymer/paper-dialog/paper-dialog.js';
import '@polymer/paper-dialog-scrollable/paper-dialog-scrollable.js';
import '@polymer/paper-radio-group/paper-radio-group.js';
import '@polymer/paper-radio-button/paper-radio-button.js';
import '@polymer/paper-menu-button/paper-menu-button.js';
import '@shoelace-style/shoelace/dist/components/alert/alert.js';
import '../google-map/google-map-elements.js';
import '../google-map/google-map-svg-text-marker.js';
import '../wms-layers/wms-layers.js';
import { getMapBaseConfigFromLegacyMapTypeId } from '../../features/layers/map-base-services.js';
import { KatapultGeometry } from 'katapult-toolbox';
import '../katapult-auth/katapult-auth.js';
import '../model-loader/model-loader.js';
import '../katapult-maps-desktop/load-render-map.js';
import { createSuperZoomOverlay } from '../katapult-maps-desktop/layers/SuperZoomOverlay.js';
import { createCustomImageOverlay } from '../katapult-maps-desktop/layers/CustomImageOverlay.js';
import '../api-map-layer/api-map-layer.js';
import '../katapult-drop-down/katapult-drop-down.js';
import '../katapult-map-icons/katapult-map-icons.js';
import '../katapult-elements/katapult-button.js';
import { ToArray } from '../../modules/ToArray.js';
import { CamelCase } from '../../modules/CamelCase.js';
import { ModelDefaults } from '../../modules/ModelDefaults.js';
import { KLogic } from '../../modules/KLogic.js';
import { GeoStyleToIcon, GetIconSize } from '../../modules/GeoStyleToIcon.js';
import './job-time-collection.js';
import './navigate-to-location.js';
import './add-section.js';
import './time-sync.js';
import './draw-on-map.js';
import './select-ref-layer.js';
import './edit-attributes.js';
import './assess-attributes.js';
import './move-item.js';
import './mobile-compass.js';
import './mobile-web-tool.js';
import randomColor from '../../modules/_deprecated/RandomColor.js';
import '../release-notes-dialog/release-notes-dialog.js';
import '../login-chip/login-chip.js';
import '../connection-state-icon/connection-state-icon.js';
import '../style-modules/paper-dialog-style.js';
import '../style-modules/paper-menu-button-style.js';
import { GeoFire } from 'geofire';
import { addListener, setTouchAction } from '@polymer/polymer/lib/utils/gestures.js';
import { dom } from '@polymer/polymer/lib/legacy/polymer.dom.js';
import { SquashNulls } from '../../modules/SquashNulls.js';
import { BlackOrWhite } from '../../modules/BlackOrWhite.js';
import { Path } from '../../modules/Path.js';
import { PickAnAttribute } from '../../modules/PickAnAttribute.js';
import { ToTitleCase } from '../../modules/ToTitleCase.js';
import { Round } from '../../modules/Round.js';
import { Clamp } from '../../modules/Clamp.js';
import { Throttle } from '../../modules/Throttle.js';
import { AttributeToString } from '../../modules/AttributeToString.js';
import '../katapult-elements/katapult-button.js';
import '../katapult-toolbar/version-selector-button.js';
import { KatapultDialog } from '../katapult-elements/katapult-dialog.js';
import { addFlagListener, removeFlagListener } from '../../modules/FeatureFlags.js';
import '../katapult-maps-desktop/map-layers-menu-view.js';
import { initializeServiceWorker } from './InitializeServiceWorker.js';
import { CompanyHasAccessToUtilityLayer } from '../../modules/UtilityDataLayer.js';
import { KatapultModel } from '../../modules/katapult-model/KatapultModel.js';
import '../replace-action-dialog/replace-action-dialog.js';
import {
  listenToUploadEventsForJob,
  uploadQueuedJobPhotos,
  uploadPhoto,
  refreshPhotoUploadProgress
} from './PhotoUpload/PhotoUploadService.js';
import { showPhotoUploadErrorToast } from './PhotoUpload/showPhotoUploadErrorToast.js';
import firebase from 'firebase/compat/app';
import 'firebase/compat/database';
import { OfflineManagement } from './offline-management.js';
import { getTransferLocking } from '../../modules/TransferLocking.js';
import { KatapultJob } from '../../modules/katapult-job/KatapultJob.js';
import { showLockedJobDialog } from '../katapult-maps-desktop/locked-job-dialog.js';
import posthog from 'posthog-js';
import { StyleRuleToIcon } from '../../modules/StyleRuleToIcon.js';
import '@shoelace-style/shoelace/dist/components/progress-bar/progress-bar.js';
import '@shoelace-style/shoelace/dist/components/spinner/spinner.js';
import { getFile } from './OPFSStore.js';
import { checkIsDevelopmentOrigin, getVersionNameFromOrigin } from '../../modules/CheckOrigin.js';
import { Parallel } from '../../modules/Parallel.js';

/**
 * @typedef ClosestItem
 * @property {string} item - the ID of the closest item prepended with a character to denote its type
 * @property {number} distance - the distance from the eye dropper to the closest item
 */

const WAIT_TIME_FOR_SERVICE_WORKER_INSTALL = 30;

class KatapultMapsMobile extends mixinBehaviors([DefaultComputedBindings], KatapultPageElement) {
  static get template() {
    return html`
      <style include="paper-dialog-style paper-menu-button-style">
        :host {
          display: block;
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
          width: 100%;
          height: 100%;
          overflow: hidden;
          --primary-color: #003e51;
          --katapult-dark-blue-3-shades-darker: #002b38;
        }
        [hidden] {
          display: none !important;
        }
        #main {
          outline: none;
          height: 100%;
          position: relative;
          transition: all 0.3s;
          min-height: 0;
          flex-grow: 1;
        }
        #mainVertContainer {
          display: flex;
          height: 100%;
          width: 100%;
          flex-direction: column;
        }
        #confirmDialog {
          width: 90%;
          max-width: 350px;
        }
        .menuDrawerIcon {
          margin-right: 0.5em;
        }
        .menuDrawer {
          margin-left: 1.5em;
        }
        .menuDrawerItem {
          padding: 10px;
          display: flex;
          align-items: center;
        }
        .submenuButton {
          flex: 1;
          height: 32px;
          margin: 5px 10px;
          text-transform: capitalize;
          background-color: var(--paper-grey-200);
        }
        .legendItem {
          display: flex;
        }
        .legendIconContainer {
          display: flex;
          margin-right: 8px;
          justify-content: center;
          align-items: center;
          position: relative;
          text-align: center;
          width: 24px;
          height: 24px;
        }
        .contextInfoLink {
          margin: 3px;
        }
        .contextInfoItem {
          margin-top: 2px;
        }
        .contextInfoTitle {
          font-style: italic;
        }
        #activeToolChooser {
          position: fixed;
          display: flex;
          flex-direction: column;
          top: 0;
          left: 0;
          height: 100%;
          width: 100%;
          background-color: white;
          z-index: 100;
          text-align: center;
          background-color: #fafafa;
          transition: all 0.3s;
          opacity: 0;
          transform: translateY(12px);
          pointer-events: none;
          padding: 8px;
          box-sizing: border-box;
        }
        #activeToolChooser[opened=''] {
          transform: translateY(0);
          opacity: 1;
          pointer-events: auto;
        }
        #activeToolChooser > h2 {
          flex-grow: 0;
          flex-shrink: 0;
        }
        #activeToolChooser > div {
          display: flex;
          flex-flow: wrap;
          justify-content: center;
          overflow-y: auto;
        }
        #activeToolChooser > #closeToolChooser {
          position: absolute;
          top: 12px;
          right: 12px;
        }
        .toolIcon {
          position: relative;
          height: 64px;
          width: 64px;
          margin: 8px;
          padding: 4px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          overflow: hidden;
          box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
          border-radius: 8px;
          background-color: white;
          transition: all 0.1s;
          box-sizing: border-box;
          border: none;
          user-select: none;
          -webkit-user-select: none; /* Safari */
        }
        .toolIcon[editing][favorite] {
          border: 4px solid var(--secondary-color);
        }
        .toolIcon > iron-icon {
          align-self: center;
          height: 36px;
          width: 36px;
          margin-bottom: 4px;
        }
        .toolIcon > span {
          font-size: 7pt;
          color: #888;
          text-overflow: ellipsis;
          overflow: hidden;
          text-align: center;
          white-space: nowrap;
          text-transform: uppercase;
        }
        #waterDrop,
        #crosshair {
          position: absolute;
          top: 50%;
          left: 50%;
          z-index: 2;
          color: white;
          width: 50px;
          height: 50px;
          margin-top: -45px;
          margin-left: -25px;
          border-radius: 50px;
          user-select: none;
          -webkit-user-select: none; /* Safari */
        }
        #crosshair {
          position: absolute;
          top: 50%;
          left: 50%;
          z-index: 2;
          color: black;
          margin-top: -12px;
          margin-left: -12px;
        }
        #waterDrop iron-icon {
          width: 100%;
          height: 100%;
        }
        #waterDropFill {
          position: absolute;
          top: 50%;
          left: 50%;
          z-index: 2;
          color: white;
          width: 20px;
          height: 20px;
          margin-top: -36px;
          margin-left: -10px;
          pointer-events: none;
        }
        #waterDropIcon {
          position: absolute;
          top: 50%;
          left: 50%;
          z-index: 2;
          color: black;
          width: 20px;
          height: 20px;
          margin-top: -36px;
          margin-left: -10px;
          pointer-events: none;
        }
        #topBar {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          z-index: 2;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 12px;
          box-sizing: border-box;
        }
        #mapContainer {
          height: 100%;
          display: flex;
          flex-direction: column;
          background-color: var(--primary-color);
        }
        #bottomBar {
          position: absolute;
          bottom: 0px;
          padding: 8px;
          box-sizing: border-box;
          width: 100%;
          z-index: 98;
          pointer-events: none;
        }
        #bottomBar > div {
          opacity: 0;
          transition: all 0.3s;
          overflow: hidden;
          padding: 8px 0;
          margin-bottom: -16px;
          pointer-events: none;
          visibility: hidden;
        }
        #bottomBar > div[opened=''] {
          opacity: 1;
          margin-bottom: 0;
          pointer-events: auto;
          visibility: visible;
        }
        #actionButtonsContainer {
          display: flex;
        }
        #promptButton {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-grow: 2;
          vertical-align: top;
          background: yellow;
          width: 230px;
          height: 50px;
          margin: 4px;
          @apply --shadow-elevation-2dp;
          white-space: nowrap;
        }
        #promptButton.jobTimeCollection[disabled] {
          background-color: #b55d01 !important;
        }
        #secondaryPromptButton {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-grow: 1;
          vertical-align: top;
          background: white;
          height: 50px;
          margin: 4px;
          @apply --shadow-elevation-2dp;
          white-space: nowrap;
        }
        #tertiaryPromptButton {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-grow: 1;
          vertical-align: top;
          --katapult-button-background: white;
          height: 50px;
          margin: 4px;
          @apply --shadow-elevation-2dp;
          white-space: nowrap;
        }
        katapult-button > iron-icon {
          margin: 0;
        }
        paper-spinner {
          --paper-spinner-layer-1-color: var(--primary-color);
          --paper-spinner-layer-2-color: var(--primary-color);
          --paper-spinner-layer-3-color: var(--primary-color);
          --paper-spinner-layer-4-color: var(--primary-color);
        }
        #googlemap {
          transition: height 0.3s;
          display: flex;
          flex-grow: 100;
        }
        .warning {
          color: #d23f31;
        }
        #collectionButton {
          background-color: white;
          @apply --shadow-elevation-2dp;
          font-size: 10pt;
        }
        #collectionButtonStatus {
          padding: 4px;
          margin: 4px;
          border-radius: 100%;
          background-color: var(--paper-green-500);
        }
        #collectionButtonStatus[active=''] {
          background-color: var(--paper-red-500);
        }
        .expanded {
          opacity: 1;
          transform: scale(1);
        }
        .collapsed {
          opacity: 0;
          transform: scale(0);
        }
        .promptIcon {
          margin: 3px 10px 0 0;
        }

        #numCollectedContainer {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 0px;
          left: 8px;
          padding: 10px;
          min-height: 20px;
          min-width: 52px;
          box-sizing: border-box;
          background-color: var(--paper-red-500);
          color: white;
          z-index: 1;
          border-radius: 24px;
          font-size: 12pt;
          transition: top 0.3s;
          @apply --shadow-elevation-2dp;
          user-select: none;
          -webkit-user-select: none; /* Safari */
        }
        #numCollectedContainer.done {
          background-color: var(--paper-green-500);
          color: var(--primary-text-color);
        }
        #poleCount {
          display: flex;
          white-space: nowrap;
          align-items: center;
          border-radius: 80px;
          background-color: var(--paper-red-500);
          color: white;
          padding: 10px;
          justify-content: center;
          font-size: 11pt;
          background-color: var(--paper-red-500);
        }
        #poleCount.done {
          background-color: var(--paper-green-500);
          color: var(--primary-text-color);
        }
        #toast {
          background-color: white;
          @apply --shadow-elevation-2dp;
          margin: 0 8px;
          border-radius: 16px;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 12px;
          min-height: 48px;
          box-sizing: border-box;
        }
        #readOnlyBanner {
          background-color: #ffca28;
          @apply --shadow-elevation-2dp;
          margin: 0 8px;
          border-radius: 24px;
          display: none;
          align-items: center;
          justify-content: center;
          padding: 12px;
          min-height: 48px;
          box-sizing: border-box;
        }
        div[opened=''] #readOnlyBanner {
          display: flex;
        }
        #sidePanel {
          position: absolute;
          top: 0;
          left: 0;
          height: 100%;
          width: 320px;
          max-width: 100%;
          background-color: white;
          z-index: 99;
          left: -100%;
          @apply --shadow-elevation-2dp;
        }
        #sidePanelScroll {
          height: inherit;
          box-sizing: border-box;
          overflow-y: auto;
          padding: 12px;
          display: flex;
          flex-direction: column;
        }
        #sidePanelScroll::-webkit-scrollbar {
          background-color: white;
        }
        #sidePanelScroll::-webkit-scrollbar-thumb {
          background-color: rgba(50, 50, 50, 0.5);
          border: 3px solid transparent;
          border-radius: 9px;
        }
        #sidePanel:not([dragging]) {
          transition: left 0.3s;
        }
        #sidePanelScroll > * {
          flex-shrink: 0;
        }
        #sidePanel[opened=''] {
          left: 0;
        }
        #sidePanelTopButtonsContainer {
          border-radius: 999px;
          background-color: var(--paper-grey-200);
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 8px;
          margin-top: 5px;
        }
        #sidePanelTopButtonsContainer paper-menu-button {
          padding: 0;
        }
        #sidePanelTopButtonsContainer login-chip {
          --user-chip-profile: {
            width: 24px;
            height: 24px;
            margin: 4px;
          };
        }
        #jobCooserContainer {
          height: 48px;
          margin: 8px 0;
        }
        h2 {
          font-weight: normal;
          text-transform: uppercase;
          font-size: 15pt;
          color: var(--primary-text-color-faded);
        }
        paper-item {
          border-radius: 999px;
          padding: 0 8px;
          box-sizing: border-box;
          overflow: hidden;
          user-select: none;
          -webkit-user-select: none; /* Safari */
        }
        #sidePanelRows {
          padding: 10px 0;
        }
        #sidePanelRows paper-item {
          margin: 2px 0;
        }
        #appsDrawer {
          display: flex;
          justify-content: center;
          align-items: center;
          flex-wrap: wrap;
          padding: 0px;
          max-width: 240px;
        }
        #appsDrawer a {
          color: black;
          text-decoration: none;
          text-transform: capitalize;
        }
        .pageIcon {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 4px;
          width: 70px;
          height: 70px;
          font-size: 14px;
          cursor: pointer;
          border-radius: 100%;
          text-align: center;
        }
        .pageIcon iron-icon {
          width: 30px;
          height: 30px;
          margin-bottom: 5px;
        }
        [slot='dropdown-content'] {
          padding: 24px;
        }
        #sideButtonContainer {
          position: absolute;
          left: 12px;
          top: 64px;
          display: flex;
          flex-direction: column;
          gap: var(--sl-spacing-small);
        }
        #zoomControls {
          display: flex;
          flex-direction: column;
          border-radius: 48px;
          z-index: 1;
          background-color: white;
          color: var(--primary-text-color-faded);
          @apply --shadow-elevation-2dp;
        }
        #mapOverlayCompass {
          z-index: 1;
          --width: 40px;
          --height: 40px;
          --box-shadow: 0 2px 2px rgba(0, 0, 0, 0.2);
        }
        #gpsButton {
          border-radius: var(--sl-border-radius-circle);
          z-index: 1;
          background-color: var(--sl-color-neutral-0);
          color: var(--primary-text-color-faded);
        }
        #favoriteToolsMenu {
          background-color: white;
          display: flex;
          flex-direction: column;
          border-radius: 24px;
          overflow: hidden;
        }
        #favoriteToolsMenu katapult-button {
          border-radius: 50%;
          border: none;
          height: 40px;
          width: 40px;
        }
        #favoriteToolsCollapse {
          display: flex;
          width: 40px;
          flex-direction: column;
          overflow-y: auto;
        }
        #favoriteToolsCollapse::-webkit-scrollbar {
          /* hide scrollbar */
          display: none;
        }
        #bugFeedbackDialog paper-input,
        #bugFeedbackDialog paper-textarea {
          --paper-input-container-focus-color: var(--secondary-color);
        }
        #bugFeedbackDialog paper-checkbox {
          --paper-checkbox-unchecked-color: var(--primary-text-color-faded);
          --paper-checkbox-checked-color: var(--secondary-color);
        }
        .log {
          width: 100%;
          display: flex;
          padding: 5px 0;
          border-bottom: 1px solid #eee;
        }
        .log.warn {
          background-color: #fffbe5;
          color: #5c3c00;
        }
        .log.error {
          background-color: #fff0f0;
          color: #eb3941;
        }
        #refSelectDialog {
          min-width: 325px;
          max-width: 500px;
          padding-bottom: 15px;
        }
        #addJobLayerDialog {
          min-width: 325px;
          max-width: 500px;
        }
        #labelsDialog {
          min-width: 325px;
          max-width: 500px;
        }
        #newVersionTag {
          position: absolute;
          top: 8px;
          left: 40px;
          background-color: var(--secondary-color);
          border: 1px solid white;
          color: white;
          padding: 2px 6px;
          border-radius: 16px;
          font-size: 12px;
          font-weight: bold;
          pointer-events: none;
        }
        #fullscreenPhoto {
          position: absolute;
          top: 0;
          left: 0;
          height: 100%;
          width: 100%;
          z-index: 999;
          background: white;
        }
        #fullscreenPhoto:not([opened]) {
          display: none;
        }
        #fullscreenPhotoViewer {
          height: 100%;
          width: 100%;
        }
        .update-available-badge {
          position: absolute;
          top: -5px;
          right: -5px;
          pointer-events: none;
        }
        .software-details {
          border-top: 1px solid var(--paper-grey-400);
          display: flex;
          flex-direction: column;
          font-size: 10pt;
          gap: 4px;
          padding-top: 16px;
        }
        .software-details p {
          margin: 0;
        }
        #photoUploadProgressDialog {
          display: flex;
          width: 100%;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding: 12px;
          background-color: white;
          pointer-events: all;
          transition: all 0.3s;
          margin-top: -45px;
          @apply --shadow-elevation-4dp;
        }
        #photoUploadProgressDialog > div {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          box-sizing: border-box;
        }
        #photoUploadProgressDialog[opened] {
          margin-top: 0 !important;
        }
        #photoUploadProgressTitle {
          position: relative;
          text-transform: uppercase;
          color: var(--primary-text-color-faded);
          padding: 0 48px;
          white-space: nowrap;
        }
        .serviceWorkerStatusMessage {
          display: flex;
          flex-direction: row;
          gap: var(--sl-spacing-small);
          align-items: center;
          justify-content: center;
        }
        #katapultProInitializingOverlay {
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          gap: 70px;
          position: absolute;
          top: 0px;
          left: 0px;
          background-color: rgba(255, 255, 255, 0.9);
          width: -webkit-fill-available;
          height: -webkit-fill-available;
          z-index: 1000;
          font-size: 30px;
          padding: var(--sl-spacing-large);
          backdrop-filter: blur(4px);
        }
        #serviceWorkerOptionsBar {
          position: absolute;
          bottom: 0px;
          padding: var(--sl-spacing-large);
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          width: -webkit-fill-available;
        }
        .serviceWorkerOverlayPart {
          display: flex;
          align-items: center;
          gap: var(--sl-spacing-small);
          flex-direction: column;
        }
      </style>
      <div id="fullscreenPhoto">
        <div
          style="position: absolute; left: 0; bottom: 0; width: 100%; padding: 16px; z-index: 99; display: flex; box-sizing: border-box;"
        >
          <katapult-button style="flex-grow: 1;" color="white" on-click="closeFullscreenPhoto">Close</katapult-button>
        </div>
        <katapult-photo-viewer
          id="fullscreenPhotoViewer"
          user-group="[[userGroup]]"
          load-data=""
          disabled="[[disabled]]"
          published=""
          job-id="[[jobid]]"
          style="margin-right:0.5em;"
          no-fit=""
          on-reload-urls="reloadJobUrls"
          input-models="[[inputModels]]"
          annotations=""
          zoom=""
          other-attributes="[[otherAttributes]]"
          show-warnings
        ></katapult-photo-viewer>
      </div>
      <model-loader
        company-id="[[jobCreator]]"
        items='["config/defaults", "attributes", "mapping_buttons", "button_groups", "input_models", "config/mobile", "drawing_disallowed_attachments", "collection_order_logic/dcs"]'
        other-attributes="{{otherAttributes}}"
        config-defaults="{{configDefaults}}"
        mapping-buttons="{{mappingButtons}}"
        button-groups="{{buttonGroups}}"
        config-mobile="{{modelConfig}}"
        input-models="{{inputModels}}"
        drawing-disallowed-attachments="{{disallowedAttachments}}"
        collection-order-logic-dcs="{{firebaseCollectionOrderLogic}}"
        user-group="[[userGroup]]"
      >
      </model-loader>
      <katapult-firebase-worker
        id="jobName"
        path="photoheight/jobs/[[jobid]]/name"
        data="{{jobName}}"
        disabled="[[!signedIn]]"
      ></katapult-firebase-worker>
      <katapult-firebase-worker
        id="nodes"
        path="photoheight/jobs/[[jobid]]/nodes"
        data="{{nodes}}"
        disabled="[[!signedIn]]"
      ></katapult-firebase-worker>
      <katapult-firebase-worker
        id="connections"
        path="photoheight/jobs/[[jobid]]/connections"
        data="{{connections}}"
        disabled="[[!signedIn]]"
      ></katapult-firebase-worker>
      <!-- This keeps a non-query on listener active for geohash so that geohash data gets stored in the database -->
      <katapult-firebase-worker
        id="geohash"
        path="photoheight/jobs/[[jobid]]/geohash"
        data="{{geohash}}"
        disabled="[[!signedIn]]"
      ></katapult-firebase-worker>
      <katapult-firebase-worker
        id="jobCreatorID"
        path="photoheight/jobs/[[jobid]]/job_creator"
        data="{{jobCreator}}"
        disabled="[[!signedIn]]"
      ></katapult-firebase-worker>
      <katapult-firebase-worker
        id="jobStyles"
        path="photoheight/jobs/[[jobid]]/map_styles"
        data="{{jobStyles}}"
        disabled="[[!signedIn]]"
      ></katapult-firebase-worker>
      <katapult-firebase-worker
        id="modelOptions"
        path="photoheight/company_space/[[userGroup]]/model_options"
        data="{{modelOptions}}"
        disabled="[[!signedIn]]"
      ></katapult-firebase-worker>
      <katapult-firebase-worker
        id="mapBaseConfigs"
        path="photoheight/company_space/[[userGroup]]/map_bases"
        data="{{mapBaseConfigs}}"
        disabled="[[!signedIn]]"
      ></katapult-firebase-worker>
      <katapult-firebase-worker
        id="useMetricUnits"
        path="photoheight/company_space/[[userGroup]]/user_data/[[user.uid]]/use_metric_units"
        data="{{useMetricUnits}}"
        disabled="[[!signedIn]]"
      ></katapult-firebase-worker>
      <katapult-firebase-worker
        id="labelFontSize"
        path="photoheight/company_space/[[userGroup]]/user_data/[[user.uid]]/mobile_label_font_size"
        data="{{labelFontSize}}"
        null-value="8"
        disabled="[[!signedIn]]"
      ></katapult-firebase-worker>
      <katapult-firebase-worker
        id="preferences"
        path="photoheight/company_space/[[userGroup]]/user_data/[[user.uid]]/preferences"
        data="{{preferences}}"
        disabled="[[!signedIn]]"
      ></katapult-firebase-worker>
      <katapult-firebase-worker
        id="status"
        path="photoheight/jobs/[[jobid]]/status"
        data="{{status}}"
        disabled="[[!signedIn]]"
      ></katapult-firebase-worker>
      <katapult-firebase-worker path="photoheight/jobs/[[jobid]]/sharing/[[userGroup]]" data="{{sharing}}"></katapult-firebase-worker>
      <katapult-firebase-worker path="photoheight/jobs/[[jobid]]/metadata" data="{{jobMetadata}}"></katapult-firebase-worker>
      <katapult-firebase-worker id="jobFiles" path="photoheight/jobs/[[jobid]]/files" data="{{jobFiles}}"></katapult-firebase-worker>
      <katapult-firebase-worker
        id="mapLayers"
        path="photoheight/jobs/[[jobid]]/layers/list"
        data="{{mapLayers}}"
        disabled="[[!signedIn]]"
      ></katapult-firebase-worker>
      <katapult-firebase-worker
        id="favoriteTools"
        path="photoheight/company_space/[[userGroup]]/user_data/[[user.uid]]/custom_toolsets/mobile"
        data="{{favoriteTools}}"
        disabled="[[!signedIn]]"
      ></katapult-firebase-worker>
      <katapult-firebase-worker
        id="recordNodeMoveAttribute"
        path="photoheight/jobs/[[jobid]]/metadata/record_node_move_attribute"
        data="{{recordNodeMoveAttribute}}"
        disabled="[[!signedIn]]"
      ></katapult-firebase-worker>
      <katapult-firebase-worker
        id="isReviewContractor"
        path="photoheight/company_space/[[config.firebaseData.utilityCompany]]/portal_config/user_options/review_contractors/[[userGroup]]"
        data="{{isReviewContractor}}"
        disabled="[[!signedIn]]"
      ></katapult-firebase-worker>
      <katapult-firebase-worker
        id="trackingDisabled"
        path="photoheight/jobs/[[job_id]]/tracking_disabled"
        data="{{trackingDisabled}}"
        disabled="[[disabled]]"
      ></katapult-firebase-worker>
      <katapult-firebase-worker
        id="savedViews"
        path="photoheight/jobs/[[jobid]]/saved_views"
        data="{{savedViews}}"
      ></katapult-firebase-worker>
      <katapult-firebase-worker
        id="apiLayerGroups"
        path="photoheight/company_space/[[userGroup]]/map_api_layer_groups"
        data="{{apiLayerGroups}}"
      ></katapult-firebase-worker>
      <katapult-map-icons model-key="[[jobCreator]]"></katapult-map-icons>
      <job-snapshots id="snapshots" job-id="[[jobid]]" job-name="[[jobName]]" user-group="[[userGroup]]"></job-snapshots>

      <iron-meta id="iconMeta" type="iconset"></iron-meta>
      <!-- TODO: this dialog needs to be converted to a katapult-dialog so that it can be a proper modal -->
      <paper-dialog id="confirmDialog" no-cancel-on-esc-key no-cancel-on-outside-click>
        <h2>{{confirmDialogHeading}}</h2>
        <paper-dialog-scrollable style="display:block; margin:20px 0; overflow-wrap:break-word;"
          >{{confirmDialogBody}}</paper-dialog-scrollable
        >

        <template is="dom-if" if="{{equal(confirmDialogBodyType, 'createSnapshot')}}">
          <paper-input value="{{newSnapshotName}}" label="Snapshot Name"></paper-input>
          <template is="dom-if" if="{{showMidspanOptionForPCI(preppingForPostConstruction, enabledFeatures.pci_midspans)}}">
            <katapult-drop-down
              label="Select map styles"
              value="{{snapshotMapStylesKey}}"
              value-path="key"
              label-path="label"
              items="[[mapStylesList]]"
            ></katapult-drop-down>
            <p>Note: The current job will use these styles when the preparation is complete.</p>
          </template>
          <template is="dom-if" if="[[isReviewContractor]]">
            <div style="display:flex; align-items:center; justify-content:space-between; flex-wrap:wrap;">
              <paper-checkbox style="width:200px; margin: 10px 0px" checked="{{newSnapshotNumbers}}">New WR/WO Numbers</paper-checkbox>
            </div>
          </template>
          <template is="dom-if" if="[[!trackingDisabled]]">
            <paper-checkbox style="width:200px; margin: 10px 0px" checked="{{disableTrackingSnapshot}}"
              >Disable Attribute Tracking in Snapshot</paper-checkbox
            >
          </template>
          <template is="dom-if" if="{{showMidspanOptionForPCI(preppingForPostConstruction, enabledFeatures.pci_midspans)}}">
            <paper-checkbox style="width:200px; margin: 10px 0px" checked="{{includeMidspansForPCI}}">Include Midspans</paper-checkbox>
          </template>
        </template>

        <template is="dom-if" if="{{equal(confirmDialogBodyType, 'selectAssignedToValue')}}">
          <!-- TODO: users currently will be undefined. Possibly change this to an input-element "user-dropdown"-->
          <katapult-drop-down
            items="[[users]]"
            value-path="uid"
            label-path="email"
            value="{{alpineAssignedTo}}"
            label="Assign Job To a User"
            no-label-float=""
          ></katapult-drop-down>
        </template>
        <div class="buttons">
          <katapult-button on-click="confirmCancelCallback">{{confirmDialogDismissiveText}}</katapult-button>
          <katapult-button color="var(--secondary-color)" on-click="confirmCallback">{{confirmDialogAffirmativeText}}</katapult-button>
        </div>
      </paper-dialog>
      <!-- TODO: this dialog needs to be converted to a katapult-dialog so that it can be a proper modal -->
      <paper-dialog id="addJobLayerDialog" no-cancel-on-outside-click no-cancel-on-esc-key>
        <div title="">Add New Job Layer</div>
        <div body="">
          <p>
            Choose a job to add as a reference job layer. You can toggle the layer on/off or remove it from the Job Layers section in the
            menu.
          </p>
          <job-chooser
            offline="[[!online]]"
            on-selected-changed="jobLayerSelectedChanged"
            user-group="{{userGroup}}"
            on-toast="displayToastMessage"
            select-on-focus=""
            mobile=""
            no-create-new-job="[[disableJobCreation]]"
            model-options="[[modelOptions]]"
            firebase-disabled="[[!signedIn]]"
          ></job-chooser>
        </div>
        <div buttons="">
          <katapult-button dialog-dismiss="">Cancel</katapult-button>
        </div>
      </paper-dialog>
      <!-- Bug Feedback Dialog -->
      <katapult-dialog
        id="bugFeedbackDialog"
        style="min-width: 300px;"
        entry-animation="scale-up-animation"
        exit-animation="fade-out-animation"
        title="Software Bug Feedback"
        icon="bug_report"
        no-cancel-on-esc-key
        no-cancel-on-outside-click
      >
        <div content>
          <paper-textarea
            id="bugSubject"
            label="Subject"
            value="{{bugSubject}}"
            error-message="Please enter a subject"
            required=""
          ></paper-textarea>
          <paper-textarea
            id="bugDescription"
            label="What went wrong?"
            value="{{bugEncountered}}"
            error-message="Please describe the issue"
            required=""
          ></paper-textarea>
          <paper-input id="yourName" label="Who are you?" value="{{yourName}}" error-message="Please enter your name"></paper-input>
          <template is="dom-if" if="{{user.email}}">
            <paper-checkbox style="margin-top: 16px;" checked="{{sendToMe}}">Send me a copy of my response</paper-checkbox>
          </template>
          <template is="dom-if" if="{{submittedFeedback}}">
            <span style="display: block; margin-top: 24px; text-align: center; font-size: 12pt;">Thank you for your feedback!</span>
          </template>
        </div>
        <div slot="buttons">
          <template is="dom-if" if="{{!submittedFeedback}}">
            <katapult-button dialog-dismiss="" on-click="clearBugFeedback">Cancel</katapult-button>
            <katapult-button color="var(--secondary-color)" loading="[[submitting]]" on-click="submitBugFeedback">Submit</katapult-button>
          </template>
          <template is="dom-if" if="{{submittedFeedback}}">
            <katapult-button dialog-dismiss="" on-click="clearBugFeedback">Close</katapult-button>
          </template>
        </div>
      </katapult-dialog>
      <paper-dialog id="refSelectDialog">
        <div title="">
          <span>Feature Data</span>
          <katapult-button iconOnly noBorder style="position:absolute; right:15px;" icon="close" dialog-dismiss></katapult-button>
        </div>
        <paper-dialog-scrollable>
          <div>
            <template is="dom-repeat" items="{{refSelectInfo}}">
              <div style="margin-bottom:3px">
                <span style="font-weight: bold">{{item.title}}:</span>
                <span>{{item.desc}}</span>
              </div>
            </template>
          </div>
        </paper-dialog-scrollable>
        <template is="dom-if" if="{{layerReferenceJobName}}">
          <div style="display: flex; align-items: center; justify-content: space-evenly;">
            <katapult-button loading="[[addReferenceJobSpinnerActive]]" on-click="turnOnReferenceJobFromLayer">Turn on Job</katapult-button>
            <katapult-button loading="[[jumpToReferenceJobSpinnerActive]]" on-click="jumpToReferenceJob">Jump to Job</katapult-button>
          </div>
        </template>
      </paper-dialog>
      <katapult-auth
        user="{{user}}"
        user-record="{{userRecord}}"
        user-group="{{userGroup}}"
        company="{{company}}"
        signed-in="{{signedIn}}"
        read-only="{{readOnlyUser}}"
        job-token="{{jobToken}}"
        user-has-mobile-assessments-role="{{userHasMobileAssessmentsRole}}"
        title="[[config.firebaseData.name]] Mobile"
        signup-link="https://katapultpro.com/signup"
        no-signup="[[!config.firebaseData.offerLicenses]]"
        on-sign-in="onSignedIn"
        page="mobile"
        stamp-auth-content-immediately
      >
        <div slot="title-content">
          <p style="margin: 0;">[[config.firebaseData.name]] Maps</p>
        </div>
        <div slot="description-content">
          <p>[[config.firebaseData.name]] Maps allows you to design and share survey jobs with Maps and Photos from any computer.</p>
          <p>Gather data for a permanent record of real-world conditions in minutes!</p>
          <template is="dom-if" if="{{appNameContains(config.firebaseData.name, 'katapult')}}">
            <p>
              Need some help? View our
              <a href="https://katapultpro.com/help/" style="color: white; font-weight: normal; text-decoration: none;">Docs</a>
            </p>
          </template>
        </div>
        <div id="mainVertContainer" slot="auth-content">
          <!-- TODO (04/01/2026): Show this again when you can load Katapult Pro from a cold start -->
          <!-- <template is="dom-if" if="[[showInitializingOverlay(appIsOfflineReady, signedIn)]]" restamp>
            <div id="katapultProInitializingOverlay">
              // Service Worker Installation in Progress
              <div class="serviceWorkerOverlayPart">
                <span>Initializing Katapult Pro</span>
                <sl-spinner></sl-spinner>
              </div>
              // Additional Options for Service Worker Installation
              <template is="dom-if" if="[[showOptionToOnlyWorkOnline]]" restamp>
                <div class="serviceWorkerOverlayPart">
                  <span style="font-size: var(--sl-font-size-medium)"
                    >This is taking longer than expected. You can Retry now, or Continue without offline capability.</span
                  >
                  <sl-alert variant="warning" open>
                    <katapult-icon slot="icon" icon="warning"></katapult-icon>
                    <div>
                      If you choose to continue without offline capability, you may lose unsaved job changes if you lose internet connection
                    </div>
                  </sl-alert>
                  <span style="font-size: var(--sl-font-size-medium)"
                    >Automatically retrying in [[getServiceWorkerInstallSecondsRemaining(serviceWorkerInstallTime)]] seconds...</span
                  >
                </div>
                <div id="serviceWorkerOptionsBar">
                  <katapult-button color="var(--secondary-color)" on-click="retryServiceWorkerInstallation">Retry</katapult-button>
                  <katapult-button color="var(--sl-color-neutral-0)" on-click="continueWithoutServiceWorker"
                    >Continue without Offline Capability</katapult-button
                  >
                </div>
              </template>
            </div>
          </template> -->
          <div id="photoUploadProgressDialog" opened$="[[_showPhotoUploadProgressDialog]]">
            <div id="photoUploadProgressTitle">
              <span>Uploading</span>
              <sl-progress-bar
                style="width: 175px; margin: 0 20px; --indicator-color: [[getUploadProgressBarColor(_jobUploadProgress.progress)]];"
                value="[[_jobUploadProgress.progress]]"
              >
              </sl-progress-bar>
              <span>[[getProgressLabel(_jobUploadProgress.numPhotosUploaded, _jobUploadProgress.numPhotos)]]</span>
            </div>
          </div>
          <div id="main">
            <time-sync
              id="timeSync"
              team-members="{{teamMembers}}"
              got-time-sync="{{gotTimeSync}}"
              loading="{{timeSyncLoading}}"
              pause-app-loading="{{timeSyncPauseAppLoading}}"
              show-clock="[[showInitialTimeSync]]"
              job-id="[[jobid]]"
              job-name="[[jobName]]"
              read-only="[[readOnlyUser]]"
              uid="[[user.uid]]"
              user-group="[[userGroup]]"
              user-email="[[user.email]]"
              other-attributes="[[otherAttributes]]"
              signed-in="[[signedIn]]"
              on-closed="timeSyncClosed"
              disabled="[[timeSyncDisabled]]"
            ></time-sync>
            <navigate-to-location
              id="navigateToLocation"
              active-command="{{activeCommand}}"
              active-item="{{activeItem}}"
              gps-data="[[gpsData]]"
              latitude="{{latitude}}"
              longitude="[[longitude]]"
              on-prompt="prompt"
              on-cancel-prompt="cancelPrompt"
              on-secondary-prompt="secondaryPrompt"
              on-cancel-secondary-prompt="cancelSecondaryPrompt"
              on-tertiary-prompt="tertiaryPrompt"
              on-cancel-tertiary-prompt="cancelTertiaryPrompt"
            ></navigate-to-location>
            <job-time-collection
              id="jobTimeCollection"
              got-time-sync="{{gotTimeSync}}"
              team-members="[[teamMembers]]"
              other-attributes="[[otherAttributes]]"
              checklist-auto-zoom="{{checklistAutoZoom}}"
              auto-zoom-skip-midspans="{{autoZoomSkipMidspans}}"
              nodes-are-loaded="[[nodesAreLoaded]]"
              model-config="{{modelConfig}}"
              model-defaults="{{modelDefaults}}"
              enabled-features="[[enabledFeatures]]"
              jobid="[[jobid]]"
              nodes="{{nodes}}"
              connections="{{connections}}"
              collection-order-logic="[[collectionOrderLogic]]"
              gps-data="[[gpsData]]"
              active-item="{{activeItem}}"
              active-command="{{activeCommand}}"
              active-tool="{{activeTool}}"
              user-group="{{userGroup}}"
              on-toast="toastEvent"
              on-prompt="prompt"
              on-cancel-prompt="cancelPrompt"
              on-secondary-prompt="secondaryPrompt"
              on-cancel-secondary-prompt="cancelSecondaryPrompt"
              on-tertiary-prompt="tertiaryPrompt"
              on-cancel-tertiary-prompt="cancelTertiaryPrompt"
              on-open-photo="openFullscreenPhoto"
              on-zoom-to-active="zoomToActive"
              prompt-button-disbled="{{promptButtonDisbled}}"
              sound-and-vibrate="{{soundAndVibrate}}"
              job-name="[[jobName]]"
              uid="[[user.uid]]"
              user-email="[[user.email]]"
              on-pulse-item="pulseItem"
              job-styles="[[jobStyles]]"
              signed-in="[[signedIn]]"
            >
            </job-time-collection>
            <add-section
              id="addSection"
              jobid="[[jobid]]"
              nodes="{{nodes}}"
              connections="{{connections}}"
              model-config="{{modelConfig}}"
              gps-data="[[gpsData]]"
              latitude="[[latitude]]"
              longitude="[[longitude]]"
              active-item="{{activeItem}}"
              active-command="{{activeCommand}}"
              active-tool="{{activeTool}}"
              active-button="{{activeButton}}"
              active-button-model="[[activeButtonModel]]"
              will-run-command="{{willRunCommand}}"
              design-only="{{designOnly}}"
              on-toast="toastEvent"
              on-prompt="prompt"
              on-cancel-prompt="cancelPrompt"
              on-secondary-prompt="secondaryPrompt"
              on-cancel-secondary-prompt="cancelSecondaryPrompt"
              on-tertiary-prompt="tertiaryPrompt"
              on-cancel-tertiary-prompt="cancelTertiaryPrompt"
              on-zoom-to-active="zoomToActive"
              on-run-command="promptTaken"
              on-update-active-item-location="updateActiveItemLocation"
              snap-line="{{snapLine}}"
              job-styles="[[jobStyles]]"
            ></add-section>
            <draw-on-map
              id="drawOnMap"
              jobid="[[jobid]]"
              nodes="{{nodes}}"
              connections="{{connections}}"
              geo="{{geo}}"
              geohash="[[geohash]]"
              model-config="{{modelConfig}}"
              collection-order-logic="[[collectionOrderLogic]]"
              other-attributes="[[otherAttributes]]"
              user-group="{{userGroup}}"
              job-creator="{{jobCreator}}"
              mapping-buttons="[[mappingButtons]]"
              model-defaults="[[modelDefaults]]"
              gps-data="[[gpsData]]"
              gps-circle-config="[[gpsCircleConfig]]"
              use-metric-units="[[useMetricUnits]]"
              latitude="{{latitude}}"
              longitude="[[longitude]]"
              active-item="{{activeItem}}"
              active-command="{{activeCommand}}"
              active-tool="{{activeTool}}"
              will-run-command="{{willRunCommand}}"
              active-button="{{activeButton}}"
              active-button-model="[[activeButtonModel]]"
              show-line-to-active="{{showLineToActive}}"
              design-only="{{designOnly}}"
              snap-length="{{snapLength}}"
              snap-angle="{{snapAngle}}"
              job-styles="{{jobStyles}}"
              on-toast="toastEvent"
              on-prompt="prompt"
              on-cancel-prompt="cancelPrompt"
              on-secondary-prompt="secondaryPrompt"
              on-set-temp-highlight-location="setTempHighlightLocation"
              on-cancel-secondary-prompt="cancelSecondaryPrompt"
              on-tertiary-prompt="tertiaryPrompt"
              on-cancel-tertiary-prompt="cancelTertiaryPrompt"
              closest-includes-reference-jobs="{{closestIncludesReferenceJobs}}"
              on-zoom-to-active="zoomToActive"
              on-run-command="promptTaken"
              on-highlight-conn="highlightConn"
              on-confirm="confirm"
              active-item-location-updated="{{activeItemLocationUpdated}}"
              enter-next-polyline-point="{{polylinePoints}}"
              on-done-collection="markDoneClicked"
            ></draw-on-map>
            <select-ref-layer
              id="selectRefLayer"
              jobid="[[jobid]]"
              geo="{{geo}}"
              layers="[[layers]]"
              main-job-id="[[jobid]]"
              map-is-ready="[[googleIsReady]]"
              other-attributes="[[otherAttributes]]"
              active-item="{{activeItem}}"
              active-command="{{activeCommand}}"
              active-tool="{{activeTool}}"
              will-run-command="{{willRunCommand}}"
              active-button="{{activeButton}}"
              active-button-model="[[activeButtonModel]]"
              show-line-to-active="{{showLineToActive}}"
              on-toast="toastEvent"
              on-ref-select="refSelect"
              on-prompt="prompt"
              on-cancel-prompt="cancelPrompt"
              on-secondary-prompt="secondaryPrompt"
              on-cancel-secondary-prompt="cancelSecondaryPrompt"
              on-run-command="promptTaken"
              on-highlight-conn="highlightConn"
              on-confirm="confirm"
            ></select-ref-layer>
            <mobile-web-tool
              id="mobileWebTool"
              jobid="[[jobid]]"
              active-item="[[activeItem]]"
              active-command="[[activeCommand]]"
              active-button-model="[[activeButtonModel]]"
              on-lit-property-changed="handleBoundLitPropertyChanged"
              on-prompt="prompt"
              on-toast="toastEvent"
              on-cancel-prompt="cancelPrompt"
              on-cancel-secondary-prompt="cancelSecondaryPrompt"
              on-cancel-tertiary-prompt="cancelTertiaryPrompt"
            ></mobile-web-tool>
            <edit-attributes
              id="editAttributes"
              config="[[config]]"
              file-folder="{{config.firebaseData.amazonFolder}}"
              jobid="[[jobid]]"
              nodes="{{nodes}}"
              connections="{{connections}}"
              job-styles="{{jobStyles}}"
              job-creator="[[jobCreator]]"
              model-defaults="[[modelDefaults]]"
              user-group="{{userGroup}}"
              user-record="[[userRecord]]"
              read-only-user="[[readOnlyUser]]"
              gps-data="[[gpsData]]"
              use-metric-units="[[useMetricUnits]]"
              status="{{status}}"
              disabled="[[!signedIn]]"
              other-attributes="[[otherAttributes]]"
              mapping-buttons="[[mappingButtons]]"
              input-models="[[inputModels]]"
              active-item="{{activeItem}}"
              active-tool="{{activeTool}}"
              active-command="{{activeCommand}}"
              selected-node-latitude="[[selectedNodeLatitude]]"
              selected-node-longitude="[[selectedNodeLongitude]]"
              on-toggle-polyline-editing="togglePolylineEditing"
              on-toast="toastEvent"
              on-prompt="prompt"
              on-cancel-prompt="cancelPrompt"
              on-secondary-prompt="secondaryPrompt"
              on-cancel-secondary-prompt="cancelSecondaryPrompt"
              on-zoom-to-active="zoomToActive"
              on-run-command="promptTaken"
              on-confirm="confirm"
              on-update-connection-endpoint="updateConnectionEndpoint"
              on-open-photo="openFullscreenPhoto"
              user-has-mobile-assessments-role="[[userHasMobileAssessmentsRole]]"
            ></edit-attributes>
            <assess-attributes
              id="assessAttributes"
              file-folder="{{config.firebaseData.amazonFolder}}"
              job-id="[[jobid]]"
              nodes="{{nodes}}"
              connections="{{connections}}"
              job-styles="{{jobStyles}}"
              job-creator="[[jobCreator]]"
              model-defaults="[[modelDefaults]]"
              user-group="{{userGroup}}"
              uid="{{user.uid}}"
              read-only-user="[[readOnlyUser]]"
              gps-data="[[gpsData]]"
              use-metric-units="[[useMetricUnits]]"
              status="{{status}}"
              disabled="[[!signedIn]]"
              other-attributes="[[otherAttributes]]"
              mapping-buttons="[[mappingButtons]]"
              input-models="[[inputModels]]"
              active-item="{{activeItem}}"
              active-tool="{{activeTool}}"
              active-command="{{activeCommand}}"
              active-button="{{activeButton}}"
              selected-node-latitude="[[selectedNodeLatitude]]"
              selected-node-longitude="[[selectedNodeLongitude]]"
              model-config="{{modelConfig}}"
              user-record="[[userRecord]]"
              got-time-sync="[[gotTimeSync]]"
              time-sync-disabled="[[timeSyncDisabled]]"
              on-toast="toastEvent"
              on-prompt="prompt"
              on-cancel-prompt="cancelPrompt"
              on-secondary-prompt="secondaryPrompt"
              on-cancel-secondary-prompt="cancelSecondaryPrompt"
              on-zoom-to-active="zoomToActive"
              on-run-command="promptTaken"
              on-confirm="confirm"
              on-update-connection-endpoint="updateConnectionEndpoint"
              on-photos-taken="assessmentPhotosTaken"
              on-open-photo="openFullscreenPhoto"
              user-has-mobile-assessments-role="[[userHasMobileAssessmentsRole]]"
            ></assess-attributes>
            <move-item
              id="moveItem"
              googlemap="[[$.googlemap]]"
              jobid="[[jobid]]"
              active-tool="[[activeTool]]"
              active-command="{{activeCommand}}"
              active-item="{{activeItem}}"
              model-config="{{modelConfig}}"
              record-node-move-attribute="[[recordNodeMoveAttribute]]"
              show-angles-of-node="{{showAnglesOfNode}}"
              conns-to-label="{{connsToLabel}}"
              latitude="{{latitude}}"
              longitude="{{longitude}}"
              gps-data="[[gpsData]]"
              center-map-on-g-p-s="[[centerMapOnGPS]]"
              map-panned="[[mapPanned]]"
              pointer-as-crosshair="{{pointerAsCrosshair}}"
              job-styles="[[jobStyles]]"
              use-metric-units="[[useMetricUnits]]"
              model-defaults="[[modelDefaults]]"
              on-toast="toastEvent"
              on-prompt="prompt"
              on-cancel-prompt="cancelPrompt"
              on-secondary-prompt="secondaryPrompt"
              on-cancel-secondary-prompt="cancelSecondaryPrompt"
              on-tertiary-prompt="tertiaryPrompt"
              on-cancel-tertiary-prompt="cancelTertiaryPrompt"
              on-zoom-to-active="zoomToActive"
              on-update-active-item-location="updateActiveItemLocation"
              on-gps-circle-config-changed="gpsCircleConfigChanged"
            ></move-item>
            <offline-management
              style="z-index: 100;"
              user-group="[[userGroup]]"
              user-id="[[user.uid]]"
              on-open-job="openJob"
              is-online="[[online]]"
              app-is-ready-for-offline-use="[[appIsOfflineReady]]"
            ></offline-management>
            <div id="sidePanel" katapult-drop-down-disable-scrolling opened$="[[showSidePanel]]">
              <div id="sidePanelScroll">
                <div id="sidePanelTopButtonsContainer">
                  <katapult-button
                    iconOnly
                    noBorder
                    icon="close"
                    on-touchstart="toggleShowSidePanel"
                    on-mousedown="toggleShowSidePanel"
                  ></katapult-button>
                  <div style="position: relative;">
                    <katapult-button iconOnly noBorder icon="refresh" on-click="reloadMobile"></katapult-button>
                    <katapult-icon
                      icon="release_alert"
                      color="var(--secondary-color)"
                      class="update-available-badge"
                      size="small"
                      hidden$="[[!updateAvailable]]"
                    ></katapult-icon>
                  </div>
                  <paper-menu-button id="helpDrawerMenu" horizontal-align="center" vertical-align="top" no-overlap>
                    <katapult-button iconOnly noBorder icon="help" slot="dropdown-trigger"></katapult-button>
                    <div id="helpDrawer" slot="dropdown-content" style="padding: 16px;">
                      <div style="display: flex; flex-direction: column; gap: 8px;">
                        <div style="display: flex; flex-direction: column; gap: 8px; align-items: center;">
                          <version-selector-button
                            style="box-sizing: border-box;"
                            current-version-name="[[currentVersionName]]"
                          ></version-selector-button>
                          <katapult-button
                            style="box-sizing: border-box; width: -webkit-fill-available;"
                            on-click="openBugFeedback"
                            icon="bug_report"
                            >Report Bug</katapult-button
                          >
                          <katapult-button
                            style="box-sizing: border-box; width: -webkit-fill-available; margin-bottom: 8px;"
                            on-click="openTrainingPage"
                            icon="help"
                            >Training Resources</katapult-button
                          >
                        </div>
                        <div class="software-details">
                          <!-- TODO (04/01/2026): Show Service Worker status again when you can load Katapult Pro from a cold start -->
                          <!-- Show Service Worker Success Status Message -->
                          <!-- <template is="dom-if" if="[[appIsOfflineReady]]">
                            <div class="serviceWorkerStatusMessage">
                              <katapult-icon icon="circle" color="var(--sl-color-success)" size="15"></katapult-icon>
                              <p>App is ready for offline use</p>
                            </div>
                          </template>
                          <template is="dom-if" if="[[!appIsOfflineReady]]">
                            <div class="serviceWorkerStatusMessage">
                              <katapult-icon icon="circle" color="var(--sl-color-danger)" size="15"></katapult-icon>
                              <p>App is not ready for offline use</p>
                            </div>
                          </template> -->
                          <p>Version: {{config.version}} ({{config.buildNumber}})</p>
                          <p>Build Date: {{config.buildDate}}</p>
                          <p>KATAPULT is a registered trademark of Katapult Engineering, Inc.</p>
                          <p>©[[getCopyrightYear()]] Katapult Engineering, Inc. All Rights Reserved.</p>
                          <p>
                            <a class="helpLink" target="_blank" href="../eula/">EULA</a>
                            <a class="helpLink" target="_blank" href="../us-privacy-policy/">Privacy Policy</a>
                          </p>
                          <p>[[googleCopyrightText]]</p>
                        </div>
                      </div>
                    </div>
                  </paper-menu-button>
                  <login-chip hide-name user-group="[[userGroup]]"></login-chip>
                </div>
                <sl-alert class="update-available-message" open="[[updateAvailable]]" closable>
                  <span>Update available. Click the reload button above to apply. This will refresh all open tabs.</span>
                </sl-alert>
                <div id="jobCooserContainer">
                  <job-chooser
                    id="mobileJobChooser"
                    offline="[[!online]]"
                    selected="{{jobChooserJobId}}"
                    user-group="{{userGroup}}"
                    on-toast="displayToastMessage"
                    select-on-focus=""
                    mobile=""
                    no-create-new-job="[[disableJobCreation]]"
                    show-job-creator
                    model-options="[[modelOptions]]"
                    on-job-created="jobCreated"
                    firebase-disabled="[[!signedIn]]"
                  ></job-chooser>
                </div>
                <div id="poleCount" class$="[[getNumCollectedContainerClass(activeTool, numPoles, numPolesCompleted)]]">
                  <span>[[numPolesCompleted]] of [[numPoles]] Completed</span>
                </div>
                <div id="sidePanelRows">
                  <!--Context Info-->
                  <iron-collapse opened="{{computeShowAppInfoMenu(jobName, userGroup)}}">
                    <paper-item on-click="toggleDrawer" name="moreContextInfoDrawer">
                      <iron-icon class="menuDrawerIcon" icon="list"></iron-icon> Application Info
                    </paper-item>
                    <iron-collapse class="menuDrawer" id="moreContextInfoDrawer">
                      <!--Data for 300 level Apps Info-->
                      <template is="dom-if" if="{{!isOldApp}}">
                        <div style="padding:0 16px;">
                          <div class="contextInfoItem"><span>Attachment Owner: {{formattedAttachmentOwner}}</span></div>
                          <template is="dom-if" if="{getJobCreator(jobMetadata)}}">
                            <span>Creator: {{formattedCreator}}</span>
                          </template>
                          <div class="contextInfoItem">
                            <span>{{jobMetadata.pole_count}}</span> Poles; <span>{{appTypeDisplayName}}</span>
                          </div>
                          <div class="contextInfoItem">Submitted: <span>{{formatDate(jobMetadata.date_submitted)}}</span></div>
                          <div class="contextInfoItem"><span class="contextInfoTitle">WR: </span>{{_computeExpression15(jobMetadata)}}</div>
                          <div class="contextInfoItem"><span class="contextInfoTitle">WO: </span>{{_computeExpression16(jobMetadata)}}</div>
                          <div class="contextInfoItem"><span class="contextInfoTitle">Status: </span>{{jobMetadata.app_status}}</div>
                          <div class="contextInfoItem">
                            <span class="contextInfoTitle">Link: </span>
                            <a
                              class="contextInfoLink"
                              target="_blank"
                              href$="https://ppl.katapultwebservices.com/pole-application/#[[jobid]]"
                              >{{jobMetadata.app_number}}</a
                            >
                          </div>
                          <template is="dom-if" if="{{formattedJobFiles.length}}">
                            <div class="contextInfoItem">
                              <span class="contextInfoTitle">Files: </span>
                              <ul>
                                <template is="dom-repeat" items="{{formattedJobFiles}}" as="file">
                                  <li><a class="contextInfoLink" href$="{{file.url}}" download$="{{file.name}}">{{file.name}}</a></li>
                                </template>
                              </ul>
                            </div>
                          </template>
                          <template is="dom-if" if="{{jobMetadata.app_notes}}">
                            <div class="contextInfoItem">
                              <span class="contextInfoTitle">Notes: </span>
                              <template is="dom-repeat" items="{{jobMetadata.app_notes}}" as="note">
                                <span>{{note.notetext}}</span>
                              </template>
                            </div>
                          </template>
                        </div>
                      </template>
                      <!-- Context Info for 200 Level Apps-->
                      <template is="dom-if" if="{{isOldApp}}">
                        <template is="dom-if" if="{{!contextInfoExists(contextInfo)}}">
                          <katapult-button color="#d0d0d0" style="margin-top:5px;" on-click="requestContextInfo"
                            >Tap to Load App Info</katapult-button
                          >
                          <template is="dom-if" if="{{contextInfoLoading}}">
                            <paper-spinner style="width:20px; height:20px;" active></paper-spinner>
                          </template>
                          <template is="dom-if" if="{{contextInfoError}}">
                            <br />
                            <p>{{contextInfoError}}</p>
                          </template>
                        </template>
                        <template is="dom-if" if="{{contextInfoExists(contextInfo)}}">
                          <div style="padding:0 16px;">
                            <div class="contextInfoItem">{{contextInfo.submitting_company}}</div>
                            <div class="contextInfoItem">
                              <span>{{contextInfo.polecount}}</span> Poles; <span>{{contextInfo.app_type}}</span>
                            </div>
                            <div class="contextInfoItem">Submitted <span>{{formatDate(contextInfo.date_submitted)}}</span></div>
                            <div class="contextInfoItem">
                              <span class="contextInfoTitle">WR: </span>{{_computeExpression15(contextInfo)}}
                            </div>
                            <div class="contextInfoItem">
                              <span class="contextInfoTitle">WO: </span>{{_computeExpression16(contextInfo)}}
                            </div>
                            <div class="contextInfoItem"><span class="contextInfoTitle">Status: </span>{{contextInfo.app_status}}</div>
                            <div class="contextInfoItem">
                              <span class="contextInfoTitle">Link: </span>
                              <a
                                class="contextInfoLink"
                                target="_blank"
                                href$="https://katapultwebservices.com/ppl/poleattachmentservices/ExistingApplication/{{contextInfo.applicationid}}"
                                >{{contextInfo.ppl_app_no}}</a
                              >
                            </div>
                            <template is="dom-if" if="{{contextInfo.app_files}}">
                              <div class="contextInfoItem">
                                <span class="contextInfoTitle">Files: </span>
                                <template is="dom-repeat" items="{{contextInfo.app_files}}" as="file">
                                  <a
                                    class="contextInfoLink"
                                    target="_blank"
                                    href$="https://katapultwebservices.com/ppl/poleattachmentservices/OpenApplicationFile/?name={{file.filepath}}&appid={{contextInfo.applicationid}}"
                                    >{{file.filepath}}</a
                                  >
                                </template>
                              </div>
                            </template>
                            <template is="dom-if" if="{{contextInfo.app_notes}}">
                              <div class="contextInfoItem">
                                <span class="contextInfoTitle">Notes: </span>
                                <template is="dom-repeat" items="{{contextInfo.app_notes}}" as="note">
                                  <span>{{note.notetext}}</span>
                                </template>
                              </div>
                            </template>
                          </div>
                        </template>
                      </template>
                    </iron-collapse>
                  </iron-collapse>
                  <!--End Context Info-->
                  <template is="dom-if" if="[[!readOnlyUser]]">
                    <!--Type of Work-->
                    <paper-item on-click="toggleDrawer" name="workTypeDrawer">
                      <iron-icon class="menuDrawerIcon" icon="dashboard"></iron-icon> Toolset
                    </paper-item>
                    <iron-collapse class="menuDrawer" id="workTypeDrawer">
                      <iron-selector attr-for-selected="value" selected="{{buttonGroup}}">
                        <template is="dom-repeat" items="{{buttonGroupKeys}}" as="buttonKey">
                          <paper-item value="{{buttonKey}}">{{camelCase(buttonKey)}}</paper-item>
                        </template>
                      </iron-selector>
                    </iron-collapse>
                  </template>
                  <!--Map Layers-->
                  <paper-item on-click="toggleDrawer" name="mapLayerDrawer">
                    <iron-icon class="menuDrawerIcon" icon="maps:layers"></iron-icon> Map Layers
                  </paper-item>
                  <iron-collapse class="menuDrawer" id="mapLayerDrawer">
                    <map-layers-menu-view
                      id="mapLayersMenuView"
                      starting-layers="[[filteredMapLayers]]"
                      geo-json-layers="[[geoJsonLayers]]"
                      api-layer-groups="[[apiLayerGroups]]"
                      api-map-layers="[[apiMapLayers]]"
                      overlays="[[loadedImageOverlays]]"
                      on-toggle-map-layer-item="toggleMapLayerItem"
                      isMobile
                    >
                    </map-layers-menu-view>
                  </iron-collapse>
                  <!--Job Layers-->
                  <template is="dom-if" if="[[jobid]]">
                    <paper-item on-click="toggleDrawer" name="jobLayerDrawer">
                      <iron-icon class="menuDrawerIcon" icon="maps:map"></iron-icon> Job Layers
                    </paper-item>
                    <iron-collapse class="menuDrawer" id="jobLayerDrawer">
                      <template is="dom-repeat" items="[[jobLayersArray]]">
                        <div style="padding:10px; display:flex; align-items: center;">
                          <paper-toggle-button
                            id="l{{item.$key}}"
                            on-change="clickedToggleReferenceJobLayer"
                            checked="{{item.visible}}"
                          ></paper-toggle-button>
                          <iron-icon icon="maps:place" style$="color:{{item.color}}"></iron-icon>
                          <span style="text-overflow:ellipsis; overflow:hidden; white-space:nowrap; flex:1;"
                            >{{firstValid(item.name, item.$val)}}</span
                          >
                        </div>
                      </template>
                      <katapult-button on-click="openJobLayersDialog" class="submenuButton" style="display:flex"
                        >Add Job Layer</katapult-button
                      >
                    </iron-collapse>
                  </template>
                  <!--Map Labels-->
                  <template is="dom-if" if="[[jobid]]">
                    <paper-item on-click="toggleDrawer" name="labelsDrawer">
                      <iron-icon class="menuDrawerIcon" icon="label"></iron-icon> Labels
                    </paper-item>
                    <iron-collapse class="menuDrawer" id="labelsDrawer">
                      <template is="dom-repeat" items="[[objectKeys(nodeLabels, nodeLabels.*)]]">
                        <div class="menuDrawerItem">
                          <paper-toggle-button on-change="clickedToggleLabel" checked="{{labelIsOn(item, nodeLabels.*)}}">
                            [[camelCase(item)]]
                          </paper-toggle-button>
                        </div>
                      </template>
                      <div class="menuDrawerItem">
                        <paper-toggle-button checked="{{showSpanDistances}}">Span Distances</paper-toggle-button>
                      </div>
                      <div style="display: flex; align-items: center">
                        <span>Label Font Size:</span>
                        <paper-input
                          value="[[labelFontSize]]"
                          type="number"
                          no-label-float
                          style="width: 40px; text-align: center; margin-left: 30px"
                          placeholder="0"
                          on-change="labelFontSizeChanged"
                        ></paper-input>
                      </div>
                      <katapult-button on-click="openAddLabelsDialog" class="submenuButton" style="display:flex"
                        >Add a Label</katapult-button
                      >
                    </iron-collapse>
                  </template>
                  <!--Map Base-->
                  <paper-item on-click="toggleDrawer" name="mapBaseDrawer">
                    <iron-icon class="menuDrawerIcon" icon="maps:terrain"></iron-icon> Map Base
                  </paper-item>
                  <iron-collapse class="menuDrawer" id="mapBaseDrawer">
                    <paper-radio-group selected="{{selectedMapType}}">
                      <template is="dom-repeat" items="[[toArray(mapTypeIds, mapTypeIds.*)]]">
                        <template is="dom-if" if="[[mapBaseIsDisabled(item, mapBaseConfigs)]]">
                          <div on-click="showWmtsMapBaseDisabledToast" style="pointer-events: auto;">
                            <paper-radio-button name="[[item.$key]]" disabled>[[item.$val]]</paper-radio-button>
                          </div>
                        </template>
                        <template is="dom-if" if="[[mapBaseIsEnabled(item, mapBaseConfigs)]]">
                          <paper-radio-button name="[[item.$key]]">[[item.$val]]</paper-radio-button>
                        </template>
                      </template>
                    </paper-radio-group>
                  </iron-collapse>
                  <!--Offline Management-->
                  <template is="dom-if" if="[[!readOnlyUser]]">
                    <paper-item on-click="openOfflineManagement">
                      <katapult-icon class="menuDrawerIcon" icon="cloud_sync"></katapult-icon> Offline Management
                    </paper-item>
                  </template>
                  <!--Legend-->
                  <paper-item on-click="toggleDrawer" name="legendDrawer">
                    <iron-icon class="menuDrawerIcon" icon="info"></iron-icon> Legend
                  </paper-item>
                  <iron-collapse class="menuDrawer" id="legendDrawer">
                    <template is="dom-repeat" items="{{legendItems}}">
                      <div class="legendItem">
                        <div class="legendIconContainer">
                          <iron-icon icon="{{item.icon}}" style$="{{item.style}}"></iron-icon>
                        </div>
                        {{item.title}}
                      </div>
                    </template>
                  </iron-collapse>
                  <paper-item on-click="toggleDrawer" name="settingsDrawer">
                    <iron-icon class="menuDrawerIcon" icon="settings"></iron-icon> Settings
                  </paper-item>
                  <iron-collapse class="menuDrawer" id="settingsDrawer">
                    <template is="dom-if" if="[[!readOnlyUser]]">
                      <div style="padding:10px; display:flex;" on-click="toggleSetting" name="checklistAutoZoom">
                        <paper-toggle-button checked="[[checklistAutoZoom]]"></paper-toggle-button>
                        <span style="margin-left: 10px; margin-right: 5px;">Auto-Zoom Checklist</span>
                      </div>
                      <template is="dom-if" if="[[checklistAutoZoom]]">
                        <div style="margin-left:50px; padding:10px; display:flex;" on-click="toggleSetting" name="autoZoomSkipMidspans">
                          <paper-toggle-button checked="[[autoZoomSkipMidspans]]"></paper-toggle-button>
                          <span style="margin-left: 1px; margin-right: 5px;">Skip Midspans</span>
                        </div>
                      </template>
                      <div style="padding:10px; display:flex;" on-click="toggleSetting" name="soundAndVibrate">
                        <paper-toggle-button checked="[[soundAndVibrate]]"></paper-toggle-button>
                        <span style="margin-left: 10px; margin-right: 5px;">Sounds &amp; Vibrate</span>
                      </div>
                      <div style="padding:10px; display:flex;" on-click="toggleSetting" name="quickPhotoCapture">
                        <paper-toggle-button checked="[[quickPhotoCapture]]"></paper-toggle-button>
                        <span style="margin-left: 10px; margin-right: 5px;">Quick Photo Capture</span>
                      </div>
                    </template>
                    <div style="padding:10px; display:flex;" on-click="toggleSetting" name="centerMapOnGPS">
                      <paper-toggle-button checked="[[centerMapOnGPS]]"></paper-toggle-button>
                      <span style="margin-left: 10px; margin-right: 5px;">Center Map On GPS</span>
                    </div>
                    <div
                      style$="padding:10px; display:flex; pointer-events: [[getHideGPSButtonPointerEvents(centerMapOnGPS)]];"
                      on-click="toggleSetting"
                      name="hideGPSButton"
                    >
                      <paper-toggle-button checked="[[hideGPSButton]]" disabled="[[centerMapOnGPS]]"></paper-toggle-button>
                      <span style="margin-left: 10px; margin-right: 5px;">Hide GPS Button</span>
                    </div>
                    <template is="dom-if" if="[[enabledFeatures.log_gps_to_job]]">
                      <div style="padding:10px; display:flex;" on-click="toggleSetting" name="logGPSToJob">
                        <paper-toggle-button checked="[[logGPSToJob]]"></paper-toggle-button>
                        <span style="margin-left: 10px; margin-right: 5px;">Log GPS To Job</span>
                      </div>
                    </template>
                    <div style="padding:10px; display:flex;">
                      <paper-toggle-button checked="{{useMetricUnitsChecked}}"></paper-toggle-button>
                      <span style="margin-left: 10px; margin-right: 5px;">Use Metric Units</span>
                    </div>
                    <div style="padding:10px; display:flex;" on-click="toggleSetting" name="hideMobileZoomControls">
                      <paper-toggle-button checked="[[hideMobileZoomControls]]"></paper-toggle-button>
                      <span style="margin-left: 10px; margin-right: 5px;">Hide Zoom Controls</span>
                    </div>
                    <div style="padding:10px; display:flex;" on-click="toggleSetting" name="hideMobileCompass">
                      <paper-toggle-button checked="[[hideMobileCompass]]"></paper-toggle-button>
                      <span style="margin-left: 10px; margin-right: 5px;">Hide Compass</span>
                    </div>
                    <div style="padding:10px; display:flex;" on-click="toggleSetting" name="savedViewsSetLabels">
                      <paper-toggle-button checked="[[savedViewsSetLabels]]"></paper-toggle-button>
                      <span style="margin-left: 10px; margin-right: 5px;">Saved Views Set Labels</span>
                    </div>
                    <div style="padding: 10px; display:flex;" on-click="toggleSetting" name="debugMode">
                      <paper-toggle-button checked="[[debugMode]]" on-checked-changed="toggleDebugConsole"></paper-toggle-button>
                      <span style="margin-left: 10px; margin-right: 5px;">Debug Mode</span>
                    </div>
                    <iron-collapse opened="[[debugMode]]" style="display: flex;">
                      <katapult-button on-click="openDebuggingLog" class="submenuButton">Mobile Console</katapult-button>
                    </iron-collapse>
                    <div style="padding: 10px; display:flex;" on-click="toggleSetting" name="superZoom">
                      <paper-toggle-button checked="[[superZoom]]"></paper-toggle-button>
                      <span style="margin-left: 10px; margin-right: 5px;">Super Zoom</span>
                    </div>
                    <div>
                      <span style="font-size: 9pt"
                        >Super Zoom is only able to work with an Internet Connection. It is suggested to keep this setting disabled if
                        working with an unstable connection.</span
                      >
                    </div>
                  </iron-collapse>
                  <template is="dom-if" if="[[enabledFeatures.show_poles_that_need_inspection_mobile]]">
                    <div style="padding: 10px; display:flex;" on-click="highlightInspectedPoles" name="showUninspectedPoles">
                      <paper-toggle-button checked="{{showUninspectedPoles}}"></paper-toggle-button>
                      <span style="margin-left: 10px; margin-right: 5px;">Show Poles That Need Inspection</span>
                    </div>
                  </template>
                </div>
                <div style="flex-grow: 1;"></div>
                <div style="display: flex; flex-direction: column; gap: 8px;">
                  <katapult-button
                    on-click="openReleaseNotes"
                    hidden$="[[isNewVersion]]"
                    bordercolor="var(--secondary-color)"
                    textcolor="var(--secondary-color)"
                    >Release Notes</katapult-button
                  >
                  <katapult-button
                    on-click="openReleaseNotes"
                    icon="campaign"
                    hidden$="[[!isNewVersion]]"
                    color="var(--secondary-color)"
                    textcolor="white"
                    >What's New</katapult-button
                  >
                </div>
              </div>
            </div>
            <paper-dialog id="debuggingLog">
              <div style="display: flex; align-items: center;">
                <h2 style="margin: 0;">Debugging Log</h2>
                <katapult-button dialog-dismiss style="margin-left: auto;">Close</katapult-button>
              </div>
              <paper-dialog-scrollable>
                <div>
                  <template is="dom-repeat" items="[[mobileConsole]]" as="log">
                    <div class$="log [[log.type]]">
                      <iron-icon icon="[[getLogIcon(log.type)]]" style="width: 20px; min-width: 20px; margin: 0 5px;"></iron-icon>
                      <span style="margin-right: 5px;">{{log.text}}</span>
                    </div>
                  </template>
                </div>
              </paper-dialog-scrollable>
            </paper-dialog>
            <paper-dialog
              id="liveGPSData"
              style="top: 0; left: 0; margin: 0; width: 100vw; height: 100vh; border-radius: 0; position: fixed;"
            >
              <div style="display: flex;">
                <h2>Live GPS Data</h2>
                <katapult-button iconOnly noBorder dialog-dismiss style="margin-left: auto;" icon="close"></katapult-button>
              </div>
              <h4>Latitude: [[gpsData.latitude]]</h4>
              <h4>Longitude: [[gpsData.longitude]]</h4>
              <p>Accuracy: [[gpsData.accuracy]]</p>
              <h4>Elevation: [[gpsData.altitude]]</h4>
              <p>Elevation Accuracy: [[gpsData.altitudeAccuracy]]</p>
            </paper-dialog>
            <div id="activeToolChooser" opened$="[[activeToolChooserOpen]]">
              <katapult-button id="closeToolChooser" iconOnly noBorder on-click="closeActiveToolChooser" icon="clear"></katapult-button>
              <template is="dom-if" if="[[editingFavoriteTools]]">
                <h2>Choose Favorite Tools</h2>
              </template>
              <template is="dom-if" if="[[!editingFavoriteTools]]">
                <h2>Choose Active Tool</h2>
              </template>
              <div style="margin-bottom: 16px;">
                <div
                  class="toolIcon"
                  name="navigateToLocation"
                  on-click="selectTool"
                  editing$="[[editingFavoriteTools]]"
                  favorite$="[[isFavoriteTool('navigateToLocation', favoriteTools.*)]]"
                  on-touchstart="toolMouseDown"
                  on-touchend="toolMouseUp"
                >
                  <paper-ripple noink style="color:#303F9F;"></paper-ripple
                  ><iron-icon icon="maps:navigation" style="color:#303F9F;"></iron-icon><span>Navigation</span>
                </div>
                <div
                  class="toolIcon"
                  name="myLocation"
                  on-click="selectTool"
                  editing$="[[editingFavoriteTools]]"
                  favorite$="[[isFavoriteTool('myLocation', favoriteTools.*)]]"
                  on-touchstart="toolMouseDown"
                  on-touchend="toolMouseUp"
                >
                  <paper-ripple noink></paper-ripple><iron-icon icon="maps:my-location"></iron-icon><span>Find Me</span>
                </div>
                <template is="dom-if" if="[[!userHasMobileAssessmentsRole]]">
                  <div
                    class="toolIcon"
                    name="showGPSData"
                    on-click="selectTool"
                    editing$="[[editingFavoriteTools]]"
                    favorite$="[[isFavoriteTool('showGPSData', favoriteTools.*)]]"
                    on-touchstart="toolMouseDown"
                    on-touchend="toolMouseUp"
                  >
                    <paper-ripple noink></paper-ripple><iron-icon icon="icons:explore"></iron-icon><span>GPS Data</span>
                  </div>
                </template>
                <template is="dom-if" if="[[!readOnlyUser]]">
                  <div
                    class="toolIcon"
                    name="timeSync"
                    on-click="selectTool"
                    editing$="[[editingFavoriteTools]]"
                    favorite$="[[isFavoriteTool('timeSync', favoriteTools.*)]]"
                    on-touchstart="toolMouseDown"
                    on-touchend="toolMouseUp"
                    hidden$="{{equal(jobid, '')}}"
                  >
                    <paper-ripple noink></paper-ripple><iron-icon icon="image:timer"></iron-icon><span>Sync Photo</span>
                  </div>
                  <template is="dom-if" if="[[!userHasMobileAssessmentsRole]]">
                    <div
                      class="toolIcon"
                      name="jobTimeCollection"
                      hidden$="{{equal(jobid, '')}}"
                      on-click="selectTool"
                      editing$="[[editingFavoriteTools]]"
                      favorite$="[[isFavoriteTool('jobTimeCollection', favoriteTools.*)]]"
                      on-touchstart="toolMouseDown"
                      on-touchend="toolMouseUp"
                    >
                      <paper-ripple noink></paper-ripple><iron-icon icon="image:camera-alt"></iron-icon><span>Checklist</span>
                    </div>
                    <div
                      class="toolIcon"
                      name="undoTimeBucket"
                      hidden$="{{equal(jobid, '')}}"
                      on-click="selectTool"
                      editing$="[[editingFavoriteTools]]"
                      favorite$="[[isFavoriteTool('undoTimeBucket', favoriteTools.*)]]"
                      on-touchstart="toolMouseDown"
                      on-touchend="toolMouseUp"
                    >
                      <paper-ripple noink style="color:#9e9e9e;"></paper-ripple><iron-icon icon="undo" style="color:#9e9e9e;"></iron-icon
                      ><span>Undo Time</span>
                    </div>
                  </template>
                </template>
                <div
                  class="toolIcon"
                  name="editAttributes"
                  hidden$="{{equal(jobid, '')}}"
                  on-click="selectTool"
                  editing$="[[editingFavoriteTools]]"
                  favorite$="[[isFavoriteTool('editAttributes', favoriteTools.*)]]"
                  on-touchstart="toolMouseDown"
                  on-touchend="toolMouseUp"
                >
                  <paper-ripple noink style="color:#d23f31;"></paper-ripple><iron-icon icon="image:edit" style="color:#d23f31;"></iron-icon
                  ><span>Edit Item</span>
                </div>

                <template
                  is="dom-repeat"
                  items="[[getMapButtons(buttonGroups, mappingButtons, buttonGroup, sandbox.button, readOnlyUser, userHasMobileAssessmentsRole)]]"
                >
                  <div
                    class="toolIcon"
                    name="drawOnMap"
                    data-button$="{{item.id}}"
                    hidden$="{{equal(jobid, '')}}"
                    on-click="selectTool"
                    editing$="[[editingFavoriteTools]]"
                    favorite$="[[isFavoriteTool(item.id, favoriteTools.*)]]"
                    on-touchstart="toolMouseDown"
                    on-touchend="toolMouseUp"
                  >
                    <paper-ripple noink style$="{{getColorStyle(item.color)}}"></paper-ripple
                    ><iron-icon
                      icon="{{getMapDrawButtonIcon(item, mappingButtons, jobMetadata)}}"
                      style$="{{getMapDrawButtonStyle(item, jobMetadata)}}"
                    ></iron-icon
                    ><span>{{item.label}}</span>
                  </div>
                </template>
                <template is="dom-if" if="[[!readOnlyUser]]">
                  <!-- 1/6/2022 Temporarily remove Fix Map Errors from mobile until we can figure out bugs with it -->
                  <!-- <div class="toolIcon" name="fixMapErrors" hidden$="{{equal(jobid, '')}}" on-click="selectTool" editing$="[[editingFavoriteTools]]" favorite$="[[isFavoriteTool('fixMapErrors', favoriteTools.*)]]" on-touchstart="toolMouseDown" on-touchend="toolMouseUp"><paper-ripple noink style="color:#d23f31;"></paper-ripple><iron-icon icon="image:healing" style="color:#FFCC99;"></iron-icon><span>Fix Map Errors</span></div> -->
                  <template is="dom-if" if="[[!userHasMobileAssessmentsRole]]">
                    <div
                      class="toolIcon"
                      name="moveItem"
                      hidden$="{{equal(jobid, '')}}"
                      on-click="selectTool"
                      editing$="[[editingFavoriteTools]]"
                      favorite$="[[isFavoriteTool('moveItem', favoriteTools.*)]]"
                      on-touchstart="toolMouseDown"
                      on-touchend="toolMouseUp"
                    >
                      <paper-ripple noink style="color:#999;"></paper-ripple><iron-icon icon="arrow-forward" style="color:#999;"></iron-icon
                      ><span>Move Item</span>
                    </div>
                  </template>
                </template>
              </div>
              <div style="display: flex; flex-direction: column; gap: 16px;">
                <template is="dom-if" if="[[!editingFavoriteTools]]">
                  <div hidden$="[[!equal(jobid, '')]]" style="color: var(--primary-text-color-faded);">Select a job for more options</div>
                  <div hidden$="[[equal(jobid, '')]]" style="color: var(--primary-text-color-faded);">
                    Long press a tool to add to favorites
                  </div>
                </template>
                <template is="dom-if" if="[[editingFavoriteTools]]">
                  <div>Select tools to add to your favorites</div>
                  <katapult-button color="var(--secondary-color)" on-click="stopEditingFavoriteTools">Done</katapult-button>
                  <katapult-button color="var(--paper-red-500)" on-click="clearAllFavoriteTools">Clear All</katapult-button>
                </template>
              </div>
            </div>
            <div id="topBar">
              <div style="display: flex; flex-basis: 0; flex-grow: 1;">
                <katapult-button
                  id="showSidePanelButton"
                  icon="menu"
                  iconOnly
                  noBorder
                  style="border-radius: 999px;"
                  color="white"
                  on-touchstart="toggleShowSidePanel"
                  on-mousedown="toggleShowSidePanel"
                ></katapult-button>
                <div id="newVersionTag" hidden$="[[!updateAvailable]]">Update</div>
              </div>
              <div style="display: flex; flex-basis: 0; flex-grow: 2; justify-content: center;">
                <connection-state-icon
                  offline="[[_showSyncingNotification]]"
                  error="[[_hasSyncErrors]]"
                  on-click="openOfflineManagement"
                ></connection-state-icon>
                <template is="dom-if" if="[[equal(activeTool, 'jobTimeCollection')]]">
                  <div id="numCollectedContainer" class$="[[getNumCollectedContainerClass(numPoles, numPolesCompleted)]]">
                    <span>[[numPolesCompleted]] of [[numPoles]]</span>
                    <iron-collapse id="completedCollapse" horizontal=""><span style="margin-left: 4px;">Completed</span></iron-collapse>
                  </div>
                </template>
                <template is="dom-if" if="[[showCollectionButton]]">
                  <katapult-button id="collectionButton" on-click="toggleDesign">
                    <div id="collectionButtonStatus" active$="[[designOnly]]"></div>
                    <span>Collect</span>
                  </katapult-button>
                </template>
              </div>
              <div style="display: flex; flex-basis: 0; flex-grow: 1; position: relative;">
                <div style="position: absolute; right: 0px; top: -20px; display: flex; gap: var(--sl-spacing-medium);">
                  <template is="dom-if" if="[[showQuickPhotoCaptureButton]]">
                    <katapult-button
                      style="background-color: white;"
                      iconOnly
                      noBorder
                      icon="photo_camera"
                      on-click="takePhoto"
                    ></katapult-button>
                  </template>
                  <div id="favoriteToolsMenu" style$="max-height: [[getFavoriteToolsMenuMaxHeight()]]">
                    <katapult-button
                      iconOnly
                      noBorder
                      on-touchstart="toggleFavoriteToolsMenu"
                      on-mousedown="toggleFavoriteToolsMenu"
                      config="[[getFavoriteToolsButtonConfig(favoriteToolsMenuOpened, favoriteTools)]]"
                    ></katapult-button>
                    <iron-collapse id="favoriteToolsCollapse" opened="[[favoriteToolsMenuOpened]]">
                      <template
                        is="dom-repeat"
                        items="[[toArray(favoriteTools)]]"
                        filter="[[filterFavoriteTools(mappingButtons, userHasMobileAssessmentsRole)]]"
                      >
                        <katapult-button
                          iconOnly
                          noBorder
                          class="favoriteToolIcon"
                          name$="[[item.tool]]"
                          data-button$="[[item.button_name]]"
                          icon="[[getButtonStyle(item.$key, 'icon', mappingButtons)]]"
                          icon-config="[[_ironIconConfig]]"
                          text-color="[[getButtonStyle(item.$key, 'color', mappingButtons)]]"
                          on-click="selectTool"
                        ></katapult-button>
                      </template>
                    </iron-collapse>
                  </div>
                </div>
              </div>
            </div>
            <div id="sideButtonContainer">
              <template is="dom-if" if="[[!hideMobileZoomControls]]">
                <div id="zoomControls">
                  <katapult-button iconOnly noBorder noBackground icon="add" on-click="zoomControlClick"></katapult-button>
                  <katapult-button iconOnly noBorder noBackground icon="remove" on-click="zoomControlClick"></katapult-button>
                </div>
              </template>
              <template is="dom-if" if="[[!hideMobileCompass]]">
                <mobile-compass id="mapOverlayCompass"></mobile-compass>
              </template>
              <template is="dom-if" if="[[showGPSButton(mapPanned, hideGPSButton)]]">
                <katapult-button id="gpsButton" iconOnly noBorder icon="my_location" on-click="recenterOnGPS"></katapult-button>
              </template>
            </div>
            <div id="mapContainer">
              <template is="dom-if" if="[[!timeSyncLoading]]">
                <template is="dom-if" if="[[!pointerAsCrosshair]]">
                  <!-- This is the main water drop marker for selecting tools -->
                  <div
                    id="waterDrop"
                    on-click="openActiveToolChooser"
                    on-touchstart="dropperTouchStart"
                    on-touchend="dropperTouchEnd"
                    style$="[[getPromptStyle(toolColor, 'waterDrop')]]"
                  >
                    <paper-ripple></paper-ripple>
                    <iron-icon icon="maps:place"></iron-icon>
                  </div>
                  <iron-icon id="waterDropFill" icon="image:brightness-1" style$="[[getPromptStyle(toolColor, 'waterDrop')]]"></iron-icon>
                  <iron-icon id="waterDropIcon" icon="[[toolIcon]]" style$="[[getPromptStyle(toolColor, 'icon')]]"></iron-icon>
                </template>
                <template is="dom-if" if="[[pointerAsCrosshair]]">
                  <div id="crosshair">
                    <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" stroke="white" fill-rule="evenodd" clip-rule="evenodd">
                      <path d="M11 11v-11h1v11h11v1h-11v11h-1v-11h-11v-1h11z"></path>
                    </svg>
                  </div>
                </template>
              </template>
              <load-render-map
                id="loadRenderMap"
                map="[[map]]"
                show-angles-of-node="[[showAnglesOfNode]]"
                conns-to-label="[[connsToLabel]]"
                layers="[[layers]]"
                main-job-id="[[jobid]]"
                map-is-ready="[[googleIsReady]]"
                use-metric-units="[[useMetricUnits]]"
                shrink-done-items=""
                polyline-points="{{polylinePoints.points}}"
                labeled-attributes="{{nodeLabels}}"
                show-span-distances="{{showSpanDistances}}"
                hidden-nodes="[[hiddenNodes]]"
                local-style="[[localStyle]]"
                other-attributes="[[otherAttributes]]"
                label-font-size="{{labelFontSize}}"
              >
              </load-render-map>
              <api-map-layer id="apiMapLayer" map="[[map]]" layers="[[apiMapLayers]]" map-is-ready="[[googleIsReady]]"></api-map-layer>
              <google-map
                id="googlemap"
                map="{{map}}"
                api-channel="[[userGroup]]"
                latitude="{{latitude}}"
                longitude="{{longitude}}"
                zoom="{{zoom}}"
                min-zoom="5"
                max-zoom="30"
                on-google-map-idle="mapIdle"
                no-auto-tilt=""
                map-type="{{maptype}}"
                map-type-ids="{{mapTypeIds}}"
                snap-line="{{snapLine}}"
                snap-length="{{snapLength}}"
                snap-angle="{{snapAngle}}"
                drag-events=""
                on-google-map-initialized="initGoogle"
                on-google-map-api-error="handleGoogleMapApiError"
                on-google-map-drag="mapPan"
                api-key="[[config.mapsApiKey]]"
                additional-map-options="{{getOptions()}}"
                on-touchstart="googlemapTouchstart"
                on-touchmove="googlemapTouchmove"
                tabindex="0"
                styles='[{"featureType":"poi","stylers":[{"visibility":"off"}]},{"featureType":"poi.park","stylers":[{"visibility":"on"}]},{"featureType":"transit","stylers":[{"visibility":"off"}]}]'
              >
                <!-- Map marker that represents the current device's location -->
                <google-map-marker
                  slot="markers"
                  latitude="[[gpsData.latitude]]"
                  longitude="[[gpsData.longitude]]"
                  icon="[[getGPSIcon(gpsData.*)]]"
                ></google-map-marker>
                <google-map-marker id="tempHighlightMarker" slot="markers" icon="[[getSelectedIcon()]]"></google-map-marker>
                <!-- Map marker that represents the halo when a node is hovered over -->
                <google-map-marker
                  slot="markers"
                  z-index="-5"
                  latitude="[[selectedNodeLatitude]]"
                  longitude="[[selectedNodeLongitude]]"
                  icon="[[getSelectedIcon(activeItem)]]"
                  map="[[getSelectedIconVisibility(activeItem, pointerAsCrosshair)]]"
                  drag-events=""
                  click-events=""
                  on-google-map-marker-click="tapNode"
                  on-google-map-marker-drag="dragNode"
                ></google-map-marker>
                <template is="dom-if" if="{{showLineToActive}}" restamp="">
                  <google-map-poly slot="objects" id="rubberband" stroke-color="#FFFF00" stroke-weight="5" stroke-opacity="0.5">
                    <google-map-point latitude$="{{selectedNodeLatitude}}" longitude$="{{selectedNodeLongitude}}"></google-map-point>
                    <google-map-point latitude$="{{latitude}}" longitude$="{{longitude}}"></google-map-point>
                  </google-map-poly>
                </template>
              </google-map>
              <wms-layers
                map="[[map]]"
                user-group="[[userGroup]]"
                map-type-ids="{{mapTypeIds}}"
                map-initialized="[[googleIsReady]]"
                map-base="[[maptype]]"
                layers="[[mapBaseConfigs]]"
              ></wms-layers>
            </div>
            <div id="bottomBar">
              <div opened$="[[showToast]]">
                <div id="toast">
                  <span style="flex-grow: 1; text-align: center;">[[toastText]]</span>
                  <template is="dom-if" if="[[toastButton]]">
                    <katapult-button on-click="toastButtonCallback">[[toastButtonText]]</katapult-button>
                  </template>
                </div>
              </div>

              <div opened$="[[showReadOnlyWarning]]">
                <div id="readOnlyBanner">
                  <span style="flex-grow: 1; text-align: center;">
                    You have read-only access. If you need to make changes, ask the job owner or your company admin to give you write
                    access.
                  </span>
                </div>
              </div>

              <div opened$="[[showButtons]]">
                <div id="actionButtonsContainer">
                  <katapult-button id="secondaryPromptButton" on-click="secondaryPromptTaken" hidden$="{{!secondaryPromptOpen}}">
                    <template is="dom-if" if="{{showSecondaryPromptIcon}}">
                      <iron-icon icon="add"></iron-icon>
                      <iron-icon icon="{{secondaryPromptIcon}}" class="promptIcon" style$="color:{{secondaryPromptIconColor}};"></iron-icon>
                    </template>
                    <span>{{secondaryPromptText}}</span>
                  </katapult-button>
                  <katapult-button
                    id="tertiaryPromptButton"
                    on-click="tertiaryPromptTaken"
                    color="[[tertiaryPromptColor]]"
                    hidden$="{{!tertiaryPromptOpen}}"
                  >
                    <template is="dom-if" if="{{showTertiaryPromptIcon}}">
                      <iron-icon icon="add"></iron-icon>
                      <iron-icon icon="{{tertiaryPromptIcon}}" class="promptIcon" style$="color:{{tertiaryPromptIconColor}};"></iron-icon>
                    </template>
                    <span>{{tertiaryPromptText}}</span>
                  </katapult-button>
                  <katapult-button
                    id="promptButton"
                    on-click="promptTaken"
                    class$="[[activeTool]]"
                    hidden$="{{!promptOpen}}"
                    disabled$="[[promptButtonDisbled]]"
                    style$="[[getPromptStyle(toolColor, 'prompt')]]"
                  >
                    <template is="dom-if" if="{{showPromptIcon}}">
                      <iron-icon icon="add"></iron-icon>
                      <iron-icon icon="{{promptIcon}}" class="promptIcon" style$="color:{{promptIconColor}};"></iron-icon>
                    </template>
                    <span>{{promptText}}</span>
                  </katapult-button>
                </div>
              </div>
            </div>
          </div>
          <release-notes-dialog
            id="releaseNotes"
            uid="[[user.uid]]"
            user-group="[[userGroup]]"
            name="[[config.firebaseData.name]]"
            code-version="[[config.version]]"
            on-release-notes-update="notifyNewVersion"
          ></release-notes-dialog>
          <replace-action-dialog user-group="[[userGroup]]"></replace-action-dialog>
        </div>
      </katapult-auth>
    `;
  }

  static get properties() {
    return {
      connsToLabel: {
        type: Array,
        value: () => {
          return [];
        }
      },
      showAnglesOfNode: {
        type: String,
        value: ''
      },
      defaultCollectionOrderLogic: {
        type: Object,
        computed: 'getDefaultCollectionOrderLogic(modelDefaults)'
      },
      _ironIconConfig: {
        type: Object,
        value: () => ({ type: 'iron-icon' })
      },
      hardcodedButtonStyles: {
        type: Object,
        value: {
          navigateToLocation: {
            color: '#303F9F',
            icon: 'maps:navigation'
          },
          myLocation: {
            color: '',
            icon: 'maps:my-location'
          },
          timeSync: {
            color: '',
            icon: 'image:timer'
          },
          jobTimeCollection: {
            color: '',
            icon: 'image:camera-alt'
          },
          undoTimeBucket: {
            color: '#9e9e9e',
            icon: 'undo'
          },
          editAttributes: {
            color: '#d23f31',
            icon: 'image:edit'
          },
          moveItem: {
            color: '#999',
            icon: 'arrow-forward'
          },
          showGPSData: {
            color: '',
            icon: 'icons:explore'
          }
        }
      },
      numPolesCompleted: {
        type: Number,
        value: 0
      },
      numPoles: {
        type: Number,
        value: 0
      },
      pageStyles: {
        type: Object,
        value: () => ({
          map: { icon: 'maps:map', color: 'var(--paper-teal-900)' },
          photos: { icon: 'image:photo', color: 'var(--paper-blue-500)' },
          upload: { icon: 'file-upload', color: 'var(--paper-deep-purple-500)' },
          dashboard: { icon: 'dashboard', color: 'var(--paper-indigo-500)' },
          search: { icon: 'search', color: '#0F9D59' },
          admin: { icon: 'social:people', color: 'var(--paper-red-600)' },
          'model-editor': { icon: 'settings', color: 'var(--paper-deep-orange-500)' }
        })
      },
      latitude: {
        type: Number,
        value: 40.104681
      },
      longitude: {
        type: Number,
        value: -77.02354
      },
      legendItems: {
        type: Array,
        value: function () {
          return [];
        },
        computed: 'computeLegendItems(jobStyles)'
      },
      submittedFeedback: {
        type: Boolean,
        value: false
      },
      zoom: {
        type: Number,
        value: 18,
        observer: 'zoomChanged'
      },
      pixelScale: {
        type: Number,
        value: 262144 // based on Google Maps' default zoom level (i.e. 2^18)
      },
      autoZoomSkipMidspans: {
        type: Boolean,
        value: false
      },
      contextInfoLoading: {
        type: Boolean,
        value: false
      },
      contextInfoError: {
        type: String,
        value: null
      },
      contextInfo: {
        type: Object,
        value: null
      },
      designOnly: {
        type: Boolean,
        value: true
      },
      googleIsReady: {
        type: Boolean,
        value: false
      },
      selectedMapType: {
        type: String,
        value: 'hybrid',
        observer: 'onSelectedMapTypeChange'
      },
      maptype: {
        type: String,
        value: 'hybrid',
        observer: 'onMapTypeChange'
      },
      mapTypeIds: {
        type: Object
      },
      mapBaseConfigs: {
        type: Object
      },
      prevMapType: {
        type: String,
        value: 'hybrid'
      },
      tilesrc: {
        type: String,
        value: 'ROA'
      },
      tileSrcIds: {
        type: Object,
        value: {
          ROA: 'Roadmap',
          SAT: 'Satellite'
        }
      },
      nullZeroValue: {
        type: String,
        value: () => {
          return null;
        }
      },
      jobid: {
        type: String,
        value: ''
      },
      jobChooserJobId: {
        type: String,
        value: ''
      },
      jobName: {
        type: String
      },
      jobToken: {
        type: String,
        observer: 'updateUrl'
      },
      promptOpen: {
        type: Boolean,
        value: false
      },
      promptText: {
        type: String
      },
      promptButtonDisbled: {
        type: Boolean,
        value: false
      },
      showJobNotAvailableOffline: {
        type: Boolean,
        value: false
      },
      secondaryPromptOpen: {
        type: Boolean,
        value: false
      },
      secondaryPromptText: {
        type: String
      },
      tertiaryPromptOpen: {
        type: Boolean,
        value: false
      },
      tertiaryPromptText: {
        type: String
      },
      showButtons: {
        type: Boolean,
        value: false
      },
      drawerStayOpen: {
        type: Boolean,
        value: false
      },
      toolIcon: {
        type: String,
        value: 'more-horiz'
      },
      buttonGroup: {
        type: String
      },
      buttonGroups: {
        type: Object,
        observer: 'buttonGroupsLoaded'
      },
      buttonGroupKeys: {
        type: Object,
        computed: 'objectKeys(buttonGroups)'
      },
      collectionOrderLogic: {
        type: Object,
        observer: 'collectionLogicLoaded'
      },
      activeButtonModel: {
        type: Object,
        computed: 'of(mappingButtons, activeButton)',
        notify: true
      },
      activeCommand: {
        type: String
      },
      activeTool: {
        type: String,
        observer: 'activeToolChanged'
      },
      activeToolChooserOpen: {
        type: Boolean,
        value: false
      },
      activeItem: {
        type: String,
        value: '',
        observer: 'activeItemChanged'
      },
      pointerAsCrosshair: {
        type: Boolean,
        value: false
      },
      activeItemLocationUpdated: {
        type: Boolean,
        value: false
      },
      useMetricUnits: {
        type: Boolean,
        observer: 'useMetricUnitsChanged'
      },
      useMetricUnitsChecked: {
        type: Boolean,
        observer: 'useMetricUnitsCheckedChanged'
      },
      labelFontSize: {
        type: Number
      },
      soundAndVibrate: {
        type: Boolean,
        value: true
      },
      userGroup: {
        type: String,
        observer: 'userGroupChanged'
      },
      isReviewContractor: {
        type: Boolean
      },
      nodes: {
        type: Object
      },
      hiddenNodes: {
        type: Array,
        value: () => []
      },
      geoJsonLayers: {
        type: Array,
        value: () => []
      },
      apiMapLayers: {
        type: Object,
        value: function () {
          return {};
        }
      },
      stateRoadStyle: {
        type: Object,
        value: function () {
          return {
            1: {
              name: 'State Road',
              color: 'rgba(255, 206, 128, 0.7)'
            },
            2: {
              name: 'Turnpike',
              color: 'rgba(255, 0, 0, 0.7)'
            },
            4: {
              name: 'Non-State Federal Aid Road',
              color: 'rgba(100, 165, 165, 0.7)'
            },
            5: {
              name: 'Local Road',
              color: 'rgba(244, 221, 255, 0.7)'
            },
            6: {
              name: 'Toll Bridge',
              color: 'rgba(122, 245, 0, 0.7)'
            }
          };
        }
      },
      savedKeys: {
        type: Array,
        value: function () {
          return [
            { key: 'latitude' },
            { key: 'longitude' },
            { key: 'zoom' },
            { key: 'maptype', default: 'hybrid' },
            { key: 'geoJsonLayers' },
            { key: 'prevMapType' },
            { key: 'buttonGroup' },
            { key: 'checklistAutoZoom' },
            { key: 'autoZoomSkipMidspans' },
            { key: 'soundAndVibrate' },
            { key: 'nodeLabels' },
            { key: 'centerMapOnGPS' },
            { key: 'logGPSToJob' },
            { key: 'hideMobileZoomControls' },
            { key: 'hideMobileCompass' },
            { key: 'hideGPSButton' },
            { key: 'showAccuracyRing' },
            { key: 'favoriteToolsMenuOpened' },
            { key: 'debugMode' },
            { key: 'superZoom' },
            { key: 'laserGate' },
            { key: 'savedViewsSetLabels' },
            { key: 'showSpanDistances' }
          ];
        }
      },
      laserGate: {
        type: Number,
        value: 1
      },
      nodeLabels: {
        type: Object,
        value: function () {
          return {};
        }
      },
      gpsData: {
        type: Object,
        value: {
          _connected: false,
          _accurate: false
        }
      },

      nodeStyle: {
        type: Object,
        computed: 'computeNodeStyle(modelDefaults)'
      },

      lineStyles: {
        type: Object,
        value: () => {
          return {
            'aerial cable': '#00FF00',
            overlash: '#0055ff',
            'slack span': '#ffff00',
            'overhead guy': '#ffaa00',
            'pole to pole guy': '#005500',
            'underground cable': '#ff0000',
            reference: '#ff00ff',
            'down guy': '#ffaaff',
            pushbrace: '#0000ff',
            misc: '#aa00ff',
            //katapult ref types
            'power reference': '#800080',
            'guy reference': '#FF99FF',
            //bechtel-atl conn sub types
            'distribution fiber': 'red',
            'access fiber': 'blue',
            strand: 'yellow',
            'drop fiber': 'indigo',
            //washington_broadband conn sub types
            trunk: '#00FF00',
            distribution: 'red',
            fiber: 'cyan',
            drop: 'gray'
          };
        }
      },

      activeItemTypes: {
        type: Object,
        value: () => {
          return {
            n: 'nodes',
            c: 'connections',
            s: 'sections'
          };
        }
      },

      debugMode: {
        type: Boolean,
        value: false
      },
      superZoom: {
        type: Boolean,
        value: false
      },
      showUninspectedPoles: {
        type: Boolean,
        value: false
      },
      savedViewsSetLabels: {
        type: Boolean,
        value: false
      },
      filteredMapLayers: {
        type: Array,
        value: () => []
      },
      mapLayers: {
        type: Object,
        value: () => {}
      },
      mobileConsole: {
        type: Array,
        value: []
      },
      layerReferenceJobName: {
        type: String,
        value: false
      },
      jobLayers: {
        type: Object,
        value: {}
      },
      showReadOnlyWarning: {
        type: Boolean,
        computed: 'computeShowReadOnlyWarning(sharing, readOnlyUser, jobid)',
        observer: 'showReadOnlyWarningChanged'
      },
      disableJobCreation: {
        type: Boolean,
        computed: 'computeDisableJobCreation(readOnlyUser, userHasMobileAssessmentsRole)'
      },
      modelDefaults: {
        type: Object,
        computed: 'computeModelDefaults(configDefaults, otherAttributes)',
        value: () => ModelDefaults()
      },
      currentVersionName: {
        type: String
      },
      isNewVersion: {
        type: Boolean,
        value: false
      },
      savedViews: {
        type: Object,
        value: {}
      },
      savedViewsArray: {
        type: Array,
        computed: 'toArray(savedViews)'
      },
      activeSavedView: {
        type: String,
        observer: 'loadSavedView'
      },
      enabledFeatures: {
        type: Object,
        value: () => ({})
      },
      updateAvailable: {
        type: Boolean,
        value: false
      },
      loadedImageOverlays: {
        type: Object,
        value: {}
      }
    };
  }

  static get observers() {
    return [
      'jobLayersChanged(jobLayers.*)',
      'mapLayersChanged(mapLayers.*, isReviewContractor, userGroup)',
      'updateShowCollectionButton(userHasMobileAssessmentsRole, activeTool)',
      'nodesLoaded(nodes.*)',
      'zoomToJob(shouldZoomToJob, nodesAreLoaded, googleIsReady)',
      'getPoleCounts(nodes.*, modelDefaults)',
      'showPolesCompleted(numPolesCompleted)',
      'followUserLocationOnMap(centerMapOnGPS, gpsData.latitude, gpsData.longitude, mapPanned)',
      'getSelectedLocation(activeItem, activeItemLocationUpdated)',
      'jobFilesUpdated(jobFiles, jobFiles.*)',
      'setDefaultLabels(modelConfig.default_labels)',
      'formatName(jobMetadata)',
      'resolveAppTypeDisplayName(jobMetadata.app_type, jobCreator)',
      'checkForOldApp(jobName)',
      'updateLayers(jobid, timeSyncPauseAppLoading)',
      'preferencesChanged(preferences.*)',
      'calcCollectionOrderLogic(defaultCollectionOrderLogic, firebaseCollectionOrderLogic)',
      'checkUserFunctionResponses(user.uid)',
      'savedViewsChanged(savedViews, mapLayers)',
      'geoJsonLayersChanged(geoJsonLayers)',
      'refreshAllLayerItemStates(geoJsonLayers.*, apiMapLayers.*)',
      '_uploadQueuedJobPhotos(jobid)',
      '_updateJobPhotoUploadListener(jobid)',
      '_updateJobUpdateProgressListener(jobid)',
      'setUpActiveJobForOfflineUse(jobChooserJobId, signedIn)',
      'jobIdChanged(jobid)',
      '_updateJobSyncStatus(jobid, _jobUpdateProgress, _jobUploadProgress, _offlineJobs)',
      'clearUserPreferenceForServiceWorker(appIsOfflineReady)'
    ];
  }

  static get importMeta() {
    return import.meta;
  }

  constructor() {
    super();

    // Set property defaults
    this.currentVersionName = getVersionNameFromOrigin();
    this.updateAvailable = false;

    // The service worker will never be installed if this is a development origin so it should always be offline ready in this case
    const isDevelopmentOrigin = checkIsDevelopmentOrigin();
    this.appIsOfflineReady = isDevelopmentOrigin === true;

    // Template helpers.
    this.getFavoriteToolsButtonConfig = (isOpened, favoriteTools) => ({
      textColor: isOpened
        ? 'var(--paper-grey-800)'
        : Object.entries(favoriteTools ?? {}).length == 0
          ? 'var(--paper-grey-500)'
          : 'var(--paper-amber-500)',
      color: isOpened ? 'var(--paper-grey-200)' : '#fff',
      icon: isOpened ? 'keyboard_arrow_up' : 'star'
    });
  }

  connectedCallback() {
    super.connectedCallback();

    this.pciMidspansFlagListener = addFlagListener('pci_midspans', (enabled) => {
      this.set('enabledFeatures.pci_midspans', enabled);
    });
    this.showPolesThatNeedInspectionMobileFlagListener = addFlagListener('show_poles_that_need_inspection_mobile', (enabled) => {
      this.set('enabledFeatures.show_poles_that_need_inspection_mobile', enabled);
    });
    this.logGpsToJobFlagListener = addFlagListener('log_gps_to_job', (enabled) => {
      this.set('enabledFeatures.log_gps_to_job', enabled);
    });

    this.setupOnlineListener();
    this.initWindowFocusListener();
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    removeFlagListener('pci_midspans', this.pciMidspansFlagListener);
    removeFlagListener('show_poles_that_need_inspection_mobile', this.showPolesThatNeedInspectionMobileFlagListener);
    removeFlagListener('log_gps_to_job', this.logGpsToJobFlagListener);

    this.disconnectOnlineListener();

    this._destroyWindowFocusListener?.();
  }

  ready() {
    // This variable tells us to ignore when the job chooser id is set on the initial load
    this.ignoreJobChooserInitialSet = true;

    super.ready();
    this.toggleDebugConsole();

    this.addEventListener('item-done', this.checkForAndRunDoneCollectionTasks);

    addListener(this.$.sidePanel, 'track', this.sidePanelTrack.bind(this));
    // Let browser handle vertical scrolling and zoom
    setTouchAction(this.$.sidePanel, 'pan-y pinch-zoom');

    // Set up the service worker
    const { updateAndReload } = initializeServiceWorker({
      onUpdateReady: () => (this.updateAvailable = true),
      onOfflineReady: () => (this.appIsOfflineReady = true)
    });
    this.updateAndReload = updateAndReload;

    // Mark the app offline ready once an active service worker is in place.
    navigator.serviceWorker?.ready.then(() => (this.appIsOfflineReady = true));

    FirebaseWorker.onChange('indexedDBConnectionError', (notify) => {
      if (notify) {
        // attempt to send an email to our developers
        firebase
          .functions()
          .httpsCallable('email')({
            template: 'indexedDBConnectionError',
            uid: this.user.uid,
            userGroup: this.userGroup,
            jobId: this.jobid,
            userAgent: navigator.userAgent
          })
          .catch((error) => {
            console.error('Failed to send email', error);
          });
      }
    });

    this.appConfiguration = new AppConfiguration(this);

    this.editingFavoriteTools = false;
    this.favoriteToolsMenuOpened = false;
    this.buttonLock = false;

    this.addEventListener('touchmove', this.preventPullDownRefresh, { passive: true });
    this.addEventListener('touchstart', this.preventPullDownRefresh, { passive: true });

    var hash = decodeURI(window.location.hash.substring(1));
    //:latitude?/:longitude?/:zoom?/:maptype?/:jobid?
    var hashParts = hash.split('/');
    if (hashParts[0] == '!') hashParts.pop();
    if (hashParts[0] == 'mobile') hashParts.pop();
    if (hashParts[0].search(/^[\w\-]{20}$/) == 0 || hashParts[0] == 'covid-19') {
      this.jobChooserJobId = hashParts[0];
      // If the hash is for a sandbox
    } else if (hashParts[0].indexOf('sandbox') >= 0) {
      this.jobChooserJobId = hashParts[0];
      this.sandbox = {};
      let queryString = new URLSearchParams(window.location.search);
      // Button test
      if (queryString.has('button')) {
        this.set('sandbox.button', queryString.get('button'));
        this.set('timeSyncDisabled', true);
      }
    }

    this.saveLocation = Throttle(() => {
      if (this.user && this.userGroup) {
        let update = {};
        let ref = FirebaseWorker.ref('photoheight');
        this.geo.update(
          '/company_space/' + this.userGroup + '/avatars/map/' + this.user.uid,
          [this.gpsData.latitude, this.gpsData.longitude],
          { job_name: this.jobName || 'No Job Selected', lastLog: { '.sv': 'timestamp' }, email: this.user.email, virtual: false },
          10,
          update
        );
        if (this.enabledFeatures.log_gps_to_job && this.logGPSToJob && this.jobid) {
          this.geo.update(
            'jobs/' + this.jobid + '/gps_logs/' + ref.push().key,
            [this.gpsData.latitude, this.gpsData.longitude],
            { time: new Date().getTime(), uid: this.user.uid },
            10,
            update
          );
        }
        ref.update(update, (e) => {
          if (e) console.log('error', e);
        });
      }
    }, 5000);

    // Init
    this.$.googlemap.$.map.addEventListener('mousewheel', this.googleMouseWheel.bind(this), { capture: true, passive: true });
    if (!navigator.onLine) {
      this.maptype = 'blank';
    }

    /*
     * When the tab is first loaded, we need to setup the view.  Here are the conditions we want to check and the order that they are currently checked in:
     * 1. If this is not the first time the tab has been loaded and there were location values saved from the last load (sessionStorage), we want our view to match those values and skip the other steps.
     * 2. If the current job has a default saved view and this is the first time the tab is loaded, we want to match the current view with the settings of the default saved view and skip the other steps.
     * 3. If there are no default saved views for the job and this is the first time the tab has been loaded, we want to zoom to the job's coordinates and skip the other steps.
     */

    this.savedKeys.forEach((item) => {
      try {
        let val = JSON.parse(sessionStorage.getItem('mobileMaps:' + item.key));
        if (val != null && !this.jobIdAlreadyChanged) {
          // facilitates the first step of the comment above
          this.settingsLoadedFromSession = true;
          this.applySetting(item.key, val);
        }
      } catch (e) {}
      this._createMethodObserver(`saveSettings('${item.key}', ${item.key}, ${item.key}.*)`);
    });

    this.getInternalGPSData(true);

    this.ignoreJobChooserInitialSet = false;

    globalThis.FirebaseWorker.listenToOfflineJobs((offlineJobs) => {
      this._offlineJobs = offlineJobs;
    });
    this._showSyncingNotification = false;
    setInterval(() => {
      // Wait 60 seconds after we begin syncing before showing the syncing notification.
      const syncingDelay = 60_000;
      // We have "unsynced changes" if we have had unsynced changes for more than unsyncedDelay.
      const hasBeenSyncingForAWhile =
        this.jobid &&
        !this._jobIsFullySynced &&
        (this._timeLastFullySynced == null || Date.now() - this._timeLastFullySynced > syncingDelay);
      // Show the syncing notification if we have been syncing for more
      this._showSyncingNotification = hasBeenSyncingForAWhile;
    }, 1_000);
  }

  toastIfActiveJobAddedToOfflineJobs() {
    const currentJobId = this.jobid;
    if (!currentJobId) return;

    const offlineJobDetails = (this._offlineJobs ?? []).find((job) => job.jobId === currentJobId);
    if (!offlineJobDetails) return;

    const jobSetupForOfflineUseAt = this._activeJobSetupForOfflineUseAt;
    if (!jobSetupForOfflineUseAt) return;

    const offlineJobAddedSinceJobSetupForOfflineUse = offlineJobDetails.addedAt >= jobSetupForOfflineUseAt;
    if (!offlineJobAddedSinceJobSetupForOfflineUse) return;

    // See if we have already toasted this job.
    if (!this._activeJobsToasted) this._activeJobsToasted = {};
    const jobAlreadyToasted = this._activeJobsToasted[currentJobId] === true;
    if (jobAlreadyToasted) return;

    // If we haven't toasted this job yet, toast it now and mark it as toasted.
    this._activeJobsToasted[currentJobId] = true;

    showToast(
      {
        variant: 'primary',
        content: litHtml`
          <katapult-icon slot="icon" icon="cloud_done"></katapult-icon>
          <div style="display: flex; flex-direction: column; align-items: center; gap: var(--sl-spacing-x-small);">
            <span>
              <span style="font-weight: var(--sl-font-weight-semibold); color: var(--sl-color-neutral-800);">${offlineJobDetails.name}</span>
              <span> added to </span>
              <span style="font-weight: var(--sl-font-weight-bold); color: var(--sl-color-primary);">Offline Management</span>
            </span>
            ${this.appIsOfflineReady ? '' : litHtml`<sl-tag variant="danger" size="small">Not Ready for Offline Use</sl-tag>`}
          </div>
        `,
        onClick: () => this.openOfflineManagement()
      },
      'top'
    );
  }

  /**
   * If the app is not offline ready, you are online, and you are signed in, refresh the page to start the service worker install
   * Check every 30 seconds to if the service worker is ready and if it's not, refresh the page to try to kick off the install again.
   */
  facilitateAutoRefreshToInstallServiceWorker() {
    // If the app is already offline ready, we don't need to refresh to install the service worker
    // If we're currently on a development origin, the service worker never needs to be installed
    const isDevelopmentOrigin = checkIsDevelopmentOrigin();
    const useAppWithoutServiceWorker = sessionStorage.getItem('useAppWithoutServiceWorker') === 'true';
    if (this.appIsOfflineReady || isDevelopmentOrigin || useAppWithoutServiceWorker) return;

    // Reload the window the first time the user signs in, is online, and there is no service worker installed.  Only do this once to kick off the install.
    const kickOffServiceWorkerInstall = sessionStorage.getItem('kickedOffServiceWorkerInstall') !== 'true';
    if (kickOffServiceWorkerInstall) {
      sessionStorage.setItem('kickedOffServiceWorkerInstall', 'true');
      // Reload the window once to kick off the install
      window.location.reload();
      return;
    }

    // If we've made it here, the page has been refreshed once and the service worker is hopefully trying to install.

    // Start a timer to track how long it's taking for the service worker to install and do things if it takes too long
    const intervalId = setInterval(() => {
      // If the app is offline ready, we can clear the interval and stop checking for the service worker install
      if (this.appIsOfflineReady) {
        clearInterval(intervalId);
        return;
      }

      // Set the install time and increment it every second
      if (this.serviceWorkerInstallTime == null) this.serviceWorkerInstallTime = 0;
      this.serviceWorkerInstallTime += 1;

      // If the service worker has taken 1/3 the max time, give the users the option to use the app offline
      if (this.serviceWorkerInstallTime === Math.ceil(WAIT_TIME_FOR_SERVICE_WORKER_INSTALL / 3)) this.showOptionToOnlyWorkOnline = true;

      // If the service worker has taken 30 seconds to install, auto-refresh the page to try to kick off the install again and log the retry to posthog
      if (this.serviceWorkerInstallTime === WAIT_TIME_FOR_SERVICE_WORKER_INSTALL) {
        posthog.capture('retry_service_worker_install');
        window.location.reload();
      }
    }, 1000);
  }

  clearUserPreferenceForServiceWorker() {
    if (!this.appIsOfflineReady) return;

    sessionStorage.removeItem('useAppWithoutServiceWorker');
    sessionStorage.removeItem('kickedOffServiceWorkerInstall');
  }

  getServiceWorkerInstallSecondsRemaining() {
    return Math.max(WAIT_TIME_FOR_SERVICE_WORKER_INSTALL - this.serviceWorkerInstallTime, 0);
  }

  retryServiceWorkerInstallation() {
    window.location.reload();
  }

  continueWithoutServiceWorker() {
    // Set the user's choice in session storage, log the choice to posthog, and reload the page to continue without the service worker
    sessionStorage.setItem('useAppWithoutServiceWorker', 'true');
    posthog.capture('user_continued_without_service_worker');
    window.location.reload();
  }

  showInitializingOverlay() {
    // Show the overlay if the app is not offline ready and the user has not chosen to continue without the service worker
    const useAppWithoutServiceWorker = sessionStorage.getItem('useAppWithoutServiceWorker') === 'true';
    return !this.appIsOfflineReady && !useAppWithoutServiceWorker;
  }

  setupOnlineListener() {
    this._onlineCallback = firebase
      .database()
      .ref('.info/connected')
      .on('value', (s) => {
        this.online = s.val() === true;
      });
  }

  disconnectOnlineListener() {
    if (!this._onlineCallback) return;
    firebase.database().ref('.info/connected').off('value', this._onlineCallback);
    this._onlineCallback = null;
  }

  initWindowFocusListener() {
    this._destroyWindowFocusListener?.();

    const callback = (event) => {
      globalThis.FirebaseWorker.refreshOfflineJobs();
      globalThis.FirebaseWorker.refreshUnsavedChangesProgress();
      refreshPhotoUploadProgress();
    };
    window.addEventListener('focus', callback);

    this._destroyWindowFocusListener = () => {
      window.removeEventListener('focus', callback);
      this._destroyWindowFocusListener = null;
    };
  }

  _updateJobSyncStatus() {
    const offlineJobs = Array.isArray(this._offlineJobs) ? this._offlineJobs : [];
    const offlineJobDetails = offlineJobs.find((job) => job.jobId === this.jobid);
    const hasMostRecentJobData = offlineJobDetails?.synced === true;
    const allChangesSavedSuccessfully = this._jobUpdateProgress?.complete === true && this._jobUpdateProgress?.failed !== true;
    const allPhotosUploadedSuccessfully = this._jobUploadProgress?.complete === true && this._jobUploadProgress?.failed !== true;

    this._jobIsFullySynced = hasMostRecentJobData && allChangesSavedSuccessfully && allPhotosUploadedSuccessfully;

    const timestamps = [];
    if (offlineJobDetails?.outOfSyncAt) timestamps.push(offlineJobDetails.outOfSyncAt);
    if (this._jobUpdateProgress?.incompleteAt) timestamps.push(this._jobUpdateProgress.incompleteAt);
    if (this._jobUploadProgress?.incompleteAt) timestamps.push(this._jobUploadProgress.incompleteAt);
    const oldestTimestamp = timestamps.length ? Math.min(...timestamps) : null;
    this._timeLastFullySynced = oldestTimestamp;

    this._hasSyncErrors = this._jobUpdateProgress?.failed === true || this._jobUploadProgress?.failed === true;
  }

  _uploadQueuedJobPhotos() {
    if (!this.jobid) return;
    uploadQueuedJobPhotos(this.jobid).catch((error) => {
      console.error('Failed to upload one or more queued photos.', error);
      showPhotoUploadErrorToast(error);
    });
  }

  _updateJobPhotoUploadListener() {
    this._disconnectJobPhotoUploadListener?.();

    if (!this.jobid) return;

    const disconnect = listenToUploadEventsForJob(this.jobid, (jobUploadProgress) => {
      this._jobUploadProgress = jobUploadProgress;
      this._updateShouldShowPhotoUploadProgressDialog();
    });

    this._disconnectJobPhotoUploadListener = () => {
      disconnect();
      this._jobUploadProgress = null;
      this._disconnectJobPhotoUploadListener = null;
    };
  }

  _updateShouldShowPhotoUploadProgressDialog() {
    // Determine if photos are currently being uploaded.
    const jobUploadProgress = this._jobUploadProgress;
    const uploadingPhotos = jobUploadProgress?.numPhotos > 0 && !jobUploadProgress?.complete;

    // If they are, show the progress dialog.
    if (uploadingPhotos) {
      if (this._hidePhotoUploadProgressDialogTimeoutId) clearTimeout(this._hidePhotoUploadProgressDialogTimeoutId);
      this._showPhotoUploadProgressDialog = true;
    }
    // Otherwise, if we don't have an existing 5s countdown to hide the dialog, start one.
    else if (this._hidePhotoUploadProgressDialogTimeoutId == null) {
      this._hidePhotoUploadProgressDialogTimeoutId = setTimeout(() => {
        this._showPhotoUploadProgressDialog = false;
        this._hidePhotoUploadProgressDialogTimeoutId = null;
      }, 5_000);
    }
  }

  _updateJobUpdateProgressListener() {
    this._disconnectJobUpdateProgressListener?.();

    if (!this.jobid) return;

    const disconnect = globalThis.FirebaseWorker.listenToUpdateProgressForJob(this.jobid, (jobUpdateProgress) => {
      this._jobUpdateProgress = jobUpdateProgress;
    });

    this._disconnectJobUpdateProgressListener = () => {
      disconnect();
      this._jobUpdateProgress = null;
      this._disconnectJobUpdateProgressListener = null;
    };
  }

  getUploadProgressBarColor(progress) {
    return progress == 100 ? 'var(--sl-color-success-500)' : 'var(--secondary-color)';
  }

  getProgressLabel(numPhotosUploaded, numPhotos) {
    return `${numPhotosUploaded || 0} / ${numPhotos || 0}`;
  }

  async checkUserFunctionResponses() {
    // Check to see if there are any responses to user requested functions and if so display the response to the user
    if (this.user?.uid) {
      let userFunctionResponses = await FirebaseWorker.ref(`photoheight/server_requests/user_requests/${this.user.uid}/responses`)
        .once('value')
        .then((s) => s.val());

      for (let key in userFunctionResponses) {
        let response = userFunctionResponses[key];

        if (response.message && response.success != null) {
          // Display the response message to the user
          if (response.success) {
            this.toast(response.message);
          } else {
            this.toast(`Error: ${response.message}`);
          }
          // Delete the response from Firebase
          FirebaseWorker.ref(`photoheight/server_requests/user_requests/${this.user.uid}/responses/${key}`).remove();
          // wait before showing the user the next response
          await new Promise((resolve) => setTimeout(resolve, 3500));
        }
      }
    }
  }

  calcCollectionOrderLogic() {
    this.collectionOrderLogic = !Path.valueIsEmpty(this.firebaseCollectionOrderLogic)
      ? this.firebaseCollectionOrderLogic
      : this.defaultCollectionOrderLogic;
  }

  computeModelDefaults(configDefaults, otherAttributes) {
    return ModelDefaults(configDefaults, otherAttributes);
  }

  geoJsonLayersChanged() {
    // for some reason, having geoJsonLayers bound to an observer makes things wait just long enough to the layers to be loaded
    // TODO: Fix timing on load for layers on mobile
  }

  savedViewsChanged() {
    if (this.savedViews) {
      if (this.activeSavedView == null || this.mapLayers) {
        for (let key in this.savedViews) {
          if (this.savedViews[key].default) {
            this.activeSavedView = key;
            // we need to manually run the loadSavedView if mapLayers exist because sometimes the map layers get loaded after the savedView has already been set
            if (this.mapLayers && this.activeSavedView == key) this.loadSavedView(key);
            return;
          }
        }
      }
    }
  }

  loadSavedView(view) {
    if (view) {
      if (this.settingsLoadedFromSession) {
        // don't apply the saved view if it doesn't match the current view
        // we should apply it if it does to turn on all layers
        this.settingsLoadedFromSession = null;
        if (!this.matchesCurrentView(view)) {
          this.activeSavedView = null;
          return;
        }
      }
      let settings = this.savedViews?.[view]?.settings;
      if (settings) {
        for (let key in settings) {
          this.applySetting(key, Path.copy(settings[key]));
        }
        this.savedKeys.forEach((item) => {
          if (settings[item.key] === undefined && item.default !== undefined) {
            this.applySetting(item.key, item.default);
          }
        });
      }
    }
  }

  matchesCurrentView(viewId) {
    // attributes are called different things /  used different in mobile vs desktop so we need these lines of code to allow some differences
    let mobileSettingsMapping = {
      maptype: 'mapBase'
    };
    let attributesToSkip = ['nodeLabels'];

    let viewSettings = this.savedViews?.[viewId]?.settings;
    let matchesKeys = this.savedKeys.every((item) => {
      if (['latitude', 'longitude', 'zoom'].includes(item.key) && viewSettings[item.key] == null) return true;
      let setting;
      // if there's an equivalent mobile attribute mapping for the current attribute, use that.
      if (mobileSettingsMapping[item.key]) setting = viewSettings[mobileSettingsMapping[item.key]];
      else setting = viewSettings[item.key];
      // skip matching on settings that aren't in the savedView settings or that aren't supported in mobile
      if (setting === undefined || attributesToSkip.includes(item.key)) return true;
      else {
        let value = this[item.key];
        if (item.key == 'latitude' || item.key == 'longitude') {
          setting = Round(setting, 7);
          value = Round(value, 7);
        }
        return this.settingMatches(setting, value);
      }
    });
    if (viewSettings.activeItem != null && viewSettings.activeItem != this.activeItem) {
      matchesKeys = false;
    }
    return matchesKeys;
  }

  settingMatches(setting1, setting2) {
    return (Path.valueIsEmpty(setting1) && Path.valueIsEmpty(setting2)) || JSON.stringify(setting1) == JSON.stringify(setting2);
  }

  async applySetting(key, value) {
    // This was copied from katapult-maps-desktop so not all of the settings for a saved view are able to be configured currently
    // TODO (4/14/2023):  Add all of the other functionality for savedViews to mobile when needed
    if ((key == 'showSpanDistances' || key == 'nodeLabels') && !this.settingsLoadedFromSession) {
      // Only turn on the span distances and node labels if we have the savedViewsSetLabels preference set
      if (this.savedViewsSetLabels) this.set(key, value);
    } else if (key == 'turnOnAllLayers') {
      this.toggleAllMapLayers({ currentTarget: { checked: true } });
    } else if (key == 'geoJsonLayers') {
      value.forEach((layerKey) => {
        this.toggleMapLayer({ key: layerKey }, true);
      });
    } else {
      if (key == 'latitude' || key == 'longitude' || key == 'zoom') this.shouldZoomToJob = false;
      this.set(key, value);
    }
  }

  toggleSetting(e) {
    if (!this.user || !this.userGroup) return;

    // Set the setting locally
    const settingId = e.currentTarget.getAttribute('name');
    this[settingId] = !this[settingId];

    // Set the setting in the database
    const userSettingRef = FirebaseWorker.ref(`photoheight/company_space/${this.userGroup}/user_data/${this.user.uid}/preferences`);
    userSettingRef.child(settingId).set(this[settingId]);

    // If the setting is centerOnZoom, also turn off the "Hide GPS Button" setting because the center map on gps is broken without it
    if (settingId == 'centerMapOnGPS' && this.centerMapOnGPS) {
      this.hideGPSButton = false;
      userSettingRef.child('hideGPSButton').set(false);
    }
  }

  highlightInspectedPoles() {
    // This function builds a list of nodes to hide that are fielded already or are not part of the current job,
    // then adds halo styling to all remaining nodes
    let tempHiddenNodes = [];
    let localStyleWithHalo = structuredClone(this.jobStyles);
    if (this.showUninspectedPoles) {
      localStyleWithHalo.default.nodes.unshift({
        attribute: 'survey_plan',
        comparator: 'equals',
        value: 'Survey in this job',
        stackable: true,
        color: '#FFFF00',
        icon: 'image:panorama-fish-eye',
        size: 24.5
      });
      for (const nodeId in this.nodes) {
        const node = this.nodes[nodeId];
        const fielded = PickAnAttribute(node.attributes, 'field_completed');
        const surveyPlan = PickAnAttribute(node.attributes, 'survey_plan');
        if (fielded || surveyPlan != 'Survey in this job') tempHiddenNodes.push(nodeId);
      }
    }
    // Update hidden nodes and local style
    this.hiddenNodes = tempHiddenNodes;
    this.localStyle = localStyleWithHalo;
  }

  preferencesChanged() {
    if (this.preferences) {
      let settings = [
        'checklistAutoZoom',
        'autoZoomSkipMidspans',
        'soundAndVibrate',
        'centerMapOnGPS',
        'logGPSToJob',
        'hideMobileZoomControls',
        'hideMobileCompass',
        'hideGPSButton',
        'showSpanDistances',
        'debugMode',
        'superZoom',
        'savedViewsSetLabels',
        'quickPhotoCapture'
      ];
      settings.forEach((setting) => {
        if (this.preferences.hasOwnProperty(setting)) {
          this[setting] = this.preferences[setting];
        }
      });
    }
  }

  toggleDebugConsole() {
    this.consoleSwitcherDebouncer = Debouncer.debounce(this.consoleSwitcherDebouncer, timeOut.after(200), () => {
      if (this.debugMode) {
        var originalConsole = window.console;
        window.console = {
          error: function () {
            let error = {
              text: arguments['0'],
              type: 'error'
            };
            this.push('mobileConsole', error);
            originalConsole.error.apply(originalConsole, arguments);
            setTimeout(() => {
              this.$.debuggingLog.notifyResize();
            });
          }.bind(this),

          log: function () {
            let log = {
              text: arguments['0'],
              type: 'log'
            };
            this.push('mobileConsole', log);
            originalConsole.log.apply(originalConsole, arguments);
            setTimeout(() => {
              this.$.debuggingLog.notifyResize();
            });
          }.bind(this),

          warn: function () {
            let warn = {
              text: arguments['0'],
              type: 'warn'
            };
            this.push('mobileConsole', warn);
            originalConsole.warn.apply(originalConsole, arguments);
            setTimeout(() => {
              this.$.debuggingLog.notifyResize();
            });
          }.bind(this),

          info: function () {
            let info = {
              text: arguments['0'],
              type: 'info'
            };
            this.push('mobileConsole', info);
            originalConsole.info.apply(originalConsole, arguments);
            setTimeout(() => {
              this.$.debuggingLog.notifyResize();
            });
          }.bind(this),

          debug: function () {
            let debug = {
              text: arguments['0'],
              type: 'debug'
            };
            this.push('mobileConsole', debug);
            originalConsole.debug.apply(originalConsole, arguments);
            setTimeout(() => {
              this.$.debuggingLog.notifyResize();
            });
          }.bind(this),

          getOriginalConsole: function () {
            return originalConsole;
          },

          trace: console.trace
        };
      } else {
        try {
          window.console = console.getOriginalConsole();
        } catch (e) {}
      }
    });
  }

  openFullscreenPhoto(e) {
    import('../katapult-photo/katapult-photo-viewer.js');
    let openingEventData = e.detail;
    let photoId = openingEventData.photoId ?? openingEventData.currentTarget.photoId;
    if (photoId) {
      this.$.fullscreenPhotoViewer.photoId = photoId;
    } else if (openingEventData.detail.url) {
      this.$.fullscreenPhotoViewer.src = openingEventData.detail.url;
    }
    this.$.fullscreenPhoto.setAttribute('opened', true);
  }

  closeFullscreenPhoto() {
    this.$.fullscreenPhoto.removeAttribute('opened');
    this.$.fullscreenPhotoViewer.photoId = null;
    this.$.fullscreenPhotoViewer.src = null;
  }

  getLogIcon(type) {
    if (type == 'warn') {
      return 'icons:error';
    } else if (type == 'error') {
      return 'icons:cancel';
    }
  }

  getSelectedLocation(activeItem, activeItemLocationUpdated, tryCount) {
    tryCount = tryCount || 0;
    if (activeItem != null && (activeItem[0] == 'n' || activeItem[0] == 's') && tryCount < 20) {
      let location = this.getActiveItemLocation();
      if (location) {
        this.selectedNodeLatitude = location[0];
        this.selectedNodeLongitude = location[1];
      } else {
        setTimeout(() => this.getSelectedLocation(this.activeItem, this.activeItemLocationUpdated, ++tryCount), 50);
      }
    } else {
      this.selectedNodeLatitude = null;
      this.selectedNodeLongitude = null;
    }
  }

  // sidePanelTouchStart(e) {
  //   this.sidePanelDragStart = {x: e.targetTouches[0].clientX, y: e.targetTouches[0].clientY};
  //   this.sidePanelOffsetLeft = this.$.sidePanel.offsetLeft;
  //   this.sidePanelOffsetWidth = this.$.sidePanel.offsetWidth;
  //   this.sidePanelLastDrag = {x: e.targetTouches[0].clientX, y: e.targetTouches[0].clientY, timeStamp: e.timeStamp};
  //   this.sidePanelTouch = true;
  // }

  // sidePanelTouchMove(e) {
  //   if (this.sidePanelTouch) {
  //     this.sidePanelDragging = true;
  //     this.$.sidePanel.setAttribute('dragging', true);
  //     this.sidePanelVelocity = (e.targetTouches[0].clientX - this.sidePanelLastDrag.x) / (e.timeStamp - this.sidePanelLastDrag.timeStamp) * 1000;
  //     this.sidePanelDragOffset = e.targetTouches[0].clientX - this.sidePanelDragStart.x;
  //     this.sidePanelLastDrag = {x: e.targetTouches[0].clientX, y: e.targetTouches[0].clientY, timeStamp: e.timeStamp};
  //     this.sidePanelLeft = Clamp(this.sidePanelOffsetLeft + this.sidePanelDragOffset, -this.sidePanelOffsetWidth, 0);
  //     this.$.sidePanel.style.left =  this.sidePanelLeft + 'px';
  //   }
  // }

  // sidePanelTouchEnd(e) {
  //   if (this.sidePanelDragging) {
  //     this.$.sidePanel.removeAttribute('dragging');
  //     this.$.sidePanel.style.left = null;
  //     this.showSidePanel = -this.sidePanelLeft < this.sidePanelOffsetWidth / 2 && this.sidePanelVelocity > -200;
  //   }
  //   this.sidePanelTouch = false;
  //   this.sidePanelDragging = false;
  // }
  jobFilesUpdated() {
    let files = [];
    let promises = [];
    if (this.jobFiles) {
      Object.keys(this.jobFiles).forEach((fileName) => {
        // filter out anything that is not an uploaded file
        if (fileName[0] == '-') {
          promises.push(
            new Promise((resolve) => {
              firebase
                .storage()
                .ref(`job_files/${this.jobid}/${fileName}`)
                .getDownloadURL()
                .then((url) => {
                  let request = new XMLHttpRequest();
                  request.addEventListener('load', () => {
                    // convert the response data to a blob and create a local url to use in an anchor tag
                    let blob = new Blob([request.response], { type: 'ArrayBuffer' });
                    let localUrl = URL.createObjectURL(blob);
                    this.jobFiles[fileName].url = localUrl;
                    files.push(this.jobFiles[fileName]);
                    resolve();
                  });
                  request.addEventListener('error', (e) => {
                    console.log('Error with http request', e);
                  });
                  request.open('GET', url);
                  request.responseType = 'arraybuffer';
                  request.send();
                });
            })
          );
        }
      });
      Promise.all(promises).then(() => {
        this.set('formattedJobFiles', files);
      });
    }
  }

  sidePanelTrack(e) {
    if (this.ignoreSidePanelTrack) return;
    if (e.detail.state === 'start') {
      this.sidePanelOffsetLeft = this.$.sidePanel.offsetLeft;
      this.sidePanelOffsetWidth = this.$.sidePanel.offsetWidth;
      this.sidePanelDraggingHorizontally =
        (e.detail.ddx != null && e.detail.ddy != null && Math.abs(e.detail.ddx) > Math.abs(e.detail.ddy)) ||
        (e.detail.dx != null && e.detail.dy != null && Math.abs(e.detail.dx) > Math.abs(e.detail.dy));
    }
    if (this.sidePanelDraggingHorizontally) {
      this.$.sidePanel.setAttribute('dragging', true);
      this.$.sidePanel.style.left = Clamp(this.sidePanelOffsetLeft + e.detail.dx, -this.sidePanelOffsetWidth, 0) + 'px';
    }
    if (e.detail.state === 'end') {
      this.$.sidePanel.removeAttribute('dragging');
      this.showSidePanel = Math.abs(this.$.sidePanel.offsetLeft) < this.sidePanelOffsetWidth / 2 && this.sidePanelLastDDX > -6;
      if (!this.showSidePanel) this.closeSidePanel();
      this.$.sidePanel.style.left = null;
    }
    this.sidePanelLastDDX = e.detail.ddx;
  }

  contextInfoExists(contextInfo) {
    return contextInfo != null;
  }

  computeShowAppInfoMenu(jobName, userGroup) {
    return jobName && userGroup && this.isReviewContractor && (jobName.substring(0, 4) == 'APP_' || jobName.substring(0, 4) == 'REL_');
  }

  requestContextInfo() {
    this.contextInfoError = null;
    this.contextInfoLoading = true;
    // Set the search text to the job name
    let searchText = this.jobName;
    // Check that the search text and user group exist
    if (searchText != null && this.userGroup != null) {
      // Cut off the first part of the search text if it starts with 'APP_' or 'REL_'
      if (searchText.substring(0, 4) == 'APP_' || searchText.substring(0, 4) == 'REL_') {
        searchText = searchText.slice(4);
      }
      // Get the key for the request and push the request to Firebase
      var requestKey = FirebaseWorker.ref('photoheight/server_requests/context_layers/requests').push({
        search: searchText,
        userGroup: this.userGroup
      }).key;
      FirebaseWorker.ref('photoheight/server_requests/context_layers/responses/' + requestKey).on(
        'value',
        function (snapshot) {
          // Check if the snapshot has data
          var contextLayers = snapshot.val();
          if (contextLayers != null) {
            // Check if the request was successful
            if (contextLayers.status == 'success') {
              // Set the context info
              this.contextInfo = contextLayers._info || null;
            } else {
              // Otherwise set an error for the user
              this.contextInfoError = 'Error loading app info.';
            }
            this.contextInfoLoading = false;
            // Remove the reference to the request
            snapshot.ref.remove();
          }
        }.bind(this)
      );
    }
  }

  computeNodeStyle(modelDefaults) {
    return {
      rules: [
        { attribute: modelDefaults.node_type_attribute, value: 'pole', icon: 'circle-small-black.svg' },
        { attribute: modelDefaults.node_type_attribute, value: 'reference', icon: 'asterisk-magenta.svg' },
        { attribute: modelDefaults.node_type_attribute, value: 'crossover', icon: 'x-red.svg' },
        { attribute: modelDefaults.node_type_attribute, value: 'existing anchor', icon: 'triangle-down-pink.svg' },
        { attribute: modelDefaults.node_type_attribute, value: 'new anchor', icon: 'triangle-down-pink.svg' },
        { attribute: modelDefaults.node_type_attribute, value: 'spatial note', icon: 'circle-cyan.svg' },
        { attribute: 'done', value: true, icon: 'bullseye-green.svg' },
        { attribute: modelDefaults.node_type_attribute, value: 'trunk amp', icon: 'square-gray.svg' },
        { attribute: modelDefaults.node_type_attribute, value: 'line extender amp', icon: 'square-white.svg' },
        { attribute: modelDefaults.node_type_attribute, value: 'cable tap', icon: 'square-small-yellow.svg' }
      ],
      fallback: 'circle-magenta.svg'
    };
  }

  computeShowReadOnlyWarning(sharing, readOnlyUser, jobid) {
    return jobid && (sharing === 'read' || readOnlyUser) ? true : false;
  }

  computeDisableJobCreation(readOnlyUser) {
    return readOnlyUser == true || this.get('userHasMobileAssessmentsRole') == true;
  }

  showReadOnlyWarningChanged() {
    if (this.showReadOnlyWarning) {
      this.activeButton = null;
      this.set('activeTool', 'editAttributes');
    }
  }

  saveSettings(key, value) {
    // we only want to store the geoJsonKey as reference for a session.  Applying the setting will then turn on the correct layer using the key
    if (key == 'geoJsonLayers') value = value.map((x) => x.key);
    this[`saveSettings${key}`] = Debouncer.debounce(this[`saveSettings${key}`], timeOut.after(100), () => {
      //Session Storage
      sessionStorage.setItem('mobileMaps:' + key, JSON.stringify(value));
    });
  }

  or(a, b) {
    return a || b;
  }

  checkUserGroup(userGroup) {
    for (let i = 1; i < arguments.length; i++) {
      if (userGroup == arguments[i]) return true;
    }
    return false;
  }

  getFavoriteToolsMenuMaxHeight() {
    return window.innerHeight - 96 + 'px';
  }

  getNumCollectedContainerClass() {
    let temp = [];
    if (this.numPolesCompleted >= this.numPoles) temp.push('done');
    return temp.join(' ');
  }

  isFavoriteTool(tool) {
    return this.get(`favoriteTools.${tool}`) != null;
  }

  initGoogle() {
    // setStyle function for geoJson layers
    this.map.data.setStyle(
      function (feature) {
        let prop = (key) => feature && feature.getProperty(key),
          label = '',
          t;

        if (prop('juris')) {
          feature.setProperty('type', 'state_roads');
        }

        if ((t = prop('st_rt_no'))) label += 'State Route Number: ' + t;
        if ((t = prop('seg_no'))) label += '<br/>Segment Number: ' + t;
        if ((t = prop('street_nam'))) label += '<br/>Street Name: ' + t;
        if ((t = prop('summary'))) label += t;

        if ((t = prop('juris'))) {
          t = this.stateRoadStyle[t];
          label += '<br/>Jurisdiction: ' + t.name;
          feature.setProperty('label', label);
          feature.setProperty('type', 'state_road');
          return {
            strokeColor: t.color,
            strokeOpacity: 1,
            strokeWeight: 8
          };
        } else {
          // For all other types, set the default properties
          var featureObject = {
            strokeColor: prop('stroke'),
            strokeOpacity: prop('stroke-opacity'),
            strokeWeight: prop('stroke-width'),
            fillColor: prop('fill'),
            fillOpacity: prop('fill-opacity'),
            editable: prop('editable')
          };
          // Check if there is an icon property
          if (prop('icon')) {
            let defaultKMZIconSize = 30;
            let iconScale = prop('icon-scale') || 1;
            featureObject['icon'] = {
              url: prop('icon'),
              scaledSize: { width: defaultKMZIconSize * iconScale, height: defaultKMZIconSize * iconScale },
              anchor: { x: (iconScale * defaultKMZIconSize) / 2, y: (iconScale * defaultKMZIconSize) / 2 }
            };
          }
          for (let key in featureObject) {
            if (key.toLowerCase().indexOf('color') != -1 && featureObject[key] && typeof featureObject[key] === 'object') {
              featureObject[key] = `rgba(${featureObject[key].r || 0}, ${featureObject[key].g || 0}, ${featureObject[key].b || 0}, ${
                featureObject[key].a || 1
              })`;
            }
          }
          return featureObject;
        }
      }.bind(this)
    );
    this.turnOnCompanyLayers();
    this.googleIsReady = true;
  }

  handleGoogleMapApiError() {
    if (this.online) return;

    // Show a dialog to user indicating that they are offline and the map can't be loaded
    const title = `Can't Initialize Offline`;
    const body = `Your device is missing core components required to function offline. Connect to the internet and refresh the page to try again.`;
    KatapultDialog.alert({
      body,
      dialog: { title, color: 'var(--paper-red-500)' }
    });
  }

  refSelect(e) {
    this.layerReferenceJobName = '';
    let layers = this.geoJsonLayers;
    let d = e.detail;
    let latLng = new google.maps.LatLng(d.lat, d.lng);
    let featureClicked;
    for (let layerIndex in layers) {
      let features = layers[layerIndex]?.features || [];
      for (var i in features) {
        var area = features[i].getGeometry();
        var geometryType = area.getType();
        // this will isolate the grid layer
        if (geometryType == 'Polygon') {
          var poly = new google.maps.Polygon({
            paths: area.getAt(0).getArray(),
            clickable: false
          });
          if (google.maps.geometry.poly.containsLocation(latLng, poly)) {
            featureClicked = features[i];
            break;
          }
        }
        // todo need to support other geometry types
        // else if() {

        // }
      }
    }
    let foundJob = '';
    let refSelectInfo = [];

    if (featureClicked) {
      featureClicked.forEachProperty((value, name) => {
        if (name.toLowerCase() == 'job name' || name.toLowerCase() == 'job_name' || name.toLowerCase() == 'job') {
          foundJob = value;
        }
        if (name.toLowerCase() != 'description' && name != '_key') {
          refSelectInfo.push({
            title: name,
            desc: value
          });
        }
      });
      // found a job to interact with
      if (foundJob) {
        this.layerReferenceJobName = foundJob;
        this.set('refSelectInfo', refSelectInfo);
        this.$.refSelectDialog.open();
      } else {
        this.toast(`Job name not found on this feature layer`);
        this.set('refSelectInfo', refSelectInfo);
        this.$.refSelectDialog.open();
      }
    } else {
      let geometryClickedData = null;
      // If we didn't find a feature in the geoJsonLayers, check the API layers
      for (let layerKey in this.apiMapLayers) {
        if (!this.apiMapLayers[layerKey]) continue;
        // Get the geometries for the layer
        let geometries = this.$.apiMapLayer.getLayerGeometries(layerKey);
        // Check if the click was inside any of the polygon geometries
        for (let geometry of geometries) {
          // Check if the item appears to be a polygon and contains the location
          if (geometry.getPaths && google.maps.geometry.poly.containsLocation(latLng, geometry)) {
            geometryClickedData = { geometry, layerKey };
            break;
          }
        }
      }

      // If we clicked on a geometry, show the properties for it
      if (geometryClickedData) {
        let properties = this.$.apiMapLayer.getPropertiesForLayerGeometry(geometryClickedData.layerKey, geometryClickedData.geometry);
        // Add the properties to the ref select dialog
        for (let prop in properties) {
          refSelectInfo.push({
            title: prop,
            desc: properties[prop]
          });
        }
        this.set('refSelectInfo', refSelectInfo);
        this.$.refSelectDialog.open();
      } else {
        this.toast(`No polygon layer was found`);
      }
    }
  }

  async jumpToReferenceJob() {
    this.jumpToReferenceJobSpinnerActive = true;
    // use the layerReferenceJobName name to do a firebase query
    let jobKey = await this.getJobKeyByName(this.layerReferenceJobName);
    // we found a job with a name matching our reference layer
    if (jobKey) {
      this.$.refSelectDialog.close();
      this.set('jobid', jobKey);
      this.activeTool = 'jobTimeCollection';
    } else {
      this.$.refSelectDialog.close();
      this.toast(`${this.layerReferenceJobName} was not found in your job list`);
    }
    this.jumpToReferenceJobSpinnerActive = false;
  }

  async addReferenceJobLayer(referenceJobId) {
    if (this.jobid && this.jobid != referenceJobId) {
      let jobName = await FirebaseWorker.ref(`photoheight/jobs/${referenceJobId}/name`)
        .once('value')
        .then((s) => s.val());
      if (jobName) {
        this.set(`jobLayers.${referenceJobId}`, {
          name: jobName,
          visible: false
        });
        return true;
      }
    }
    return false;
  }

  removeReferenceJobLayer(referenceJobId) {
    let layersToRemove = [referenceJobId];
    if (referenceJobId == 'all') {
      layersToRemove = Object.keys(this.jobLayers || {});
    }
    // Filter out null
    layersToRemove = layersToRemove.filter((x) => x);
    layersToRemove.forEach((layerKey) => {
      this.set(`layers.${layerKey}`, null);
      this.set(`jobLayers.${layerKey}`, null);
    });
  }

  toggleReferenceJobLayer(referenceJobId, toggleState) {
    let existingLayer = SquashNulls(this.jobLayers, referenceJobId);
    let color = 'var(--katapult-dark-blue-3-shades-darker)';
    if (existingLayer) {
      if (toggleState) {
        color = randomColor({ format: 'rgba', alpha: 0.7 });
        this.set(`layers.${referenceJobId}`, {
          color,
          url: `photoheight/jobs/${referenceJobId}/geohash`,
          name: existingLayer.name,
          data: {
            jobCreator: null
          }
        });
      } else {
        this.set(`layers.${referenceJobId}`, null);
      }
      // Set the toggle state
      this.set(`jobLayers.${referenceJobId}.visible`, Boolean(toggleState));
      this.set(`jobLayers.${referenceJobId}.color`, color);
    }
  }

  async getJobKeyByName(jobName) {
    if (this.userGroup) {
      let jobData = await FirebaseWorker.ref(`photoheight/job_permissions/${this.userGroup}/list`)
        .orderByChild('name')
        .equalTo(jobName)
        .once('value')
        .then((s) => s.val());
      if (jobData) {
        return Object.keys(jobData)[0];
      }
    }
    return null;
  }

  async turnOnReferenceJobFromLayer() {
    this.addReferenceJobSpinnerActive = true;
    let referenceJobKey = await this.getJobKeyByName(this.layerReferenceJobName);
    if (referenceJobKey) {
      if (referenceJobKey == this.jobid) {
        this.toast(`${this.layerReferenceJobName} is already the active job.`);
      } else {
        let success = await this.addReferenceJobLayer(referenceJobKey);
        if (success) {
          this.toggleReferenceJobLayer(referenceJobKey, true);
          this.toast(`${this.layerReferenceJobName} turned on`);
        } else {
          this.toast(`Sorry, there was an error turning on the reference layer.`);
        }
      }
    } else {
      this.toast(`${this.layerReferenceJobName} was not found in your job list`);
    }
    this.$.refSelectDialog.close();
    this.addReferenceJobSpinnerActive = false;
  }

  openJob(e) {
    this.jobChooserJobId = e.detail.jobId;
  }

  onSignedIn() {
    this.$.googlemap.resize();

    // TODO (04/02/2026): Uncomment this when you can cold start maps mobile
    // this.facilitateAutoRefreshToInstallServiceWorker();
  }

  filterFavoriteTools() {
    const mobileAssessmentWorkflow = this.get('userHasMobileAssessmentsRole');
    // some favorite tool sets have favorites in them with buttons that no longer exist in a given model
    // this filters out those buttons along with buttons that should not be allowed in a mobile assessment workflow
    return (tool) => {
      const toolIsAssessment = this.get(`mappingButtons.${tool.$key}.view`) == 'assessment';
      let toolIsAllowed = true;
      if (mobileAssessmentWorkflow == true) {
        toolIsAllowed = toolIsAssessment == true;
      }
      let buttonStyle = this.get(`hardcodedButtonStyles.${tool.$key}`) || this.get(`mappingButtons.${tool.$key}`);
      if (buttonStyle) return toolIsAllowed;
      else return false;
    };
  }

  getButtonStyle(buttonKey, property) {
    let buttonStyle = this.get(`hardcodedButtonStyles.${buttonKey}`) || this.get(`mappingButtons.${buttonKey}`);
    if (property) return Path.get(buttonStyle, property);
    return buttonStyle;
  }

  preventPullDownStart(e) {
    this.preventPullDownY = e.targetTouches[0].pageY;
  }

  preventPullDownRefresh(e) {
    if (e.currentTarget.$.scrollable && e.currentTarget.$.scrollable.scrollTop == 0 && e.targetTouches[0].pageY > this.preventPullDownY) {
      e.preventDefault();
    }
  }

  recenterOnGPS(options = {}) {
    if (!this.googleIsReady || !this.gpsData) return;
    this.mapPanned = false;
    // Set the zoom, latitude, and longitude to the GPS location
    this.latitude = this.gpsData.latitude;
    this.longitude = this.gpsData.longitude;
    if (!options.preserveZoomLevel && this.zoom < 18) {
      this.ignoreNextZoom = true;
      this.zoom = 18;
    }
  }

  showGPSButton() {
    return this.mapPanned && !this.hideGPSButton;
  }

  appNameContains(appName, searchString) {
    return (appName || '').toLowerCase().indexOf(searchString.toLowerCase()) != -1;
  }

  followUserLocationOnMap() {
    // Only follow the user's location if they have the centerMapOnGPS setting turned on and they haven't panned the map themselves
    if (!this.centerMapOnGPS || this.mapPanned) return;
    this.recenterOnGPS({ preserveZoomLevel: true });
  }

  openDebuggingLog() {
    this.$.debuggingLog.open();
  }

  getInternalGPSData(start) {
    if (start && navigator.geolocation) {
      this.geolocationId = navigator.geolocation.watchPosition(
        (gpsPosition) => {
          const { latitude, longitude, accuracy, altitude, altitudeAccuracy, heading, speed } = gpsPosition.coords;
          this.gpsData = {
            latitude,
            longitude,
            accuracy,
            altitude,
            altitudeAccuracy,
            heading,
            speed,
            timestamp: gpsPosition.timestamp,
            _source: 'internal',
            _connected: true,
            _accurate: accuracy < 50
          };

          this.saveLocation();
        },
        (error) => {
          const errors = {
            1: 'GPS Permission Denied',
            2: 'GPS Position Unavailable',
            3: 'GPS Request Timeout'
          };
          console.log(errors[error.code]);
        },
        {
          enableHighAccuracy: true,
          timeout: 10 * 1000 * 1000,
          maximumAge: 0
        }
      );
    } else {
      this.set('gpsData._connected', false);
      navigator.geolocation.clearWatch(this.geolocationId);
      this.set('geolocationId', null);
    }
  }

  roundNumber(e) {
    if (typeof e === 'number') {
      return e.toFixed(2);
    }
    return e;
  }

  useMetricUnitsChanged() {
    if (this.useMetricUnits != null) {
      this.useMetricUnitsChecked = this.useMetricUnits;
    }
  }

  useMetricUnitsCheckedChanged() {
    if (this.userGroup != null && this.user.uid != null && this.useMetricUnitsChecked != null) {
      FirebaseWorker.ref('photoheight/company_space/' + this.userGroup + '/user_data/' + this.user.uid + '/use_metric_units').set(
        this.useMetricUnitsChecked
      );
    }
  }

  labelFontSizeChanged(e) {
    const newValue = e?.currentTarget?.value;
    if (this.userGroup != null && this.user.uid != null && newValue != null) {
      FirebaseWorker.ref('photoheight/company_space/' + this.userGroup + '/user_data/' + this.user.uid + '/mobile_label_font_size').set(
        newValue
      );
      this.labelFontSize = newValue;
    }
  }

  getPoleCounts() {
    //todo this could be in worker
    let poleCount = 0;
    let polesCompleted = 0;
    for (let nodeId in this.nodes) {
      let nodeType = PickAnAttribute(this.nodes[nodeId].attributes, this.modelDefaults.node_type_attribute);
      if (
        this.modelDefaults.pole_node_types.includes(nodeType) &&
        !PickAnAttribute(this.nodes[nodeId].attributes, 'exclude_from_pole_count')
      ) {
        poleCount++;
        if (PickAnAttribute(this.nodes[nodeId].attributes, 'field_completed')) {
          polesCompleted++;
        }
      }
    }
    this.numPoles = poleCount;
    this.numPolesCompleted = polesCompleted;
  }

  getOptions() {
    // position:7 is google.map.ControlPosition.RIGHT_TOP
    if (self.isMobile)
      return {
        backgroundColor: '#002b38',
        clickableIcons: false,
        gestureHandling: 'greedy',
        mapTypeControl: false,
        fullscreenControl: false,
        panControl: false,
        streetViewControl: false,
        zoomControl: false,
        rotateControl: false
      };
    return {
      backgroundColor: '#002b38',
      clickableIcons: false,
      gestureHandling: 'greedy',
      mapTypeControl: false,
      fullscreenControl: false,
      panControl: true,
      panControlOptions: { position: 7 },
      zoomControl: false,
      streetViewControl: true,
      streetViewControlOptions: { position: 7 }
    };
  }

  /**
   * Reloads the page. If there is an update available, it will update the service worker and reload the page.
   */
  reloadMobile() {
    // If there is an update available, update the service worker and reload the page
    if (this.updateAvailable && typeof this.updateAndReload == 'function') {
      return this.updateAndReload();
    }

    // Otherwise, just reload the page
    window.location.reload();
  }

  timeSyncClosed() {
    this.startCollectionTime = false;
    this.$.jobTimeCollection.timeSyncClosed();
    this.toastIfActiveJobAddedToOfflineJobs();
  }

  _computeExpression15(contextInfo) {
    if (contextInfo == null) return '';
    else if (this.jobMetadata.wr_number) {
      return this.jobMetadata.wr_number;
    } else return this.isOldApp ? contextInfo.ppl_wr_number || '(None)' : contextInfo.wr_number || '(None)';
  }

  _computeExpression16(contextInfo) {
    if (contextInfo == null) return '';
    else if (this.jobMetadata.wo_number) {
      return this.jobMetadata.wo_number;
    } else return this.isOldApp ? contextInfo.ppl_wo_number || '(None)' : contextInfo.wo_number || '(None)';
  }

  getJobCreator(contextInfo) {
    if (contextInfo == null) return false;
    if (contextInfo.attachment_owner != contextInfo.creator) return true;
    else return false;
  }
  formatName() {
    if (this.jobMetadata) {
      this.formattedAttachmentOwner = '';
      this.formattedCreator = '';
      FirebaseWorker.ref(`photoheight/companies/${this.jobMetadata.attachment_owner}/name`)
        .once('value')
        .then((s) => {
          this.formattedAttachmentOwner = s.val();
        });
      if (this.jobMetadata.attachment_owner != this.jobMetadata.creator) {
        FirebaseWorker.ref(`photoheight/companies/${this.jobMetadata.creator}/name`)
          .once('value')
          .then((s) => {
            this.formattedCreator = s.val();
          });
      }
    }
  }

  async resolveAppTypeDisplayName(appType, jobCreator) {
    // Show the app type's display name in the application info panel so push-id app types stay readable
    if (!jobCreator || !appType) {
      this.appTypeDisplayName = appType ?? '';
      return;
    }
    this.appTypeDisplayName = await KatapultModel.fromId(jobCreator).getPortalAppTypeDisplayName(appType);
  }

  formatDate(date) {
    if (date != null && date.split) {
      return date.split(' ')[0];
    }
    return null;
  }

  updateUrl() {
    // TODO: possibly change this to default the hash to a "#" like katapult-maps-desktop
    this.updateUrlDebounce = Debouncer.debounce(this.updateUrlDebounce, timeOut.after(200), () => {
      let hash = this.jobChooserJobId;
      if (this.jobToken) hash += '///' + this.jobToken;
      window.location.hash = hash;
    });
  }

  toArray(x) {
    return ToArray(x);
  }

  toggleFavoriteToolsMenu(e) {
    e.preventDefault();

    // If there are no favorite tools, open the active tool chooser
    if (Object.keys(this.favoriteTools ?? {}).length == 0 && !this.favoriteToolsMenuOpened) {
      this.editingFavoriteTools = true;
      this.openActiveToolChooser();
      return;
    }

    this.favoriteToolsMenuOpened = !this.favoriteToolsMenuOpened;
  }

  toggleDesign(e) {
    this.designOnly = !this.designOnly;
    e.stopPropagation();
  }

  getColorStyle(color) {
    return 'color:' + (color || 'black') + ';';
  }

  getPromptStyle(toolColor, type) {
    if (type == 'waterDrop') {
      return 'color:' + toolColor + ';';
    } else if (type == 'prompt') {
      return 'background-color:' + toolColor + '; color:' + BlackOrWhite(toolColor, true) + ';';
    } else if (type == 'icon') {
      return 'color:' + BlackOrWhite(toolColor, true) + ';';
    }
  }

  updateShowCollectionButton() {
    this.showCollectionButton =
      !this.get('userHasMobileAssessmentsRole') && (this.activeTool === 'drawOnMap' || this.activeTool === 'addSection');
  }

  getDefaultCollectionOrderLogic(modelDefaults) {
    return {
      autoZoom_node_types_to_skip: modelDefaults.reference_node_types,
      click_radius_in_px: 10,
      connection_types_to_skip: [...modelDefaults.downguy_connection_types, 'pushbrace', 'underground'],
      node_types_to_skip: ['building attachment', ...modelDefaults.anchor_node_types, ...modelDefaults.map_note_node_types]
    };
  }

  computeLegendItems(jobStyles) {
    var legendItems = [];
    var styleModel = SquashNulls(jobStyles, 'default') || [];
    // Loop through styles types
    for (var styleType in styleModel) {
      // Skip properties starting with _
      if (styleType[0] != '_') {
        for (var styleIndex in styleModel[styleType]) {
          if (styleModel[styleType].hasOwnProperty(styleIndex)) {
            const icon = StyleRuleToIcon(styleModel[styleType][styleIndex], false, { modelDefaults: this.modelDefaults });
            legendItems.push(icon);
          }
        }
      }
    }
    return legendItems;
  }

  dropperTouchStart() {
    this.dropperLongPressTimeout = setTimeout(() => {
      if (this.$.editAttributes) {
        this.$.editAttributes.select(this.findClosest(), this.latitude, this.longitude);
      }
    }, 1000);
  }

  dropperTouchEnd() {
    if (this.dropperLongPressTimeout) {
      clearTimeout(this.dropperLongPressTimeout);
    }
  }

  openActiveToolChooser() {
    this.activeToolChooserOpen = true;
  }

  closeActiveToolChooser(e) {
    if (e && typeof e.preventDefault == 'function') e.preventDefault();
    this.activeToolChooserOpen = false;
    this.editingFavoriteTools = false;
  }

  googlemapTouchstart(e) {
    this.closeSidePanel();
    // Manually focus the map on tap to dismiss the keyboard
    this.$.googlemap.focus();
    if (e.targetTouches.length == 2) {
      this.touchStartLength = KatapultGeometry.CalcDistanceXY(
        { x: e.targetTouches[0].pageX, y: e.targetTouches[0].pageY },
        { x: e.targetTouches[1].pageX, y: e.targetTouches[1].pageY }
      );
    }
  }

  googlemapTouchmove(e) {
    if (e.targetTouches.length == 2) {
      var currentLength = KatapultGeometry.CalcDistanceXY(
        { x: e.targetTouches[0].pageX, y: e.targetTouches[0].pageY },
        { x: e.targetTouches[1].pageX, y: e.targetTouches[1].pageY }
      );
      if (this.zoom >= 20 && currentLength > this.touchStartLength && navigator.onLine && this.superZoom) {
        //zooming in
        if (this.maptype == 'blank' && this.zoom == 20) {
          this.prevMapType = 'blank';
        }
        if (this.triedTosuperzoom) {
          this.maptype = 'blank';
          this.superzoomOverlay();
        } else {
          setTimeout(() => {
            this.triedTosuperzoom = true;
          }, 500);
        }
      } else if (this.zoom <= 20 && currentLength < this.touchStartLength) {
        //zooming out
        if (this._superZoomActive && this.prevMapType != 'blank' && navigator.onLine) {
          this.superzoomOverlayDisable();
        }
        this.triedTosuperzoom = false;
      } else if (this.zoom <= 21 && currentLength < this.touchStartLength) {
        if (this._superZoomActive && navigator.onLine) {
          this.maptype = this.selectedMapType;
          this.superzoomOverlayDisable();
        }
        this.triedTosuperzoom = false;
      }
    }
  }

  googleMouseWheel(e) {
    //On Chrome
    //+delta = zooming in | -delta = zooming out
    //Hybrid: 5-20/30
    //Roadmap: 5-22/30
    //Terrain: 5-21/30
    //Satellite: 5-20/30
    //Blank: Jumps to 13, changes to previous when scrolling out to 20

    //Note: zoom numbers can repeat, esp when scrolling quickly
    this.mouseWheel = true;
    if (['hybrid', 'satellite', 'blank', 'terrain', 'roadmap'].includes(this.maptype)) {
      var delta = 0;
      if (e.wheelDelta) {
        /* IE/Opera. */
        delta = e.wheelDelta / 120;
      } else if (e.detail) {
        /* Mozilla case. */
        delta = -e.detail / 3;
      }
      if (this.zoom >= 20 && delta > 0 && navigator.onLine && this.superZoom) {
        //zooming to superzoom (this.superzoom denotes if option is on, not current state of superzoom)
        if (this.maptype == 'blank' && this.zoom == 20) {
          this.prevMapType = 'blank';
        }
        if (this.triedTosuperzoom) {
          this.maptype = 'blank';
          this.superzoomOverlay();
        } else {
          setTimeout(() => {
            this.triedTosuperzoom = true;
          }, 500);
        }
      } else if (this.zoom <= 20 && delta < 0) {
        if (this._superZoomActive && this.prevMapType != 'blank' && navigator.onLine) {
          this.prevMaptype = this.maptype;
          this.superzoomOverlayDisable();
        }
        this.triedTosuperzoom = false;
      } else if (this.zoom <= 21 && delta < 0) {
        if (this._superZoomActive && this.prevMapType != 'blank' && navigator.onLine) {
          //zooming out from superzoom
          this.maptype = this.prevMapType;
          this.superzoomOverlayDisable();
        }
        this.triedTosuperzoom = false;
      }
    }
  }

  togglePolylineEditing(connId, override) {
    connId = SquashNulls(connId, 'detail', 'connId') || connId;
    var line = this.$.loadRenderMap.lineLocations[connId];
    if (line) {
      if (!line.getEditable()) this.toast('Use a finger to drag polyline breakpoints');
      line.setEditable(typeof override === 'boolean' ? override : !line.getEditable());
      this.$.loadRenderMap.setupPolylineListeners(line.getPath(), line, connId, this.jobid);
    }
  }

  onMapTypeChange() {
    if (this.maptype !== 'blank') {
      this.prevMapType = this.maptype;
      this.superzoomOverlayDisable();
    }
  }
  onSelectedMapTypeChange() {
    this.maptype = this.selectedMapType;
  }

  mapBaseIsDisabled(mapTypeIdEntry, mapBaseConfigs) {
    // Get the proper map base config
    const legacyMapTypeId = mapTypeIdEntry?.$key;
    const mapBase = getMapBaseConfigFromLegacyMapTypeId(mapBaseConfigs, legacyMapTypeId);
    if (mapBase == null) return false;

    // Disable a map base if it is a wmts layer since the google maps engine cannot render it
    return mapBase?.type === 'wmts';
  }

  mapBaseIsEnabled(mapTypeIdEntry, mapBaseConfigs) {
    // Inverse of mapBaseIsDisabled for the enabled branch of the radio template
    return !this.mapBaseIsDisabled(mapTypeIdEntry, mapBaseConfigs);
  }

  showWmtsMapBaseDisabledToast() {
    // Tell the user why the wmts map base cannot be selected
    showToast({ variant: 'primary', duration: 3_000, content: litHtml`Google Map Engine does not support WMTS Map Bases` }, 'bottom');
  }

  superzoomOverlay() {
    if (this.zoom < 20) return;
    this._superZoomActive = true;
    // Remove the super zoom overlay if it already exists
    this._superZoomOverlay?.setMap(null);
    // Create a super zoom overlay with the previous map base
    this._superZoomOverlay = createSuperZoomOverlay(this.prevMapType);
    // Set the super zoom overlay on the map
    this._superZoomOverlay.setMap(this.map);
  }

  superzoomOverlayDisable() {
    this._superZoomActive = false;
    this._superZoomOverlay?.setMap(null);
    this._superZoomOverlay = null;
  }

  checkForOldApp() {
    this.set('isOldApp', config.appName != 'ppl-kws');
  }

  getMapDrawButtonIcon(button) {
    if (Path.get(this.mappingButtons, `${button.id}.models.compute_data_from`) && this.jobMetadata) {
      let key = Path.get(this.mappingButtons, `${button.id}.models.compute_data_from`);
      return (
        SquashNulls(this.mappingButtons, button.id, 'models', 'data', this.jobMetadata[key], 'icon') ||
        this.mappingButtons[button.id].icon ||
        'maps:place'
      );
    } else return button.icon || 'maps:place';
  }

  getMapDrawButtonStyle(button) {
    if (Path.get(this.mappingButtons, `${button.id}.models.compute_data_from`) && this.jobMetadata) {
      let key = Path.get(this.mappingButtons, `${button.id}.models.compute_data_from`);
      return (
        'color:' +
        (SquashNulls(this.mappingButtons, button.id, 'models', 'data', this.jobMetadata[key], 'color') ||
          this.mappingButtons[button.id].color ||
          'black') +
        ';'
      );
    } else return 'color:' + button.color || 'black' + ';';
  }

  showMidspanOptionForPCI() {
    // show the option to include midspan photos in PCI if we've clicked on the prep for post construction button and the current userGroup has the proper feature flag
    // Note: we may need to expand this option using feature flags to other companies in the future when we make PCI
    // more widely available, but for now, we only want to show this option for TRC.
    return this.preppingForPostConstruction && this.enabledFeatures?.pci_midspans;
  }

  async selectTool(e) {
    let target = e.target;
    if (target.className.indexOf('favoriteToolIcon') == -1) {
      while (target.className.indexOf('toolIcon') == -1) {
        target = target.parentNode;
      }
    }

    let tool = target.getAttribute('name');
    let buttonName = target.getAttribute('data-button');

    if (this.editingFavoriteTools) {
      this.toggleFavoriteTool(tool, buttonName);
    } else {
      // Track changing active tool
      posthog.capture('changed_mobile_active_tool', { button: buttonName, tool: tool });

      if (tool == 'myLocation') this.recenterOnGPS();
      else if (tool == 'showGPSData') {
        this.$.liveGPSData.open();
      } else if (tool == 'undoTimeBucket') {
        if (this.$.jobTimeCollection.checkIfLastTimeBucket()) {
          this.confirm({
            detail: {
              heading: 'Undo Last Time Bucket?',
              body: 'This undo the last item you marked as complete (and cannot be undone).',
              affirmativeText: 'Undo',
              dismissiveText: 'Cancel',
              callback: () => {
                this.$.jobTimeCollection.undoLastTimeBucket();
              }
            }
          });
        }
      } else if (tool == 'fixMapErrors') {
        this.toast('Fixing map errors...');
        const FixMapErrors = await import('../katapult-maps-desktop/FixMapErrors.js');
        let result = await FixMapErrors.run(this.jobid, this.map.getProjection(), this.jobStyles, this.jobCreator, this.modelConfig);

        result = result.split('.').join('.\n');

        this.showToast = false;

        KatapultDialog.alert({
          body: result,
          dialog: {
            title: 'Errors Found',
            color: 'var(--paper-red-500)',
            icon: 'report'
          }
        });
      } else if (tool == 'timeSync') {
        this.$.timeSync.open();
      } else if (tool != null) {
        if (buttonName != null) {
          var buttonFunction = SquashNulls(this.mappingButtons, buttonName, 'function');
          if (buttonFunction === '_button_mark_done') {
            if (this.activeItem?.[0] === 'n') {
              // Add specified attributes.
              let poleStatus;
              if (buttonName === 'mark_phantom') poleStatus = 'Phantom';
              else if (buttonName === 'mark_inaccessible') poleStatus = 'Inaccessible';
              else if (buttonName === 'mark_discovered') poleStatus = 'Discovered';
              let nodeId = this.activeItem.slice(1);
              if (this.nodes[nodeId].attributes.pole_status) {
                for (let key in this.nodes[nodeId].attributes.pole_status) {
                  this.nodes[nodeId].attributes.pole_status[key] = poleStatus;
                }
              } else {
                this.nodes[nodeId].attributes.pole_status = { button_added: poleStatus };
              }
              let update = { [`jobs/${this.jobid}/nodes/${nodeId}/attributes/pole_status`]: this.nodes[nodeId].attributes.pole_status };
              // Mark item done.
              let time = new Date().getTime();
              this.$.jobTimeCollection.doneCollection(false, this.latitude, this.longitude, null, time, update);
            } else {
              this.toast('Please select closer to an existing node');
            }
          } else if (buttonFunction == '_button_prep_for_post_construction') {
            // If the user is offline, let the user know that they can't use the Prep for Post Construction tool
            if (!FirebaseWorker.online) {
              KatapultDialog.alert({
                body: 'The Prep for Post Construction tool does not work in Offline Mode. Please return to an area will a stable connection to run.',
                dialog: {
                  title: 'Post Construction',
                  color: 'var(--paper-red-500)',
                  icon: 'error'
                }
              });

              this.closeActiveToolChooser();
              return;
            }

            this.preppingForPostConstruction = true;

            // Reset important variables for PCI before we prep
            this.snapshotMapStylesKey = null;

            // Check if the job is in a portal context so we pull the map styles from the correct model
            const isPortalJob = await FirebaseWorker.ref(`photoheight/jobs/${this.jobid}/metadata/app_type`)
              .once('value')
              .then((s) => s.exists());

            // Check if the job model is the portal utility company
            const jobCreator = await FirebaseWorker.ref(`photoheight/jobs/${this.jobid}/job_creator`)
              .once('value')
              .then((s) => s.val());
            const portalUtilityCompany = this.config.firebaseData.utilityCompany;
            const jobOwnedByPortalUtility = jobCreator == portalUtilityCompany;

            // Check that the current user has read access to the portal utility company's model
            const userHasAccessToPortalUtilityModel = Boolean(
              await KatapultModel.fromId(portalUtilityCompany).getCompanyReadAccess(this.userGroup)
            );

            const usePortalUtilityCompanyStyles = isPortalJob && jobOwnedByPortalUtility && userHasAccessToPortalUtilityModel;

            // Get the list of available map styles to choose from
            let mapStylesList = await KatapultModel.fromId(
              usePortalUtilityCompanyStyles ? portalUtilityCompany : this.userGroup
            ).getMapStyles();
            this.mapStylesList = Object.keys(mapStylesList ?? {}).map((mapStylesKey) => {
              return { key: mapStylesKey, label: ToTitleCase(mapStylesKey) };
            });

            // If we have a PCI map style, auto fill the map styles dropdown
            if (mapStylesList['pci']) this.snapshotMapStylesKey = 'pci';

            // Show the PCI dialog
            this.confirm({
              detail: {
                heading: 'Post Construction',
                body: 'To prep this job, a copy of the existing job will be made (and archived). Additionally, all photos will be marked as pre-construction, Post Construction Job Styles will be loaded, and Field Completed, Done & Proposed will be cleared.',
                bodyType: 'createSnapshot',
                affirmativeText: 'Prep Job',
                dismissiveText: 'Cancel',
                callback: async () => {
                  let includeMidspansForPCI = this.includeMidspansForPCI || null;
                  await import('../job-snapshots/job-snapshots.js'); //lazyload snapshot, reducing strain on mobile
                  await this.$.snapshots.createSnapshot(this.newSnapshotName, this.newSnapshotNumbers, this);
                  await new Promise((x) => setTimeout(x, 500));
                  await import('../katapult-maps-desktop/PrepForPostConstruction.js').then(async (module) => {
                    await module.default
                      .run(
                        this.jobid,
                        this.jobCreator,
                        this.userGroup,
                        this.mappingButtons?.[buttonName]?.models,
                        this.modelDefaults,
                        this.toast.bind(this),
                        this.snapshotMapStylesKey,
                        this.otherAttributes,
                        { includeMidspansForPCI }
                      )
                      .then(async () => {
                        this.toast({
                          text: 'Job Prepped for Post Construction!',
                          duration: Infinity
                        });
                      });
                  });
                }
              }
            });
          } else if (buttonFunction == '_button_set_job_metadata') {
            const { setJobMetadata } = await import('../katapult-maps-desktop/button_functions/set_job_metadata.js');
            let metadata = '';
            if (SquashNulls(this.mappingButtons, buttonName, 'models', 'data')) {
              let computeFrom = SquashNulls(this.mappingButtons, buttonName, 'models', 'compute_data_from');
              let oldValue = SquashNulls(this.jobMetadata, computeFrom);
              metadata = SquashNulls(this.mappingButtons, buttonName, 'models', 'data', oldValue, 'metadata');
              let newValue = SquashNulls(metadata, computeFrom);
              let promises = [];
              if (this.userGroup == 'alpine_communication_corp' && newValue) {
                this.users =
                  this.users ||
                  (await FirebaseWorker.ref(`photoheight/company_space/${this.userGroup}/users`)
                    .once('value')
                    .then((s) => s.val()));
                if (oldValue == 'New_Job') {
                  let uid = Object.keys(this.users || {}).find((x) => this.users[x].email == 'jrohlfing@alpinecc.us');
                  metadata = Object.assign(metadata, { assigned_to: uid });
                  this.toast('Status advanced to Field_Ready, assigned to jrohlfing@alpinecc.us');
                } else {
                  promises.push(
                    new Promise((resolve) => {
                      this.confirm({
                        detail: {
                          heading: 'Assign a User',
                          body: `The status of this job will be advanced to ${newValue}. Assign a user to this job.`,
                          bodyType: 'selectAssignedToValue',
                          affirmativeText: 'Okay',
                          dismissiveText: 'Cancel',
                          callback: async () => {
                            metadata = Object.assign(metadata, { assigned_to: this.alpineAssignedTo || '' });
                            resolve();
                          }
                        }
                      });
                    })
                  );
                }
                // reset value for next input from user
                this.alpineAssignedTo = null;
              }

              Promise.all(promises).then(async () => {
                await setJobMetadata(this.userGroup, metadata, this.jobid);
                let toast = SquashNulls(this.mappingButtons, buttonName, 'models', 'toast') || 'Job Metadata';
                if (metadata) {
                  if (this.userGroup == 'alpine_communication_corp' && oldValue == 'New_Job') {
                    this.toast('Status advanced to Field_Ready, assigned to jrohlfing@alpinecc.us');
                  } else this.toast(`${toast} updated`);
                } else {
                  this.toast('No action taken');
                }
              });
            } else {
              const label = this.mappingButtons?.[buttonName]?.label || 'Job Metadata';
              this.confirm({
                detail: {
                  heading: 'Update Metadata',
                  body: `This will update ${label} for the job. Are you sure you want to continue?`,
                  bodyType: 'setJobMetadata',
                  affirmativeText: 'Set Metadata',
                  dismissiveText: 'Cancel',
                  callback: async () => {
                    const metadata = structuredClone(this.mappingButtons?.[buttonName]?.models?.metadata);
                    //check if the metadata already exists
                    for (let key in metadata) {
                      if (this.jobMetadata[key] && this.jobMetadata[key] == metadata[key]) {
                        delete metadata[key];
                      }
                    }
                    if (Object.keys(metadata).length > 0) {
                      await setJobMetadata(this.userGroup, metadata, this.jobid);
                      const toast = this.mappingButtons?.[buttonName]?.models?.toast || 'Job Metadata';
                      this.toast(`${toast} updated`);
                    } else {
                      this.toast('Metadata was already set, no action taken');
                    }
                  }
                }
              });
            }
          } else if (buttonFunction == '_button_select_reference_layer') {
            this.activeButton = buttonName;
            this.activeTool = 'selectRefLayer';
            this.setToolColor();
          } else if (this.mappingButtons?.[buttonName]?.endpoint_url) {
            // Check and see if the tool can run immediately or needs user input
            const toolRanImmediately = this.$.mobileWebTool?.attemptToRunWebToolImmediately(this.mappingButtons[buttonName], this.jobid);
            if (!toolRanImmediately) {
              this.activeButton = buttonName;
              this.activeTool = 'mobileWebTool';
            }
          } else if (buttonFunction == '_button_mark_job_done') {
            this.closeActiveToolChooser();
            this.toast('Marking job done...');
            // Get the generated map key on this button (it should be there).
            let mapKey = SquashNulls(this.mappingButtons, buttonName, 'models', 'map_key');
            if (mapKey != null) {
              // Based on the app type of the job determine what the status of this job should be set to
              let newAppStatus = 'MR Engineering';
              // If the job is a one touch job then give it a one touch mr engineering status
              if (this.jobMetadata?.app_type == 'one_touch_make_ready_application') newAppStatus = 'MR Engineering (One Touch)';

              // Make a request to run the markJobDone firebase function
              let key = await FirebaseWorker.ref(`photoheight/server_requests/user_requests/${this.user.uid}/requests`).push({
                name: 'markJobDone',
                userGroup: this.userGroup,
                mapKey,
                jobId: this.jobid,
                newAppStatus
              }).key;

              // Setup an on listener to watch for the response
              let responseRef = FirebaseWorker.ref(`photoheight/server_requests/user_requests/${this.user.uid}/responses`);

              let callback = responseRef.on('child_added', async (s) => {
                let response = s.val();

                // check to be sure we have a response and the response is for this request
                if (response && s.key == key) {
                  // display the response message to the user as a toast
                  if (response.success) {
                    this.toast(response.message);
                  } else {
                    this.toast(`Error: ${response.message}`);
                  }

                  // Remove this on listener
                  await responseRef.off('value', callback);

                  // Delete this response in Firebase
                  responseRef.child(key).remove();
                }
              });

              this.toast({ text: 'Marking job done has been queued and will finish soon or when you are back online', duration: 5000 });
            } else {
              this.toast('No map key specified.');
            }
          } else if (buttonFunction == '_button_rotate_icon') {
            this.activeButton = buttonName;
            this.activeTool = 'drawOnMap';
            this.setToolColor();
          } else if (buttonFunction != '') {
            this.toast('Function not setup to run on this system.');
          } else {
            // Check if the button is for drawing sections and if it is, then
            // override the tool to be the addSection tool
            if (SquashNulls(this.mappingButtons, buttonName, 'section')) {
              tool = 'addSection';
            }
            this.activeButton = buttonName;
            this.activeTool = tool;
            this.setToolColor();
          }
        } else {
          this.activeButton = null;
          this.activeTool = null;
          setTimeout(() => {
            this.set('activeTool', tool);
          });
        }
      }
      this.closeActiveToolChooser();
    }
  }

  activeToolChanged() {
    this.snapLine = null;
    this.snapLength = null;
    this.snapAngle = null;
    if (this.pointerAsCrosshair) {
      this.pointerAsCrosshair = false;
      if (this.activeItem[0] == 'n') {
        var id = this.activeItem.slice(1);
        let marker = window.loadRenderMap.pointLocations[id];
        if (marker) {
          marker.map = window.loadRenderMap.map;
          if (marker.data) {
            for (var connId in marker.data.n) {
              var line = window.loadRenderMap.lineLocations[connId];
              if (line) {
                line.setOptions({ strokeOpacity: line.data.o });
                line.override = null;
              }
            }
          }
        }
      }
    }
    this.showLineToActive = false;
    this.set('connsToLabel', []);
    this.set('showAnglesOfNode', '');
    var tool = this.$[this.activeTool];
    if (tool != null) {
      this.setToolColor(tool);
      if (this.willRunCommand) {
        this.willRunCommand = false;
      } else {
        tool.init();
      }
    } else if (this.activeTool == null) {
      this.cancelPrompt();
      this.cancelSecondaryPrompt();
      this.cancelTertiaryPrompt();
      this.toolIcon = 'more-horiz';
      this.toolColor = 'white';
    } else {
      this.toast(this.activeTool + ' not setup correctly');
    }
  }

  setToolColor(tool) {
    if (this.activeButtonModel != null) {
      this.toolColor = this.activeButtonModel.color || 'black';
      this.toolIcon = this.activeButtonModel.icon || 'maps:place';
    } else {
      this.toolColor = tool.color;
      this.toolIcon = tool.icon;
    }
  }

  stopEditingFavoriteTools() {
    this.editingFavoriteTools = false;
  }

  toggleFavoriteTool(tool, buttonName, state) {
    let toolKey = buttonName || tool;
    if (toolKey) {
      if (this.isFavoriteTool(toolKey) && state !== true) {
        FirebaseWorker.ref(
          `photoheight/company_space/${this.userGroup}/user_data/${this.user.uid}/custom_toolsets/mobile/${toolKey}`
        ).remove();
      } else if (state !== false) {
        FirebaseWorker.ref(`photoheight/company_space/${this.userGroup}/user_data/${this.user.uid}/custom_toolsets/mobile/${toolKey}`).set({
          tool: tool,
          button_name: buttonName
        });
      }
    }
  }

  clearAllFavoriteTools() {
    FirebaseWorker.ref(`photoheight/company_space/${this.userGroup}/user_data/${this.user.uid}/custom_toolsets/mobile`).set(null);
  }

  // Pass a function name if you want a different name called; otherwise activeCommand will be called;
  callActiveFunction(functionName) {
    if (functionName != null && functionName.type == 'run-command') {
      functionName = null;
    }
    if (this.activeTool != null && this.activeCommand != null) {
      var tool = this.$[this.activeTool];
      if (tool != null) {
        var fn = tool[functionName || this.activeCommand];
        if (typeof fn === 'function') {
          var args = [];
          for (var i = 1; i < arguments.length; i++) {
            args.push(arguments[i]);
          }
          // Tool functions can be async; catch rejections so a failure doesn't silently leave a tool stuck open with no feedback to the user.
          Promise.resolve(fn.apply(tool, args)).catch((error) => {
            console.error(error);
            this.toast(error);
          });
        }
      } else {
        this.toast('Function not setup correctly');
      }
    }
  }

  zoomChanged() {
    if (this.ignoreNextZoom) {
      this.ignoreNextZoom = false;
    } else {
      this.mapPan();
    }
    // scalar to convert from XY to pixels
    // pixel = xy * 2^zoomLevel
    this.pixelScale = 1 << this.zoom;
  }

  async openOfflineManagement() {
    this.closeSidePanel();

    const offlineManagement = this.shadowRoot?.querySelector('offline-management');
    if (!(offlineManagement instanceof OfflineManagement)) return;
    offlineManagement.setActiveJob(this.jobid);
    offlineManagement.open();
  }

  mapPan() {
    this.mapPanDebounce = Debouncer.debounce(this.mapPanDebounce, timeOut.after(16), () => {
      this.mapPanned = true;
      // Toast Spatial Notes or Map Notes
      let closest = this.findClosest(null, null, { includeReferenceJobs: this.closestIncludesReferenceJobs });
      let toasted = false;
      if (closest != null && closest.item[0] == 'n') {
        let node = SquashNulls(this.nodes, closest.item.slice(1));
        if (node != '' && node.attributes && this.otherAttributes) {
          let nodeType = PickAnAttribute(node.attributes, this.modelDefaults.node_type_attribute);
          let toast = '';
          let attributesToToast = ['note', 'description'];
          if (this.modelConfig?.toast_attributes?.list) attributesToToast = this.modelConfig.toast_attributes.list;
          attributesToToast.forEach((property) => {
            for (var key in node.attributes[property]) {
              if (toast != '') toast += SquashNulls(this.modelConfig, 'toast_attributes', 'separator') || '; ';
              // Add the label if needed
              toast += SquashNulls(this.modelConfig, 'toast_attributes', 'labels', property) ? CamelCase(property) + ': ' : '';
              // Add the attribute value
              toast += AttributeToString(node.attributes[property][key], this.otherAttributes[property]);
            }
          });
          if (!toast && this.modelDefaults.map_note_node_types.includes(nodeType)) toast = '(No Note)';
          if (toast) {
            toasted = true;
            let duration = SquashNulls(this.modelConfig, 'attributeToastDuration') || Infinity;
            this.toast({ text: toast, duration });
          }
        }
      }
      if (!toasted) this.showToast = false;

      // If the quick photo capture is on, determine if a button should be shown when a node or section is hovered
      if (this.quickPhotoCapture) {
        // Set the closest item
        const closestItem = closest?.item;
        this.photoCaptureTarget = closestItem ?? null;
        // Determine whether to show the camera button
        this.showQuickPhotoCaptureButton = closestItem?.[0] == 'n' || closestItem?.[0] == 's';
      } else if (this.showQuickPhotoCaptureButton) this.showQuickPhotoCaptureButton = false;

      // Call Map pan for the active tool
      this.callActiveFunction('map_pan', this.latitude, this.longitude, closest);

      // Always call the map pan command for move-item (in case GPS actions are being used by another tool)
      this.$.moveItem?.map_pan?.(this.latitude, this.longitude, closest);
    });
  }

  getSelectedIconVisibility(activeItem, pointerAsCrosshair) {
    if (activeItem == '' || activeItem[0] == 'c' || pointerAsCrosshair) {
      return null;
    } else {
      return this.map;
    }
  }

  getGPSIcon() {
    let url = 'https://storage.googleapis.com/katapult-pro-shared-files/photos/gps.svg';
    if (this.gpsData._connected === false) {
      url = 'https://storage.googleapis.com/katapult-pro-shared-files/photos/gps-disconnected.svg';
    } else if (this.gpsData._accurate === false) {
      url = 'https://storage.googleapis.com/katapult-pro-shared-files/photos/gps-inaccurate.svg';
    }
    return {
      anchor: {
        x: 12,
        y: 12
      },
      size: {
        height: 24,
        width: 24
      },
      scaledSize: {
        height: 24,
        width: 24
      },
      url: url
    };
  }

  getSelectedIcon(activeItem) {
    let defaultIcon = {
      anchor: {
        x: 16,
        y: 16
      },
      url: 'https://storage.googleapis.com/katapult-pro-shared-files/photos/halo-yellow.svg',
      scaledSize: {
        width: 32,
        height: 32
      }
    };
    // Check if the active item is a node or section
    if (activeItem && (activeItem[0] == 'n' || activeItem[0] == 's')) {
      // Get the geodata for the node
      let geoData = SquashNulls(loadRenderMap, 'pointLocations', activeItem.slice(1), 'data');
      if (geoData) {
        let iconSize = GetIconSize(geoData, {
          shrinkDoneItems: true
        });
        // Increase the size of the highlight by 50% of the icon, but don't go less than 36
        let size = Math.max(iconSize.width * 1.5, 36);
        // Create new size values
        return Object.assign(defaultIcon, {
          scaledSize: { width: size, height: size },
          anchor: { x: size / 2, y: size / 2 }
        });
      }
    }
    // Otherwise return the default
    return defaultIcon;
  }

  getByKey(name, key, attribute) {
    if (name == null || key == null || key == '') {
      return null;
    }
    if (name == '') {
      name = this.activeItemTypes[key[0]];
    }
    if ((name == 'nodes' && key[0] == 'n') || (name == 'connections' && key[0] == 'c') || (name == 'sections' && key[0] == 's')) {
      key = key.slice(1);
    }
    var sectionId;
    if (name == 'sections') {
      name = 'connections';
      var split = key.split(':');
      key = split[0];
      sectionId = split[1];
    }
    var object = this[name][key];
    if (object == null) {
      return null;
    }
    if (sectionId != null) {
      object = SquashNulls(object, 'sections', sectionId);
      if (object == '') {
        return null;
      }
    }
    if (attribute != null) {
      return object[attribute];
    } else {
      return object;
    }
  }

  nodesLoaded() {
    this.nodesLoadedDebounce = Debouncer.debounce(this.nodesLoadedDebounce, timeOut.after(100), () => {
      if (this.nodes && !this.nodesAreLoaded) {
        this.nodesAreLoaded = true;
        this.registerJobLocationForPostHog();
        this.checkMapReady();
        if (this.collectionLogicIsLoaded) {
          this.setDefaultTool();
        }
      }
    });
  }

  registerJobLocationForPostHog() {
    if (!this.nodes) return;
    for (const nodeId in this.nodes) {
      const node = this.nodes[nodeId];
      const lat = node?.latitude;
      const lng = node?.longitude;
      const nodeType = String(PickAnAttribute(node?.attributes, this.modelDefaults.node_type_attribute) ?? '').toLowerCase();
      if (Number.isFinite(lat) && Number.isFinite(lng) && !nodeType.includes('note')) {
        posthog.register({ job_latitude: lat, job_longitude: lng });
        return;
      }
    }
  }

  collectionLogicLoaded() {
    if (!this.collectionLogicIsLoaded) {
      this.collectionLogicIsLoaded = true;
      if (this.nodesAreLoaded) {
        this.setDefaultTool();
      }
    }
  }

  mapIdle() {
    // Need to store bounds to know if map is ready later
    this.lastBounds = this.map.getBounds();
    this.checkMapReady();
  }

  checkMapReady() {
    if ((window.offscreenCanvas || this.nodesAreLoaded) && this.map) {
      this.showInitialTimeSync = true;
    }
    if (this.nodesAreLoaded && !this.mapIsReady && this.map) {
      if (
        this.lastBounds &&
        this.lastBounds.getCenter().lat() == this.map.getBounds().getCenter().lat() &&
        this.lastBounds.getCenter().lng() == this.map.getBounds().getCenter().lng()
      ) {
        this.nextAvailableFrame(
          function () {
            this.mapIsReady = true;
          }.bind(this)
        );
      }
    }
    // Re-create the super zoom overlay on each map idle to keep it fresh after panning or zooming
    if (this._superZoomActive) this.superzoomOverlay();
  }

  nextAvailableFrame(callback) {
    // Get the current time to check the responsiveness
    var startTime = new Date().getTime();
    // Request the next animation frame
    window.requestAnimationFrame(
      function () {
        // Get the end time to test the time difference
        var endTime = new Date().getTime();
        // If the time difference is greater than 80ms,
        // reset the counter and try again
        if (endTime - startTime > 80) {
          this.responsivenessCounter = 0;
          this.nextAvailableFrame(callback);
        } else {
          // Set initial counter value if not already set
          if (this.responsivenessCounter == null) {
            this.responsivenessCounter = 0;
          }
          // Increase the responsivenessCounter
          this.responsivenessCounter++;
          // If we've had 10 successful tests, call the callback
          if (this.responsivenessCounter >= 10) {
            // Reset the counter
            this.responsivenessCounter = 0;
            callback();
          } else {
            // Otherwise, try again until we get 10 successful tries
            this.nextAvailableFrame(callback);
          }
        }
      }.bind(this)
    );
  }

  /**
   * Data listeners on mobile need to be able to access cached data if the user is offline.
   * This function faciliates changing the active job in the offline system and caching its data.
   * When all of this is complete, it sets the job id so that the proper data can be loaded
   */
  async setUpActiveJobForOfflineUse() {
    // Save the current job chooser job id
    const jobIdToCache = this.jobChooserJobId;

    // Clear the current job id
    this.jobid = null;

    if (!this.signedIn) return;

    this._activeJobSetupForOfflineUseAt = Date.now();

    // Create a new promise for setting up the active job for offline use and wait for it to finish
    await globalThis.FirebaseWorker.setCurrentJobId(this.jobChooserJobId);

    // If the job that just finished caching is still the active job chooser job, set the job id to load its data
    if (jobIdToCache == this.jobChooserJobId) this.jobid = this.jobChooserJobId;
  }

  jobIdChanged() {
    // clear the active saved view so a new one can be loaded
    this.activeSavedView = null;
    // reset the toggle for loading layers from sessionStorage when we switch jobs
    this.geoJsonToggled = false;
    // we only want to remove all of the layers when we switch jobs, not when we first load it
    if (this.ignoreJobChooserInitialSet !== true) this.removeGeoJsonLayerFromMap('all');

    if (!this.jobIdAlreadyChanged && this.ignoreJobChooserInitialSet !== true) {
      this.jobIdAlreadyChanged = true;
      this.settingsLoadedFromSession = false;
    }

    this.removeReferenceJobLayer('all');
    if (!this.jobid) {
      this.mapLayers = {};
      this.apiMapLayers = {};
    }

    if (!Path.valueIsEmpty(this.nodeLabels)) this.nodeLabels = {};
    this.updateUrl();
    this.contextInfo = null;
    this.activeItem = '';
    this.startCollectionTime = false;
    if (this.jobid != null && this.jobid != '') {
      this.geo = new GeoFire(FirebaseWorker.ref('photoheight/jobs/' + this.jobid + '/geohash'));
      this.nodesAreLoaded = undefined;
      this.shouldZoomToJob = true;
      this.mapIsReady = false;
      this.closeSidePanel();
    } else {
      this.geo = new GeoFire(FirebaseWorker.ref());
      this.activeButton = null;
      this.activeTool = null;
      posthog.unregister('job_latitude');
      posthog.unregister('job_longitude');
    }

    if (this.jobid) this.showDialogIfJobLockedForTransfer(this.jobid);
  }

  async showDialogIfJobLockedForTransfer(jobId) {
    if (!jobId) return;
    const jobRef = KatapultJob.fromId(jobId);
    const jobOwner = await jobRef.getOwner();
    const locked = await getTransferLocking(jobOwner);
    // Make sure that the locked job is still the active job.
    if (locked && this.jobid == jobId) {
      showLockedJobDialog(jobId);
    }
  }

  jobCreated() {
    this.nodesLoaded();
  }

  setTempHighlightLocation(e) {
    if (this.$.tempHighlightMarker) {
      if (e && e.detail && e.detail.location) {
        this.$.tempHighlightMarker.latitude = e.detail.location[0];
        this.$.tempHighlightMarker.longitude = e.detail.location[1];
        this.$.tempHighlightMarker.map = this.map;
      } else {
        this.$.tempHighlightMarker.map = null;
      }
    }
  }

  handleBoundLitPropertyChanged(e) {
    if (e?.detail?.newValue == undefined) return;
    if (e?.detail?.property == undefined) return;
    this[e.detail.property] = e.detail.newValue;
  }

  activeItemChanged(newItem, oldItem) {
    if (newItem != null && newItem[0] == 'c') {
      let line = this.$.loadRenderMap.lineLocations[newItem.slice(1)];
      if (line) {
        line.setOptions({ strokeColor: 'yellow' });
      }
    }
    if (oldItem != null && oldItem[0] == 'c') {
      let line = this.$.loadRenderMap.lineLocations[oldItem.slice(1)];
      if (line) {
        line.setOptions({ strokeColor: line.data.c });
      }
    }
  }

  updateActiveItemLocation() {
    this.activeItemLocationUpdated = !this.activeItemLocationUpdated;
  }

  updateLayers() {
    if (this.jobid) {
      // Map loads features when layers is set.
      // We don't want the map to be loading when the time sync is open because it can cause the time sync to freeze.
      if (this.timeSyncPauseAppLoading === false) {
        // Start loading the map if the time sync has been taken or isn't needed or the time sync is in a worker.
        this.set('layers', { [this.jobid]: { color: null, url: 'photoheight/jobs/' + this.jobid + '/geohash' } });
      }
    } else {
      // Clear layers.
      this.set('layers', {});
    }
  }

  highlightConn(e, d) {
    if (this.highlightInlineConn != null) this.highlightInlineConn.setMap(null);
    if (this.highlightBisectConns != null) {
      let t;
      while ((t = this.highlightBisectConns.pop()) != null) t.setMap(null);
    }
    this.highlightInlineConn = null;
    this.highlightBisectConns = [];
    if (d != null && !Array.isArray(d) && d.p1 && d.p2) {
      this.highlightInlineConn = new google.maps.Polyline({
        clickable: false,
        map: this.map,
        path: [d.p1, d.p2],
        strokeColor: '#fff',
        strokeOpacity: 0.8,
        strokeWeight: 10,
        zIndex: -1
      });
    } else if (d != null && Array.isArray(d)) {
      for (let i = 0; i < d.length; i++) {
        let t = d[i];
        if (t && t.p1 && t.p2) {
          this.highlightBisectConns.push(
            new google.maps.Polyline({
              clickable: false,
              map: this.map,
              path: [t.p1, t.p2],
              strokeColor: '#fff',
              strokeOpacity: 0.8,
              strokeWeight: 10,
              zIndex: -1
            })
          );
        }
      }
    }
  }

  promptTaken(e) {
    let time = new Date().getTime();
    this.callActiveFunction(
      null,
      this.findClosest(null, null, { includeReferenceJobs: this.closestIncludesReferenceJobs }),
      this.latitude,
      this.longitude,
      e.detail,
      time
    );
  }

  secondaryPromptTaken() {
    this.callActiveFunction(
      'action_secondary',
      this.findClosest(null, null, { includeReferenceJobs: this.closestIncludesReferenceJobs }),
      this.latitude,
      this.longitude
    );
  }

  tertiaryPromptTaken() {
    this.callActiveFunction(
      'action_tertiary',
      this.findClosest(null, null, { includeReferenceJobs: this.closestIncludesReferenceJobs }),
      this.latitude,
      this.longitude
    );
  }

  confirmCallback(e) {
    this.confirmDialogCallback(e);
    this.$.confirmDialog.close();
  }

  confirmCancelCallback(e) {
    this.confirmDialogCancelCallback(e);
    this.$.confirmDialog.close();
  }

  confirm(e) {
    this.confirmDialogHeading = e.detail.heading || '';
    this.confirmDialogBody = e.detail.body || '';
    this.confirmDialogBodyType = e.detail.bodyType || '';
    this.confirmDialogAffirmativeText = e.detail.affirmativeText || '';
    this.confirmDialogDismissiveText = e.detail.dismissiveText || '';
    this.confirmDialogCallback = e.detail.callback || function () {};
    this.confirmDialogCancelCallback = e.detail.cancelCallback || function () {};
    this.$.confirmDialog.open();
  }

  showPolesCompleted() {
    let completedCollapse = this.shadowRoot.querySelector('#completedCollapse');
    if (completedCollapse && !completedCollapse.opened && this.numPoles) {
      completedCollapse.show();
      setTimeout(() => {
        completedCollapse.hide();
      }, 3000);
    }
  }

  findClosest(latitude, longitude, options) {
    options = options || {};
    options.skipList = options.skipList || [];
    if (this.collectionOrderLogic == null || !this.googleIsReady) return null;
    var closestNode = this.closestNode(latitude, longitude, options);
    var closestSection = this.closestSection(latitude, longitude, options);
    var tolerance = this.collectionOrderLogic.click_radius_in_px;
    var closest = closestNode;
    if (closestSection.distance < closestNode.distance) {
      closest = closestSection;
    }

    if (!options.absoluteClosest && closest.distance < tolerance) {
      return closest;
    }

    var closestConnection = this.closestConnection(latitude, longitude, options);
    if (options.absoluteClosest) {
      if (closestConnection.distance < closest.distance) {
        closest = closestConnection;
      }
      if (closest.distance == Infinity) return null;
      return closest;
    }
    if (closestConnection.distance < tolerance) {
      return closestConnection;
    }
    return null;
  }

  findPixelCoordinate(latLng) {
    let projection = this.$.googlemap.map.getProjection();
    if (projection) {
      var coord = projection.fromLatLngToPoint(latLng);
      return new google.maps.Point(Math.floor(coord.x * this.pixelScale), Math.floor(coord.y * this.pixelScale));
    }
  }

  getItemDistance(clickLatLong, itemLatLong) {
    let clickPixel = this.findPixelCoordinate(clickLatLong);
    let itemPixel = this.findPixelCoordinate(itemLatLong);
    if (clickPixel && itemPixel) {
      let nodeDistanceVector = KatapultGeometry.CalculateVector(clickPixel, itemPixel);
      return KatapultGeometry.VectorNorm(nodeDistanceVector);
    }
  }

  _isAssessmentFilterActive() {
    const logic = this.activeButtonModel?.logic;
    if (this.activeButtonModel?.view !== 'assessment' || !logic) return false;
    return KLogic.isKlogicBlock(logic);
  }

  closestNode(latitude, longitude, options) {
    options = options || {};
    options.skipList = options.skipList || [];
    var closest;
    var distance = Infinity;
    var click = new google.maps.LatLng(latitude || this.latitude, longitude || this.longitude);
    const logic = this.activeButtonModel?.logic;
    const assessmentFilterActive = this._isAssessmentFilterActive();
    // This visiblesNodes object makes sure hidden nodes can't be selected
    let visibleNodes = structuredClone(this.nodes);
    for (const nodeId of this.hiddenNodes) {
      delete visibleNodes[nodeId];
    }
    for (const nodeId in visibleNodes) {
      var nodeType = PickAnAttribute(this.nodes[nodeId].attributes, this.modelDefaults.node_type_attribute);
      if (
        (options.skipGPSMatch && latitude == this.nodes[nodeId].latitude && longitude == this.nodes[nodeId].longitude) ||
        options.skipList.indexOf('n' + nodeId) != -1 ||
        (options.skipDoneItems && this.$.jobTimeCollection.isNodeDone(this.nodes[nodeId].attributes)) ||
        (options.skipNonCollectTypes && this.collectionOrderLogic.node_types_to_skip.indexOf(nodeType) != -1) ||
        (this.activeButton &&
          this.disallowedAttachments != null &&
          this.disallowedAttachments.hasOwnProperty(nodeType) &&
          this.disallowedAttachments[nodeType][this.activeButton])
      ) {
        continue;
      }
      if (assessmentFilterActive && KLogic.compute(logic, { node: this.nodes[nodeId] }) !== true) {
        continue;
      }
      let nodeDistance = this.getItemDistance(click, new google.maps.LatLng(this.nodes[nodeId].latitude, this.nodes[nodeId].longitude));
      if (nodeDistance != null && nodeDistance < distance) {
        closest = nodeId;
        distance = nodeDistance;
      }
    }
    // If we should also check reference jobs, then loop through point locations as well for items not in the current job
    if (options.includeReferenceJobs) {
      for (let pointKey in this.$.loadRenderMap.pointLocations) {
        // Check that the item is not in the current job
        let point = this.$.loadRenderMap.pointLocations[pointKey];
        if (point.jobKey != this.jobid) {
          // Check that the item is a node
          if (SquashNulls(point, 'data', 't') == 'n') {
            // See if the point location is closest
            let pointDistance = this.getItemDistance(click, new google.maps.LatLng(point.data.l[0], point.data.l[1]));
            if (pointDistance != null && pointDistance < distance) {
              closest = pointKey;
              distance = pointDistance;
            }
          }
        }
      }
    }
    return { item: 'n' + closest, distance: distance };
  }

  closestConnection(latitude, longitude, options) {
    options = options || {};
    var closest;
    var distance = Infinity;
    var click = new google.maps.LatLng(latitude || this.latitude, longitude || this.longitude);
    click = this.findPixelCoordinate(click);
    for (var connId in this.connections) {
      if (
        (options.skipDoneItems && this.$.jobTimeCollection.isConnDone(this.connections[connId])) ||
        (options.skipNonCollectTypes &&
          this.collectionOrderLogic.connection_types_to_skip.indexOf(
            PickAnAttribute(this.connections[connId].attributes, this.modelDefaults.connection_type_attribute)
          ) != -1)
      ) {
        continue;
      }
      var n1 = this.nodes[this.connections[connId].node_id_1];
      var n2 = this.nodes[this.connections[connId].node_id_2];
      if (this.connections[connId].breakpoints) {
        let length = Object.keys(this.connections[connId].breakpoints).length;
        let points = [];
        // push first point
        points.push(new google.maps.LatLng(n1.latitude, n1.longitude));
        // push breakpoints
        for (let i = 0; i < length; i++) {
          let point = this.connections[connId].breakpoints[i];
          points.push(new google.maps.LatLng(point[0], point[1]));
        }
        // push last point
        points.push(new google.maps.LatLng(n2.latitude, n2.longitude));
        // loop through points array and check to see if cursor is on this portion of the line
        for (let j = 0; j < points.length; j++) {
          if (points[j + 1]) {
            let item1 = this.findPixelCoordinate(points[j]);
            let item2 = this.findPixelCoordinate(points[j + 1]);
            var pointOnLine = KatapultGeometry.SnapToLineXY(click, item1, item2); // this is in pixels
            var connDistanceVector = KatapultGeometry.CalculateVector(click, pointOnLine);
            var connDistance = KatapultGeometry.VectorNorm(connDistanceVector);
            if (connDistance < distance && (!options.skipGPSMatch || this.activeItem != 'c' + connId)) {
              closest = connId;
              distance = connDistance;
            }
          }
        }
      } else {
        if (n1 != null && n2 != null) {
          var item1 = new google.maps.LatLng(n1.latitude, n1.longitude);
          var item2 = new google.maps.LatLng(n2.latitude, n2.longitude);
          item1 = this.findPixelCoordinate(item1);
          item2 = this.findPixelCoordinate(item2);
          var pointOnLine = KatapultGeometry.SnapToLineXY(click, item1, item2); // this is in pixels
          var connDistanceVector = KatapultGeometry.CalculateVector(click, pointOnLine);
          var connDistance = KatapultGeometry.VectorNorm(connDistanceVector);
          if (connDistance < distance && (!options.skipGPSMatch || this.activeItem != 'c' + connId)) {
            closest = connId;
            distance = connDistance;
          }
        }
      }
    }
    return { item: 'c' + closest, distance: distance };
  }

  closestSection(latitude, longitude, options) {
    options = options || {};
    var closest;
    var distance = Infinity;
    var click = new google.maps.LatLng(latitude || this.latitude, longitude || this.longitude);
    click = this.findPixelCoordinate(click);
    const logic = this.activeButtonModel?.logic;
    const assessmentFilterActive = this._isAssessmentFilterActive();
    for (var connId in this.connections) {
      if (
        options.skipNonCollectTypes &&
        this.collectionOrderLogic.connection_types_to_skip.indexOf(
          PickAnAttribute(this.connections[connId].attributes, this.modelDefaults.connection_type_attribute)
        ) != -1
      ) {
        continue;
      }
      for (var sectionId in this.connections[connId].sections) {
        if (
          (options.skipGPSMatch &&
            latitude == this.connections[connId].sections[sectionId].latitude &&
            longitude == this.connections[connId].sections[sectionId].longitude) ||
          (options.skipDoneItems && this.$.jobTimeCollection.isSectionDone(this.connections[connId].sections[sectionId].multi_attributes))
        ) {
          continue;
        }
        if (assessmentFilterActive && KLogic.compute(logic, { section: this.connections[connId].sections[sectionId] }) !== true) {
          continue;
        }
        var item = new google.maps.LatLng(
          this.connections[connId].sections[sectionId].latitude,
          this.connections[connId].sections[sectionId].longitude
        );
        item = this.findPixelCoordinate(item);
        var sectionDistanceVector = KatapultGeometry.CalculateVector(click, item);
        var sectionDistance = KatapultGeometry.VectorNorm(sectionDistanceVector);
        if (sectionDistance < distance) {
          closest = connId + ':' + sectionId;
          distance = sectionDistance;
        }
      }
    }
    return { item: 's' + closest, distance: distance };
  }

  prompt(event, detail) {
    this.promptText = detail.text;
    if (detail.icon) {
      this.promptIcon = detail.icon;
      this.promptIconColor = detail.color || 'black';
      this.showPromptIcon = true;
    } else {
      this.showPromptIcon = false;
    }
    this.promptOpen = true;
    this.showButtons = true;
    if (detail.cancelSecondary) {
      this.cancelSecondaryPrompt();
    }
    if (detail.cancelTertiary) {
      this.cancelTertiaryPrompt();
    }
    // Remove the GPS options when we do a different prompt
    this.$.moveItem.resetGPSActions();
  }

  menuToggled() {
    setTimeout(() => {
      this.resizeMap();
    }, 400);
  }

  resizeMap() {
    if (typeof google !== 'undefined') {
      let oldLat = this.latitude;
      let oldLong = this.longitude;
      google.maps.event.trigger(this.$.googlemap.map, 'resize');
      if (this.keepMapCenter) {
        this.latitude = oldLat; // restore because resize can move our center
        this.longitude = oldLong;
      }
    }
  }

  cancelPrompt() {
    this.promptOpen = false;
    this.promptText = '';
    if (!this.secondaryPromptOpen && !this.tertiaryPromptOpen) {
      this.showButtons = false;
    }
  }

  secondaryPrompt(event, detail) {
    this.secondaryPromptReopened = true;
    this.secondaryPromptText = detail.text;
    if (detail.icon) {
      this.secondaryPromptIcon = detail.icon;
      this.secondaryPromptIconColor = detail.color || 'black';
      this.showSecondaryPromptIcon = true;
    } else {
      this.showSecondaryPromptIcon = false;
    }
    this.secondaryPromptOpen = true;
    this.showButtons = true;
    if (detail.cancelMain) {
      this.cancelPrompt();
    }
  }

  cancelSecondaryPrompt() {
    this.secondaryPromptOpen = false;
    this.secondaryPromptReopened = false;
    if (!this.promptOpen && !this.tertiaryPromptOpen) {
      this.showButtons = false;
    }
    setTimeout(() => {
      if (!this.secondaryPromptReopened) {
        this.secondaryPromptText = '';
      }
    }, 150);
  }

  tertiaryPrompt(event, detail) {
    this.tertiaryPromptReopened = true;
    this.tertiaryPromptText = detail.text;
    this.tertiaryPromptColor = detail.buttonColor;
    if (detail.icon) {
      this.tertiaryPromptIcon = detail.icon;
      this.tertiaryPromptIconColor = detail.color || 'black';
      this.showTertiaryPromptIcon = true;
    } else {
      this.showTertiaryPromptIcon = false;
    }
    this.tertiaryPromptOpen = true;
    this.showButtons = true;
    if (detail.cancelMain) {
      this.cancelPrompt();
    }
  }

  cancelTertiaryPrompt() {
    this.tertiaryPromptOpen = false;
    this.tertiaryPromptReopened = false;
    if (!this.promptOpen && !this.secondaryPromptOpen) {
      this.showButtons = false;
    }
    setTimeout(() => {
      if (!this.tertiaryPromptReopened) {
        this.tertiaryPromptText = '';
      }
    }, 150);
  }

  pulseItem(e) {
    let item = e.detail;
    if (item != null) {
      let id = item.slice(1);
      const marker = this.$.loadRenderMap.pointLocations[id];
      if (marker) {
        marker.icon = GeoStyleToIcon(marker.data);
        setTimeout(() => {
          marker.icon = GeoStyleToIcon(marker.data, { sizeMultiplier: 0.65 });
        }, 300);
      }
    }
  }

  zoomToActive(e) {
    if (this.activeItem != '') {
      this.ignoreNextZoom = true;
      if (e && e.detail && e.detail.zoom) {
        this.zoom = 18;
        if (this.maptype == 'blank' && navigator.onLine) this.maptype = 'hybrid';
      }
      if (e && e.detail && e.detail.minZoom) {
        if (this.zoom < e.detail.minZoom) {
          this.zoom = e.detail.minZoom;
        }
      }
      let location = this.getActiveItemLocation();
      if (location) {
        this.latitude = location[0];
        this.longitude = location[1];
      }
    }
  }

  getActiveItemLocation() {
    var itemId = this.activeItem.slice(1);
    let latitude = null;
    let longitude = null;
    if (this.activeItem[0] == 'n') {
      // Prefer the marker's actual current position over its last-synced `.data.l` snapshot
      const position = loadRenderMap?.pointLocations?.[itemId]?.position;
      if (position) {
        latitude = position.lat();
        longitude = position.lng();
      } else {
        latitude = loadRenderMap?.pointLocations?.[itemId]?.data?.l?.[0];
        longitude = loadRenderMap?.pointLocations?.[itemId]?.data?.l[1];
      }
    } else if (this.activeItem[0] == 's') {
      var ids = itemId.split(':');
      if (ids.length == 4) {
        latitude = ids[2];
        longitude = ids[3];
      } else {
        var conn = this.connections[ids[0]];
        var section = conn.sections[ids[1]];
        latitude = section?.latitude;
        longitude = section?.longitude;
      }
    } else {
      var lat1 = SquashNulls(this.nodes, SquashNulls(this.connections, itemId, 'node_id_1'), 'latitude');
      var lon1 = SquashNulls(this.nodes, SquashNulls(this.connections, itemId, 'node_id_1'), 'longitude');
      var lat2 = SquashNulls(this.nodes, SquashNulls(this.connections, itemId, 'node_id_2'), 'latitude');
      var lon2 = SquashNulls(this.nodes, SquashNulls(this.connections, itemId, 'node_id_2'), 'longitude');
      var midpoint = this.getMidpointLatLng(new google.maps.LatLng(lat1, lon1), new google.maps.LatLng(lat2, lon2));
      latitude = midpoint.lat();
      longitude = midpoint.lng();
    }
    if (!latitude || !longitude) return null;
    else return [latitude, longitude];
  }

  //google.maps.geometry.spherical.interpolate has a precision error where it only returns an endpoint for small lines. This works at any size.
  getMidpointLatLng(latLng1, latLng2) {
    var projection = this.map.getProjection();
    var n1Point = projection.fromLatLngToPoint(latLng1);
    var n2Point = projection.fromLatLngToPoint(latLng2);
    var midPoint = {
      x: (n1Point.x + n2Point.x) / 2,
      y: (n1Point.y + n2Point.y) / 2
    };
    return projection.fromPointToLatLng(midPoint);
  }

  displayToastMessage(e) {
    this.toast(e.detail.message);
  }

  toast(options) {
    this.toastText = options.text || options;
    if (this.toastTimeout) clearTimeout(this.toastTimeout);
    if (options.button) {
      this.toastButton = true;
      this.toastButtonText = options.buttonText || 'button';
      this.toastButtonCallback = options.buttonCallback;
    } else {
      this.toastButton = false;
    }
    if (options.duration != Infinity) {
      this.toastTimeout = setTimeout(() => {
        this.showToast = false;
      }, options.duration || 3000);
    }
    this.showToast = true;
  }

  toastEvent(e) {
    this.toast(e.detail);
  }

  buttonGroupsLoaded() {
    if (this.buttonGroup == null && this.buttonGroups != null) {
      var priority = Infinity;
      var chosenKey = null;
      for (var key in this.buttonGroups) {
        if (this.buttonGroups[key]._priority < priority) {
          priority = this.buttonGroups[key]._priority;
          chosenKey = key;
        }
      }
      this.buttonGroup = chosenKey;
    }
  }

  getMapButtons(buttonGroups, mappingButtons, buttonGroup, sandboxButton) {
    if (sandboxButton && mappingButtons && mappingButtons[sandboxButton]) {
      this.setDefaultTool();
      return [{ ...mappingButtons[sandboxButton], id: sandboxButton }];
    }
    if (!buttonGroups || !mappingButtons) return;
    var buttons = [];
    for (var buttonName in buttonGroups[buttonGroup]) {
      // Only include the buttons if they:
      //   don't start with _
      //   don't have a function to run
      //   have data for inserting a section, node, or connection
      //   You do not have the mobile_assessments role OR the button is of type assessment
      //   Have an endpoint_url property for a web tool
      if (
        !this.readOnlyUser &&
        buttonName[0] != '_' &&
        mappingButtons[buttonName] &&
        ((mappingButtons[buttonName].function == null &&
          (!this.get('userHasMobileAssessmentsRole') || mappingButtons[buttonName].view == 'assessment') &&
          (mappingButtons[buttonName].section != null ||
            mappingButtons[buttonName].node != null ||
            mappingButtons[buttonName].connection != null)) ||
          (mappingButtons[buttonName].mobile_function && mappingButtons[buttonName].function != null) ||
          mappingButtons[buttonName].allow_mobile == true ||
          mappingButtons[buttonName]?.endpoint_url)
      ) {
        // if (!mappingButtons[buttonName].node.open_for_editing && (mappingButtons[buttonName].connection == null || !mappingButtons[buttonName].connection.open_for_editing)) {
        mappingButtons[buttonName].priority = buttonGroups[buttonGroup][buttonName].priority;
        mappingButtons[buttonName].id = buttonName;
        buttons.push(mappingButtons[buttonName]);
        // }
      }
    }
    buttons.sort(function (a, b) {
      return a.priority - b.priority;
    });
    var firstButton = null;
    for (var i = 0; i < buttons.length; i++) {
      if (buttons[i].function == null) {
        firstButton = buttons[i].id;
        break;
      }
    }
    if (firstButton != null) {
      this.defaultButton = firstButton;
      this.defaultTool = 'drawOnMap';
    } else {
      this.defaultButton = null;
      this.defaultTool = 'editAttributes';
    }
    if (this.nodesAreLoaded && this.collectionLogicIsLoaded) {
      this.setDefaultTool();
    }
    return buttons;
  }

  setDefaultTool() {
    if (this.activeTool == null) {
      // If there's a sandbox button, use that by default
      if (this.sandbox && this.sandbox.button) {
        this.activeTool = 'drawOnMap';
        this.activeButton = this.sandbox.button;
        this.setToolColor();
        // Otherwise, follow this logic
      } else if (this.nodes) {
        this.activeButton = null;
        if (this.gotTimeSync) {
          this.timeSyncClosed();
        } else {
          this.startCollectionTime = true;
        }
        this.keepMapCenter = true;
        if (this.get('userHasMobileAssessmentsRole')) {
          let firstAssessmentButton = null;
          if (this.buttonGroups && this.buttonGroup && this.buttonGroups[this.buttonGroup] && this.mappingButtons) {
            let buttonGroup = this.buttonGroups[this.buttonGroup];
            let buttonKeys = Object.keys(buttonGroup).sort((a, b) => buttonGroup[a] - buttonGroup[b]);
            firstAssessmentButton = buttonKeys.find((key) => {
              let button = this.mappingButtons[key];
              if (button && button.view == 'assessment') return key;
            });
          }
          if (firstAssessmentButton) {
            this.activeTool = 'drawOnMap';
            this.activeButton = firstAssessmentButton;
            this.setToolColor();
          } else {
            this.activeTool = 'navigateToLocation';
            this.activeButton = null;
          }
        } else if (this.readOnlyUser) {
          this.activeTool = 'editAttributes';
        } else {
          this.activeTool = 'jobTimeCollection';
        }
      } else {
        this.activeButton = this.defaultButton;
        if (this.activeButton != null) {
          this.setToolColor();
        }
        this.activeTool = this.defaultTool;
      }
    }
  }

  camelCase(a) {
    return CamelCase(a);
  }

  objectKeys(obj) {
    if (obj == null) {
      return obj;
    } else {
      var keys = Object.keys(obj);
      keys.sort(function (a, b) {
        return obj[a].priority - obj[b].priority;
      });
      return keys;
    }
  }

  getLabelAttributeKeys(attrs) {
    // check to ensure attrs is an object
    if (attrs == null || typeof attrs != 'object') return [];

    let temp = [];
    for (let key in attrs) {
      let allowedTypes = attrs[key].attribute_types;
      // only add the attribute if it belongs on a node, connection, or section
      if (Array.isArray(allowedTypes) && allowedTypes.some((x) => ['node', 'connection', 'section'].includes(x)) == true) temp.push(key);
    }
    return temp;
  }

  toggleDrawer(e, d) {
    var name = e.srcElement.getAttribute('name');
    if (this.$[name] != null) {
      this.$[name].toggle();
    } else {
      var drawer = dom(this.shadowRoot).querySelector('#' + name);
      if (drawer != null) {
        drawer.toggle();
      }
    }
  }

  assessmentPhotosTaken(event) {
    // Calls doneCollection to close the timebucket when a photo has been taken from an assessment prompt
    this.$.jobTimeCollection.doneCollection(false, this.latitude, this.longitude, null, event.detail.time, null, event.detail);
  }

  markDoneClicked(event) {
    const time = Date.now();
    this.$.jobTimeCollection.doneCollection(false, this.latitude, this.longitude, null, time, null, event.detail);
  }

  zoomToJob() {
    if (this.shouldZoomToJob && this.nodesAreLoaded && this.googleIsReady) {
      this.shouldZoomToJob = false;
      let latLngBounds = new google.maps.LatLngBounds();
      let count = 0;
      for (let nodeId in this.nodes) {
        if (this.nodes[nodeId].latitude && this.nodes[nodeId].longitude) {
          count++;
          latLngBounds.extend(new google.maps.LatLng(this.nodes[nodeId].latitude, this.nodes[nodeId].longitude));
        }
      }
      // For one marker, set the zoom a default amount
      if (count == 1) {
        this.map.setCenter(latLngBounds.getCenter());
        this.zoom = 18;
      } else if (count > 1) {
        this.map.fitBounds(latLngBounds);
        this.map.setCenter(latLngBounds.getCenter());
      }
    }
  }

  /**
   *   refresh the state of the layers (which tracks if its toggled) when the geoJsonLayers, mapLayers, or multiJobIds change
   */
  refreshAllLayerItemStates() {
    this.$.mapLayersMenuView?.refreshStateForAllLayerItems();
  }

  mapLayersChanged() {
    if (this.settingsLoadedFromSession && !this.geoJsonToggled && Object.values(this.mapLayers ?? {}).length != 0) {
      // Toggle the relevant map layers on here (they haven't been toggled on yet because they didn't exist in the ready() function)
      let val = JSON.parse(sessionStorage.getItem('mobileMaps:geoJsonLayers'));
      if (val != null) {
        this.applySetting('geoJsonLayers', val);
        this.geoJsonToggled = true;
      }
    }

    // Filter out utility reference layers if the user does not have permission to view them
    const temp = Object.entries(this.mapLayers ?? {})
      .map(([key, layer]) => {
        return {
          key,
          ...layer
        };
      })
      .filter((layer) => {
        return CompanyHasAccessToUtilityLayer(
          layer,
          globalThis.config?.firebaseData?.utilityCompany,
          katapultAuth.userGroup,
          this.isReviewContractor
        );
      });

    if (temp.length != 0) {
      this.geoJsonLayers.forEach((layer, index) => {
        let key = layer.key;
        if (key) {
          let foundKey = false;
          for (let i = 0; i < temp.length; i++) {
            if (temp[i].key == key) {
              foundKey = true;
              break;
            }
          }
          // If we didn't find the key, them remove the geoJson
          if (foundKey == false) {
            for (let i = 0; i < this.geoJsonLayers?.[index]?.features?.length; i++) {
              this.map.data.remove(this.geoJsonLayers?.[index]?.features[i]);
            }
            this.splice('geoJsonLayers', index, 1);
            this.geoJsonLayersChange = !this.geoJsonLayersChange;
          }
        }
      });
    }

    temp.sort((a, b) => a.order - b.order);

    this.set('filteredMapLayers', temp);

    // Re-render any cached image overlays so layer data edits are reflected even when already toggled on
    const imageOverlayLayers = temp.filter((layer) => layer.type === 'Overlay Layer');
    this.refreshImageOverlays(imageOverlayLayers);
  }

  /**
   * Updates each cached image overlay with the latest bounds and options from its matching layer data.
   * @param {object[]} imageOverlayLayers - The current set of image overlay layers
   */
  refreshImageOverlays(imageOverlayLayers) {
    for (const layer of imageOverlayLayers) {
      // Skip layers that don't have a cached overlay yet or are missing bounds
      const overlay = this.loadedImageOverlays[layer.key];
      if (!overlay || !layer.options?.bounds) continue;

      // Update the cached overlay with the latest bounds and options
      const { rotation, relative_anchor_x, relative_anchor_y, opacity, bounds } = layer.options;
      overlay.redrawWithUpdates(bounds, { rotation, relative_anchor_x, relative_anchor_y, opacity });
    }
  }

  removeGeoJsonLayerFromMap(layerKey) {
    let keysToRemove = [layerKey];
    if (layerKey == 'all') {
      keysToRemove = this.geoJsonLayers?.map((x) => x.key) || [];
    }
    keysToRemove.forEach((removeLayerKey) => {
      let currIndex = 0;
      while (currIndex != this.geoJsonLayers.length) {
        let geoJsonLayer = this.geoJsonLayers[currIndex];
        let geoJsonLayerKey = geoJsonLayer.key;
        if (geoJsonLayerKey == removeLayerKey) {
          // remove the features from the map then remove the geoJsonLayer
          for (let i = 0; i < this.geoJsonLayers?.[currIndex]?.features?.length; i++) {
            this.map.data.remove(this.geoJsonLayers[currIndex].features[i]);
          }
          this.splice('geoJsonLayers', currIndex, 1);
        } else currIndex++;
      }
    });
  }

  jobLayersChanged() {
    let newArray = [];
    for (let key in this.jobLayers) {
      // Check if the job layer is not null
      if (this.jobLayers[key]) {
        let layerObjectCopy = JSON.parse(JSON.stringify(this.jobLayers[key]));
        layerObjectCopy['$key'] = key;
        newArray.push(layerObjectCopy);
      }
    }
    this.set('jobLayersArray', newArray);
  }

  userGroupChanged() {
    this.turnOnCompanyLayers();
  }

  // NOTE: There is a timing issue that is preventing this from running properly; the google map is not ready when this function is called
  turnOnCompanyLayers() {
    const companyIsAllowed = ['katapult', 'davey_resource_group'].includes(this.userGroup);
    if (!companyIsAllowed || !this.googleIsReady) return;

    setTimeout(() => {
      for (const key in this.filteredMapLayers) {
        if (!['app_pa_state_roads', 'pa_state_roads'].includes(key)) continue;
        this.toggleMapLayer({ key }, true);
      }
    });
  }

  /**
   * Used to determine whether to toggle a layer group or single layer
   * @param {object} e - Event details for the triggering element
   */
  async toggleMapLayerItem(e) {
    const checked = e.detail?.checked;
    const toggledMapLayerItem = e.detail?.item;
    if (checked == null || toggledMapLayerItem == null) return;

    // if the layer item has grouped layer, it's a layer group, toggle all of the layers
    const groupedLayers = toggledMapLayerItem.groupedLayers;
    if (groupedLayers) {
      for (const layer of groupedLayers) {
        this.toggleMapLayer(layer, checked);
      }
    } else this.toggleMapLayer(toggledMapLayerItem, checked);
  }

  /**
   * Togggle a given map layer based on the checked value and the layer type
   * @param {object} selectedMapLayer - The selected map layer to toggle
   * @param {boolean} checked - Whether the layer should be turned on or off
   */
  toggleMapLayer(selectedMapLayer, checked) {
    if (!selectedMapLayer || !this.jobid || checked == null) return;

    if (
      !CompanyHasAccessToUtilityLayer(
        selectedMapLayer,
        globalThis.config?.firebaseData?.utilityCompany,
        katapultAuth.userGroup,
        this.isReviewContractor
      )
    )
      return;

    // Check if the selected layer is an API Layer
    if (selectedMapLayer.type == 'API Layer') {
      if (checked) {
        // Turn on the layer and make it unselectable (since that will be handled via the refSelect function)
        this.set('apiMapLayers.' + selectedMapLayer.key, { selectable: false, ...selectedMapLayer });
      } else {
        this.set('apiMapLayers.' + selectedMapLayer.key, null);
      }
    } else if (selectedMapLayer.type == 'Overlay Layer') {
      const mapLayerKey = selectedMapLayer.key;
      const currentOverlay = this.loadedImageOverlays[mapLayerKey];

      // Remove the old overlay if it exists
      if (currentOverlay) {
        if (currentOverlay.existingBlobUrl) URL.revokeObjectURL(currentOverlay.existingBlobUrl);
        // Remove the overlay from the map
        currentOverlay.setMap(null);
        // Clear the overlay from the loadedImageOverlays object
        delete this.loadedImageOverlays[mapLayerKey];
      }

      // If checked is true, add the new overlay
      if (checked) {
        const { rotation, relative_anchor_x, relative_anchor_y, opacity, bounds } = selectedMapLayer.options ?? {};
        const overlayOptions = { rotation, relative_anchor_x, relative_anchor_y, opacity };
        // Pull the image url from the cache and use that instead
        getFile('image_overlays', `${this.jobid}-${mapLayerKey}`).then((layerBlob) => {
          const blobUrl = URL.createObjectURL(layerBlob);
          const overlay = createCustomImageOverlay(blobUrl, bounds, overlayOptions);
          overlay.existingBlobUrl = blobUrl;
          this.loadedImageOverlays[mapLayerKey] = overlay;
          overlay.setMap(this.map);
        });
      }
    } else {
      // NOTE: We are not using the `getLayer` function from JobLayer.js here. For offline purposes, in FirebaseWebWorker.js, we pull
      // the data for any layers from Cloud Storage and store them in IndexedDB. This means that a normal FirebaseWorker call will
      // properly get the data for the layer.
      FirebaseWorker.ref('photoheight/jobs/' + this.jobid + '/layers/data/' + selectedMapLayer.key).once('value', (response) => {
        const layer = response.val();
        if (layer?.features) {
          if (checked) {
            // turning on the layer means adding it to the geoJsonLayers.  If it's already added, we don't want to add it again
            let layerAlreadyAdded = this.geoJsonLayers.find((x) => x.key == selectedMapLayer.key);
            if (!layerAlreadyAdded) {
              const addedLayer = this.map.data.addGeoJson(layer);
              this.push('geoJsonLayers', {
                key: selectedMapLayer.key,
                features: addedLayer
              });
            }
          } else {
            this.removeGeoJsonLayerFromMap(selectedMapLayer.key);
          }
        }
      });
    }
  }

  toggleAllMapLayers(e) {
    this.filteredMapLayers.forEach((layer) => {
      this.toggleMapLayer(layer, true);
    });
  }

  clickedToggleReferenceJobLayer(e) {
    let checked = SquashNulls(e, 'checked') || SquashNulls(e, 'currentTarget', 'checked') || false;
    let jobId = SquashNulls(e, 'model', 'item', '$key');
    if (jobId) {
      this.toggleReferenceJobLayer(jobId, checked);
    }
  }

  openJobLayersDialog() {
    this.closeSidePanel();
    this.$.addJobLayerDialog.open();
  }

  async jobLayerSelectedChanged(e) {
    let currentTarget = e.currentTarget;
    let selectedJobId = SquashNulls(e, 'detail', 'value');
    if (selectedJobId) {
      this.$.addJobLayerDialog.close();
      if (selectedJobId == this.jobid) {
        this.toast(`${this.jobName} is already the active job.`);
      } else {
        let success = await this.addReferenceJobLayer(selectedJobId);
        if (success) {
          this.toggleReferenceJobLayer(selectedJobId, true);
          this.toast(`Job layer turned on`);
          if (currentTarget) {
            currentTarget.$.dropdown.clear();
          }
        }
      }
    }
  }

  async openAddLabelsDialog() {
    this.closeSidePanel();

    const attributeSelectedForLabel = async (e) => {
      const attribute = e?.detail?.selectedItem;
      if (!attribute) return;
      this.set(`nodeLabels.${attribute}`, true);
      dialog.opened = false;
    };

    const dialog = KatapultDialog.open({
      dialog: {
        title: 'Add A Label',
        icon: 'label'
      },
      template: () => litHtml`
        <div>
          <p>Choose an attribute from the list to add as a label on the map.</p>
          <katapult-drop-down
            id="addLabelAttributeDropDown"
            label="Select an Attribute"
            .items=${this.getLabelAttributeKeys(this.otherAttributes)}
            .labelfunction=${this.camelCase}
            value-path="$key"
            value="item.attribute"
            @selected-changed=${(e) => attributeSelectedForLabel(e)}
            no-label-float
          ></katapult-drop-down>
        </div>
        <katapult-button slot="buttons" @click=${() => (dialog.opened = false)}>Cancel</katapult-button>
      `
    });
  }

  clickedToggleLabel(e) {
    // id="l{{item.\$key}}"
    let attribute = SquashNulls(e, 'model', 'item');
    let checked = SquashNulls(e, 'checked') || SquashNulls(e, 'currentTarget', 'checked') || false;
    if (attribute) {
      this.set(`nodeLabels.${attribute}`, checked);
    }
  }

  labelIsOn(attribute) {
    return this.nodeLabels[attribute] === true;
  }

  setDefaultLabels() {
    // Get default labels.
    const defaultLabels = this.modelConfig?.default_labels ?? {};
    // Return if no default labels.
    if (Object.keys(defaultLabels).length == 0) return;
    // Get session labels.
    const sessionLabels = JSON.parse(sessionStorage.getItem('mobileMaps:nodeLabels'));
    // If session labels don't exist yet, set node labels to be the default labels.
    if (Object.keys(sessionLabels ?? {}).length == 0) {
      this.nodeLabels = defaultLabels;
    }
  }

  closeSidePanel(e) {
    this.shadowRoot.querySelector('login-chip')?.closeMenu();
    this.$.helpDrawerMenu.close();

    // If the side panel isn't already closed, close it
    if (this.showSidePanel) this.showSidePanel = false;
  }

  toggleShowSidePanel(e) {
    e.preventDefault();
    e.stopPropagation();
    this.showSidePanel = !this.showSidePanel;

    if (this.showSidePanel) {
      let copyright = this.$.googlemap.$.map.querySelector('.gmnoscreen div');
      if (copyright) this.googleCopyrightText = copyright.innerText;
    } else {
      this.closeSidePanel();
      this.ignoreSidePanelTrack = true;
      setTimeout(() => (this.ignoreSidePanelTrack = false), 300);
    }
  }

  openBugFeedback() {
    this.closeSidePanel();
    if (this.get('user.email')) this.yourName = this.user.email;
    this.$.bugFeedbackDialog.open();
  }

  clearBugFeedback() {
    this.$.bugFeedbackDialog.close();
    this.bugSubject = '';
    this.bugEncountered = '';
    this.yourName = '';
    this.sendToMe = false;
    this.$.bugDescription.invalid = false;
    this.$.yourName.invalid = false;
    this.$.bugSubject.invalid = false;
    this.submitting = false;
    this.submittedFeedback = false;
    this.submittedError = '';
  }

  async openTrainingPage() {
    const { OpenPage } = await import('../../modules/OpenPage.js');
    OpenPage('help/', { target: '_blank' });
  }

  submitBugFeedback() {
    this.$.bugDescription.invalid = false;
    this.$.yourName.invalid = false;
    this.$.bugSubject.invalid = false;

    if (!this.bugEncountered) {
      this.$.bugDescription.invalid = true;
    } else if (!this.yourName) {
      this.$.yourName.invalid = true;
    } else if (!this.bugSubject) {
      this.$.bugSubject.invalid = true;
    } else {
      var to = ['katapultpro-bugs@katapultengineering.com'];
      // Send a copy to the user (if desired) via CC
      if (this.sendToMe && this.user.email) to.push({ type: 'cc', email: this.user.email });

      this.submitting = true;

      var requestKey = FirebaseWorker.ref('/photoheight/server_requests/email/requests').push({
        addresses: to,
        subject: this.bugSubject || 'Software Bug Feedback',
        body: `What went wrong:\n${this.bugEncountered}\n\nSubmitted by: ${this.yourName}\n(${this.user.email})\n\nLink to buggy page: ${window.location.href}`,
        group_tag: 'internal'
      }).key;
      FirebaseWorker.ref(`/photoheight/server_requests/email/responses/${requestKey}`).on('value', (snapshot) => {
        var t = snapshot.val();
        if (t) {
          this.submitting = false;
          this.submittedFeedback = true;
          if (!t.success) {
            this.submittedError = t.message || 'There was an issue submiting your feedback.';
          }
          snapshot.ref.remove();
        }
      });
    }
  }

  toolMouseDown(e) {
    if (this.longPressToolTimer) {
      clearTimeout(this.longPressToolTimer);
      this.longPressToolTimer = null;
    }
    var tool = e.currentTarget.getAttribute('name');
    var buttonName = e.currentTarget.getAttribute('data-button');
    this.longPressToolTimer = setTimeout(() => {
      this.editingFavoriteTools = true;
      this.toggleFavoriteTool(tool, buttonName, true);
    }, 1000);
  }

  toolMouseUp() {
    if (this.longPressToolTimer) {
      clearTimeout(this.longPressToolTimer);
      this.longPressToolTimer = null;
    }
  }

  zoomControlClick(e) {
    if (e.currentTarget.icon === 'add' && this.$.googlemap.zoom < this.$.googlemap.maxZoom) this.$.googlemap.zoom++;
    else if (e.currentTarget.icon === 'remove' && this.$.googlemap.zoom > this.$.googlemap.minZoom) this.$.googlemap.zoom--;
  }

  ////
  //// BEGIN CUSTOM ACTIONS
  //// Below are custom actions that can be called after marking
  //// and item as "done" if it's set up in the models under
  //// config/mobile/onDoneCollection
  ////
  checkForAndRunDoneCollectionTasks(e) {
    if (e && e.detail && e.detail) {
      // Check if there is a function listed in the config that we should run
      // when marking the item as done
      let runFunction = SquashNulls(this.modelConfig, 'onDoneCollection', 'runFunction');
      if (this[runFunction]) {
        this[runFunction].call(this, e.detail);
      } else {
        this.fire('There is an issue with your mobile models. Please contact support for help.');
      }
    }
  }
  getJobModels(type, editingItemJob, job_id) {
    var jobCreator = SquashNulls(this.multiJobIds, editingItemJob, 'data', 'jobCreator');
    if (editingItemJob == job_id || jobCreator == this.jobCreator) {
      return this[type];
    } else {
      return SquashNulls(this.companyModels, jobCreator, type, 'value') || null;
    }
  }

  // This function is used with a custom workflow for DRG
  // Sets a date in the post_inspection_date attribute on the item
  ////
  //// END CUSTOM ACTIONS
  ////
  setPostInspectionDate(activeItem) {
    if (activeItem && this.jobid) {
      // Default the path to an empty string so we can check if we were able to find a valid path
      let pathToExistingAttributes = '';
      // Get the type of the active item (first letter in the string)
      let itemType = activeItem[0];
      // Check the item type and set the paths accordingly
      if (itemType == 'n') {
        let nodeId = activeItem.slice(1);
        pathToExistingAttributes = `nodes/${nodeId}/attributes`;
      } else if (itemType == 'c') {
        let connId = activeItem.slice(1);
        pathToExistingAttributes = `connections/${connId}/attributes`;
      } else if (itemType == 's') {
        let connId = activeItem.slice(1).split(':')[0];
        let sectionId = activeItem.slice(1).split(':')[1];
        if (connId && sectionId) {
          pathToExistingAttributes = `connections/${connId}/sections/${sectionId}/multi_attributes`;
        }
      }
      // Check if we have a path
      if (pathToExistingAttributes) {
        // Replace all / with . and then use the get function to get the existing attribute
        let existingAttribute = this.get(`${pathToExistingAttributes.replace(/\//g, '.')}.post_inspection_date`);

        // Create an update object
        let attributeUpdate = {};
        // Loop through all of the keys in the existing object to null
        // to remove all instances of the attribute
        for (let key in existingAttribute) {
          attributeUpdate[key] = null;
        }
        // Then set a new value for the attribute under the 'value' key
        // Create a date stamp
        let now = new Date();
        let dateStamp = `${now.getMonth() + 1}/${now.getDate()}/${now.getFullYear()}`;
        attributeUpdate['value'] = dateStamp;

        // Set the date for the post_inspection_date
        FirebaseWorker.ref(`photoheight/jobs/${this.jobid}/${pathToExistingAttributes}/post_inspection_date`).update(attributeUpdate);
      }
    }
  }
  notifyNewVersion() {
    this.isNewVersion = true;
  }
  openReleaseNotes() {
    this.$.releaseNotes.open();
    this.isNewVersion = false;
  }
  gpsCircleConfigChanged(e) {
    this.gpsCircleConfig = e.detail.value;
  }
  getCopyrightYear() {
    return new Date().getFullYear();
  }

  takePhoto() {
    // Create a file input element
    const photoUploadFileInput = document.createElement('input');

    // Set the proper attributes on the file input
    Object.assign(photoUploadFileInput, {
      type: 'file',
      accept: 'image/jpeg',
      capture: 'environment'
    });

    // Remove the file input element when the user cancels the file picker
    photoUploadFileInput.addEventListener('cancel', () => {
      photoUploadFileInput.remove();
    });

    // Set up a listener to upload the photo once it's taken and selected, then remove the file input element
    photoUploadFileInput.addEventListener('change', () => {
      // Get the files from the file input.
      const filesArray = photoUploadFileInput.files ? Array.from(photoUploadFileInput.files) : [];
      // The input can now be removed from the DOM.
      photoUploadFileInput.remove();
      // If no files were selected, exit early.
      if (!filesArray.length) return;
      // Otherwise, upload the selected photos.
      this.uploadPhotos(filesArray).catch((error) => {
        console.error('Failed to upload one or more selected photos.', error);
        showPhotoUploadErrorToast(error);
      });
    });

    // Click before appending to the DOM — iOS Safari blocks .click() on file inputs already in the DOM.
    photoUploadFileInput.click();

    // Hide and append to the DOM so the browser keeps a reference and reliably fires the change event.
    // Change event may not fire reliably on iOS Safari unless the input is in the DOM.
    photoUploadFileInput.style.display = 'none';
    document.body.appendChild(photoUploadFileInput);
  }

  /**
   *
   * @param {File[]} files
   * @returns
   */
  async uploadPhotos(files) {
    if (files.length == 0) return;

    const photoCaptureTarget = this.photoCaptureTarget ?? '';

    const selectedItemIsNode = photoCaptureTarget[0] == 'n';
    const selectedItemIsSection = photoCaptureTarget[0] == 's';
    const association = {};

    if (selectedItemIsNode) {
      association.nodeId = photoCaptureTarget.slice(1);
    } else if (selectedItemIsSection) {
      const [connectionId, sectionId] = photoCaptureTarget.slice(1).split(':');
      association.connectionId = connectionId;
      association.sectionId = sectionId;
    } else {
      this.toast('Cannot upload photo.  No node or section selected.');
      return;
    }

    // Upload each photo in parallel, then remove the file input element
    await Parallel.forEach(files, async (file) => {
      await uploadPhoto(file, this.jobid, { association }).catch((error) => {
        console.error('Failed to add photo to the upload queue.', error);
        showPhotoUploadErrorToast(error);
      });
    });
  }

  getHideGPSButtonPointerEvents() {
    return this.centerMapOnGPS ? 'none' : 'auto';
  }
}

customElements.define('katapult-maps-mobile', KatapultMapsMobile);
